// Original index.js has only one edit, search for Storyside with a console log

!(function () {
  var e =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof self
        ? self
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : {},
    t = {},
    n = {},
    i = e.parcelRequire3852;
  function a(e, t, n) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function r(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
        i = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols &&
        (i = i.concat(
          Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })
        )),
        i.forEach(function (t) {
          a(e, t, n[t]);
        });
    }
    return e;
  }
  function o(e, t) {
    return (
      (t = null != t ? t : {}),
      Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : (function (e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);
              t &&
                (i = i.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, i);
            }
            return n;
          })(Object(t)).forEach(function (n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
          }),
      e
    );
  }
  null == i &&
    (((i = function (e) {
      if (e in t) return t[e].exports;
      if (e in n) {
        var i = n[e];
        delete n[e];
        var a = { id: e, exports: {} };
        return (t[e] = a), i.call(a.exports, a, a.exports), a.exports;
      }
      var r = new Error("Cannot find module '" + e + "'");
      throw ((r.code = "MODULE_NOT_FOUND"), r);
    }).register = function (e, t) {
      n[e] = t;
    }),
    (e.parcelRequire3852 = i)),
    i.register("gCGxJ", function (e, t) {
      var n, i;
      (n = "undefined" != typeof window ? window : {}),
        (i = (function (e, t, n) {
          "use strict";
          var i, a;
          if (
            ((function () {
              var t,
                n = {
                  lazyClass: "lazyload",
                  loadedClass: "lazyloaded",
                  loadingClass: "lazyloading",
                  preloadClass: "lazypreload",
                  errorClass: "lazyerror",
                  autosizesClass: "lazyautosizes",
                  fastLoadedClass: "ls-is-cached",
                  iframeLoadMode: 0,
                  srcAttr: "data-src",
                  srcsetAttr: "data-srcset",
                  sizesAttr: "data-sizes",
                  minSize: 40,
                  customMedia: {},
                  init: !0,
                  expFactor: 1.5,
                  hFac: 0.8,
                  loadMode: 2,
                  loadHidden: !0,
                  ricTimeout: 0,
                  throttleDelay: 125,
                };
              for (t in ((a = e.lazySizesConfig || e.lazysizesConfig || {}), n))
                t in a || (a[t] = n[t]);
            })(),
            !t || !t.getElementsByClassName)
          )
            return { init: function () {}, cfg: a, noSupport: !0 };
          var r,
            o,
            s,
            c,
            l,
            u,
            d,
            h,
            f,
            v,
            p,
            m,
            y,
            g,
            b,
            _,
            k,
            w,
            S,
            C,
            E,
            x,
            L,
            I,
            T,
            A,
            D,
            P,
            M,
            B,
            q,
            O,
            R,
            N,
            F,
            V,
            z,
            H,
            U,
            K,
            W,
            j,
            Y,
            X,
            Q,
            G = t.documentElement,
            Z = e.HTMLPictureElement,
            J = "addEventListener",
            $ = "getAttribute",
            ee = e[J].bind(e),
            te = e.setTimeout,
            ne = e.requestAnimationFrame || te,
            ie = e.requestIdleCallback,
            ae = /^picture$/i,
            re = ["load", "error", "lazyincluded", "_lazyloaded"],
            oe = {},
            se = Array.prototype.forEach,
            ce = function (e, t) {
              return (
                oe[t] || (oe[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
                oe[t].test(e[$]("class") || "") && oe[t]
              );
            },
            le = function (e, t) {
              ce(e, t) ||
                e.setAttribute("class", (e[$]("class") || "").trim() + " " + t);
            },
            ue = function (e, t) {
              var n;
              (n = ce(e, t)) &&
                e.setAttribute("class", (e[$]("class") || "").replace(n, " "));
            },
            de = function (e, t, n) {
              var i = n ? J : "removeEventListener";
              n && de(e, t),
                re.forEach(function (n) {
                  e[i](n, t);
                });
            },
            he = function (e, n, a, r, o) {
              var s = t.createEvent("Event");
              return (
                a || (a = {}),
                (a.instance = i),
                s.initEvent(n, !r, !o),
                (s.detail = a),
                e.dispatchEvent(s),
                s
              );
            },
            fe = function (t, n) {
              var i;
              !Z && (i = e.picturefill || a.pf)
                ? (n &&
                    n.src &&
                    !t[$]("srcset") &&
                    t.setAttribute("srcset", n.src),
                  i({ reevaluate: !0, elements: [t] }))
                : n && n.src && (t.src = n.src);
            },
            ve = function (e, t) {
              return (getComputedStyle(e, null) || {})[t];
            },
            pe = function (e, t, n) {
              for (
                n = n || e.offsetWidth;
                n < a.minSize && t && !e._lazysizesWidth;

              )
                (n = t.offsetWidth), (t = t.parentNode);
              return n;
            },
            me =
              ((j = []),
              (Y = W = []),
              (X = function () {
                var e = Y;
                for (Y = W.length ? j : W, U = !0, K = !1; e.length; )
                  e.shift()();
                U = !1;
              }),
              (Q = function (e, n) {
                U && !n
                  ? e.apply(this, arguments)
                  : (Y.push(e), K || ((K = !0), (t.hidden ? te : ne)(X)));
              }),
              (Q._lsFlush = X),
              Q),
            ye = function (e, t) {
              return t
                ? function () {
                    me(e);
                  }
                : function () {
                    var t = this,
                      n = arguments;
                    me(function () {
                      e.apply(t, n);
                    });
                  };
            },
            ge = function (e) {
              var t,
                i = 0,
                r = a.throttleDelay,
                o = a.ricTimeout,
                s = function () {
                  (t = !1), (i = n.now()), e();
                },
                c =
                  ie && o > 49
                    ? function () {
                        ie(s, { timeout: o }),
                          o !== a.ricTimeout && (o = a.ricTimeout);
                      }
                    : ye(function () {
                        te(s);
                      }, !0);
              return function (e) {
                var a;
                (e = !0 === e) && (o = 33),
                  t ||
                    ((t = !0),
                    (a = r - (n.now() - i)) < 0 && (a = 0),
                    e || a < 9 ? c() : te(c, a));
              };
            },
            be = function (e) {
              var t,
                i,
                a = 99,
                r = function () {
                  (t = null), e();
                },
                o = function () {
                  var e = n.now() - i;
                  e < a ? te(o, a - e) : (ie || r)(r);
                };
              return function () {
                (i = n.now()), t || (t = te(o, a));
              };
            },
            _e =
              ((k = /^img$/i),
              (w = /^iframe$/i),
              (S =
                "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent)),
              (C = 0),
              (E = 0),
              (x = 0),
              (L = -1),
              (I = function (e) {
                x--, (!e || x < 0 || !e.target) && (x = 0);
              }),
              (T = function (e) {
                return (
                  null == _ && (_ = "hidden" == ve(t.body, "visibility")),
                  _ ||
                    !(
                      "hidden" == ve(e.parentNode, "visibility") &&
                      "hidden" == ve(e, "visibility")
                    )
                );
              }),
              (A = function (e, n) {
                var i,
                  a = e,
                  r = T(e);
                for (
                  m -= n, b += n, y -= n, g += n;
                  r && (a = a.offsetParent) && a != t.body && a != G;

                )
                  (r = (ve(a, "opacity") || 1) > 0) &&
                    "visible" != ve(a, "overflow") &&
                    ((i = a.getBoundingClientRect()),
                    (r =
                      g > i.left &&
                      y < i.right &&
                      b > i.top - 1 &&
                      m < i.bottom + 1));
                return r;
              }),
              (P = ge(
                (D = function () {
                  var e,
                    n,
                    r,
                    o,
                    s,
                    c,
                    d,
                    f,
                    k,
                    w,
                    I,
                    D,
                    P = i.elements;
                  if ((h = a.loadMode) && x < 8 && (e = P.length)) {
                    for (n = 0, L++; n < e; n++)
                      if (P[n] && !P[n]._lazyRace)
                        if (
                          !S ||
                          (i.prematureUnveil && i.prematureUnveil(P[n]))
                        )
                          F(P[n]);
                        else if (
                          (((f = P[n][$]("data-expand")) && (c = 1 * f)) ||
                            (c = E),
                          w ||
                            ((w =
                              !a.expand || a.expand < 1
                                ? G.clientHeight > 500 && G.clientWidth > 500
                                  ? 500
                                  : 370
                                : a.expand),
                            (i._defEx = w),
                            (I = w * a.expFactor),
                            (D = a.hFac),
                            (_ = null),
                            E < I && x < 1 && L > 2 && h > 2 && !t.hidden
                              ? ((E = I), (L = 0))
                              : (E = h > 1 && L > 1 && x < 6 ? w : C)),
                          k !== c &&
                            ((v = innerWidth + c * D),
                            (p = innerHeight + c),
                            (d = -1 * c),
                            (k = c)),
                          (r = P[n].getBoundingClientRect()),
                          (b = r.bottom) >= d &&
                            (m = r.top) <= p &&
                            (g = r.right) >= d * D &&
                            (y = r.left) <= v &&
                            (b || g || y || m) &&
                            (a.loadHidden || T(P[n])) &&
                            ((u && x < 3 && !f && (h < 3 || L < 4)) ||
                              A(P[n], c)))
                        ) {
                          if ((F(P[n]), (s = !0), x > 9)) break;
                        } else
                          !s &&
                            u &&
                            !o &&
                            x < 4 &&
                            L < 4 &&
                            h > 2 &&
                            (l[0] || a.preloadAfterLoad) &&
                            (l[0] ||
                              (!f &&
                                (b ||
                                  g ||
                                  y ||
                                  m ||
                                  "auto" != P[n][$](a.sizesAttr)))) &&
                            (o = l[0] || P[n]);
                    o && !s && F(o);
                  }
                })
              )),
              (B = ye(
                (M = function (e) {
                  var t = e.target;
                  t._lazyCache
                    ? delete t._lazyCache
                    : (I(e),
                      le(t, a.loadedClass),
                      ue(t, a.loadingClass),
                      de(t, q),
                      he(t, "lazyloaded"));
                })
              )),
              (q = function (e) {
                B({ target: e.target });
              }),
              (O = function (e, t) {
                var n = e.getAttribute("data-load-mode") || a.iframeLoadMode;
                0 == n
                  ? e.contentWindow.location.replace(t)
                  : 1 == n && (e.src = t);
              }),
              (R = function (e) {
                var t,
                  n = e[$](a.srcsetAttr);
                (t = a.customMedia[e[$]("data-media") || e[$]("media")]) &&
                  e.setAttribute("media", t),
                  n && e.setAttribute("srcset", n);
              }),
              (N = ye(function (e, t, n, i, r) {
                var o, s, c, l, u, h;
                (u = he(e, "lazybeforeunveil", t)).defaultPrevented ||
                  (i &&
                    (n ? le(e, a.autosizesClass) : e.setAttribute("sizes", i)),
                  (s = e[$](a.srcsetAttr)),
                  (o = e[$](a.srcAttr)),
                  r && (l = (c = e.parentNode) && ae.test(c.nodeName || "")),
                  (h = t.firesLoad || ("src" in e && (s || o || l))),
                  (u = { target: e }),
                  le(e, a.loadingClass),
                  h && (clearTimeout(d), (d = te(I, 2500)), de(e, q, !0)),
                  l && se.call(c.getElementsByTagName("source"), R),
                  s
                    ? e.setAttribute("srcset", s)
                    : o && !l && (w.test(e.nodeName) ? O(e, o) : (e.src = o)),
                  r && (s || l) && fe(e, { src: o })),
                  e._lazyRace && delete e._lazyRace,
                  ue(e, a.lazyClass),
                  me(function () {
                    var t = e.complete && e.naturalWidth > 1;
                    (h && !t) ||
                      (t && le(e, a.fastLoadedClass),
                      M(u),
                      (e._lazyCache = !0),
                      te(function () {
                        "_lazyCache" in e && delete e._lazyCache;
                      }, 9)),
                      "lazy" == e.loading && x--;
                  }, !0);
              })),
              (F = function (e) {
                if (!e._lazyRace) {
                  var t,
                    n = k.test(e.nodeName),
                    i = n && (e[$](a.sizesAttr) || e[$]("sizes")),
                    r = "auto" == i;
                  ((!r && u) ||
                    !n ||
                    (!e[$]("src") && !e.srcset) ||
                    e.complete ||
                    ce(e, a.errorClass) ||
                    !ce(e, a.lazyClass)) &&
                    ((t = he(e, "lazyunveilread").detail),
                    r && ke.updateElem(e, !0, e.offsetWidth),
                    (e._lazyRace = !0),
                    x++,
                    N(e, t, r, i, n));
                }
              }),
              (V = be(function () {
                (a.loadMode = 3), P();
              })),
              (H = function () {
                u ||
                  (n.now() - f < 999
                    ? te(H, 999)
                    : ((u = !0), (a.loadMode = 3), P(), ee("scroll", z, !0)));
              }),
              {
                _: function () {
                  (f = n.now()),
                    (i.elements = t.getElementsByClassName(a.lazyClass)),
                    (l = t.getElementsByClassName(
                      a.lazyClass + " " + a.preloadClass
                    )),
                    ee("scroll", P, !0),
                    ee("resize", P, !0),
                    ee("pageshow", function (e) {
                      if (e.persisted) {
                        var n = t.querySelectorAll("." + a.loadingClass);
                        n.length &&
                          n.forEach &&
                          ne(function () {
                            n.forEach(function (e) {
                              e.complete && F(e);
                            });
                          });
                      }
                    }),
                    e.MutationObserver
                      ? new MutationObserver(P).observe(G, {
                          childList: !0,
                          subtree: !0,
                          attributes: !0,
                        })
                      : (G[J]("DOMNodeInserted", P, !0),
                        G[J]("DOMAttrModified", P, !0),
                        setInterval(P, 999)),
                    ee("hashchange", P, !0),
                    [
                      "focus",
                      "mouseover",
                      "click",
                      "load",
                      "transitionend",
                      "animationend",
                    ].forEach(function (e) {
                      t[J](e, P, !0);
                    }),
                    /d$|^c/.test(t.readyState)
                      ? H()
                      : (ee("load", H),
                        t[J]("DOMContentLoaded", P),
                        te(H, 2e4)),
                    i.elements.length ? (D(), me._lsFlush()) : P();
                },
                checkElems: P,
                unveil: F,
                _aLSL: (z = function () {
                  3 == a.loadMode && (a.loadMode = 2), V();
                }),
              }),
            ke =
              ((o = ye(function (e, t, n, i) {
                var a, r, o;
                if (
                  ((e._lazysizesWidth = i),
                  (i += "px"),
                  e.setAttribute("sizes", i),
                  ae.test(t.nodeName || ""))
                )
                  for (
                    r = 0, o = (a = t.getElementsByTagName("source")).length;
                    r < o;
                    r++
                  )
                    a[r].setAttribute("sizes", i);
                n.detail.dataAttr || fe(e, n.detail);
              })),
              (s = function (e, t, n) {
                var i,
                  a = e.parentNode;
                a &&
                  ((n = pe(e, a, n)),
                  (i = he(e, "lazybeforesizes", { width: n, dataAttr: !!t }))
                    .defaultPrevented ||
                    ((n = i.detail.width) &&
                      n !== e._lazysizesWidth &&
                      o(e, a, i, n)));
              }),
              {
                _: function () {
                  (r = t.getElementsByClassName(a.autosizesClass)),
                    ee("resize", c);
                },
                checkElems: (c = be(function () {
                  var e,
                    t = r.length;
                  if (t) for (e = 0; e < t; e++) s(r[e]);
                })),
                updateElem: s,
              }),
            we = function () {
              !we.i &&
                t.getElementsByClassName &&
                ((we.i = !0), ke._(), _e._());
            };
          return (
            te(function () {
              a.init && we();
            }),
            (i = {
              cfg: a,
              autoSizer: ke,
              loader: _e,
              init: we,
              uP: fe,
              aC: le,
              rC: ue,
              hC: ce,
              fire: he,
              gW: pe,
              rAF: me,
            })
          );
        })(n, n.document, Date)),
        (n.lazySizes = i),
        e.exports && (e.exports = i);
    }),
    i("gCGxJ");
  var s = {};
  function c(e, t) {
    for (var n in t) {
      var i = t[n];
      e.addEventListener(n, i.listener || i, i.options || void 0);
    }
  }
  !(function (e, t) {
    if (e) {
      var n = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
      };
      (t = t.bind(null, e, e.document)),
        s
          ? t(i("gCGxJ"))
          : "function" == typeof define && define.amd
          ? define(["lazysizes"], t)
          : e.lazySizes
          ? n()
          : e.addEventListener("lazyunveilread", n, !0);
    }
  })("undefined" != typeof window ? window : 0, function (e, t, n) {
    "use strict";
    if (e.addEventListener) {
      var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        a = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
        r = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
        o = /^picture$/i,
        s = n.cfg,
        c = {
          getParent: function (t, n) {
            var i = t,
              a = t.parentNode;
            return (
              (n && "prev" != n) ||
                !a ||
                !o.test(a.nodeName || "") ||
                (a = a.parentNode),
              "self" != n &&
                (i =
                  "prev" == n
                    ? t.previousElementSibling
                    : (n &&
                        (a.closest || e.jQuery) &&
                        (a.closest ? a.closest(n) : jQuery(a).closest(n)[0])) ||
                      a),
              i
            );
          },
          getFit: function (e) {
            var t,
              n,
              i = getComputedStyle(e, null) || {},
              o = i.content || i.fontFamily,
              s = {
                fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit"),
              };
            return (
              !s.fit && o && (t = o.match(a)) && (s.fit = t[1]),
              s.fit
                ? (!(n =
                    e._lazysizesParentContainer ||
                    e.getAttribute("data-parent-container")) &&
                    o &&
                    (t = o.match(r)) &&
                    (n = t[1]),
                  (s.parent = c.getParent(e, n)))
                : (s.fit = i.objectFit),
              s
            );
          },
          getImageRatio: function (t) {
            var n,
              a,
              r,
              c,
              l,
              u,
              d,
              h = t.parentNode,
              f =
                h && o.test(h.nodeName || "")
                  ? h.querySelectorAll("source, img")
                  : [t];
            for (n = 0; n < f.length; n++)
              if (
                ((a =
                  (t = f[n]).getAttribute(s.srcsetAttr) ||
                  t.getAttribute("srcset") ||
                  t.getAttribute("data-pfsrcset") ||
                  t.getAttribute("data-risrcset") ||
                  ""),
                (r = t._lsMedia || t.getAttribute("media")),
                (r = s.customMedia[t.getAttribute("data-media") || r] || r),
                a && (!r || ((e.matchMedia && matchMedia(r)) || {}).matches))
              ) {
                (c = parseFloat(t.getAttribute("data-aspectratio"))) ||
                  ((l = a.match(i))
                    ? "w" == l[2]
                      ? ((u = l[1]), (d = l[3]))
                      : ((u = l[3]), (d = l[1]))
                    : ((u = t.getAttribute("width")),
                      (d = t.getAttribute("height"))),
                  (c = u / d));
                break;
              }
            return c;
          },
          calculateSize: function (e, t) {
            var n,
              i,
              a,
              r = this.getFit(e),
              o = r.fit,
              s = r.parent;
            return "width" == o ||
              (("contain" == o || "cover" == o) && (i = this.getImageRatio(e)))
              ? (s ? (t = s.clientWidth) : (s = e),
                (a = t),
                "width" == o
                  ? (a = t)
                  : (n = t / s.clientHeight) &&
                    (("cover" == o && n < i) || ("contain" == o && n > i)) &&
                    (a = t * (i / n)),
                a)
              : t;
          },
        };
      (n.parentFit = c),
        t.addEventListener("lazybeforesizes", function (e) {
          if (!e.defaultPrevented && e.detail.instance == n) {
            var t = e.target;
            e.detail.width = c.calculateSize(t, e.detail.width);
          }
        });
    }
  });
  var l =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype,
    u = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),
    d = ["src", "poster"];
  function h(e, t) {
    var n = !0,
      i = !1,
      a = void 0;
    try {
      for (
        var r, o = d[Symbol.iterator]();
        !(n = (r = o.next()).done);
        n = !0
      ) {
        var s = r.value;
        s in e.dataset &&
          (e.setAttribute(s, e.dataset[s]),
          e.classList.contains(t) && e.classList.remove(t));
      }
    } catch (e) {
      (i = !0), (a = e);
    } finally {
      try {
        n || null == o.return || o.return();
      } finally {
        if (i) throw a;
      }
    }
  }
  function f(e, t, n, i) {
    if ("VIDEO" == e.nodeName) {
      var a = Array.from(e.querySelectorAll("source")),
        r = !0,
        o = !1,
        s = void 0;
      try {
        for (
          var c, l = a[Symbol.iterator]();
          !(r = (c = l.next()).done);
          r = !0
        ) {
          h(c.value, t);
        }
      } catch (e) {
        (o = !0), (s = e);
      } finally {
        try {
          r || null == l.return || l.return();
        } finally {
          if (o) throw s;
        }
      }
      e.load();
    }
    h(e, t);
    var u = e.classList;
    u.contains(n) && (u.remove(n), u.add(i));
  }
  function v(e) {
    var t = (null == e ? void 0 : e.lazyClass) || "lazy",
      n = (null == e ? void 0 : e.lazyBackgroundClass) || "lazy-bg",
      i = (null == e ? void 0 : e.lazyBackgroundLoaded) || "lazy-bg-loaded",
      a = (null == e ? void 0 : e.threshold) || 200,
      r = (null == e ? void 0 : e.events) || {},
      o = (null == e ? void 0 : e.observeChanges) || !1,
      s = (null == e ? void 0 : e.observeRootSelector) || "body",
      d = (null == e ? void 0 : e.mutationObserverOptions) || {
        childList: !0,
        subtree: !0,
      },
      h = "video.".concat(t, ",.").concat(n),
      v = Array.from(document.querySelectorAll(h)),
      p = !0,
      m = !1,
      y = void 0;
    try {
      for (
        var g, b = v[Symbol.iterator]();
        !(p = (g = b.next()).done);
        p = !0
      ) {
        c(g.value, r);
      }
    } catch (e) {
      (m = !0), (y = e);
    } finally {
      try {
        p || null == b.return || b.return();
      } finally {
        if (m) throw y;
      }
    }
    var _ = !0,
      k = !1,
      w = void 0;
    if (!0 === l && !1 === u) {
      var S = new IntersectionObserver(
          function (e) {
            var a = !0,
              r = !1,
              s = void 0;
            try {
              for (
                var c,
                  l = function () {
                    var e = c.value;
                    if (e.isIntersecting || e.intersectionRatio) {
                      var a = e.target;
                      f(a, t, n, i),
                        S.unobserve(a),
                        (v = v.filter(function (e) {
                          return e != a;
                        })),
                        0 === v.length && !1 === o && S.disconnect();
                    }
                  },
                  u = e[Symbol.iterator]();
                !(a = (c = u.next()).done);
                a = !0
              )
                l();
            } catch (e) {
              (r = !0), (s = e);
            } finally {
              try {
                a || null == u.return || u.return();
              } finally {
                if (r) throw s;
              }
            }
          },
          { rootMargin: "".concat(a, "px 0%") }
        ),
        C = !0,
        E = !1,
        x = void 0;
      try {
        for (
          var L, I = v[Symbol.iterator]();
          !(C = (L = I.next()).done);
          C = !0
        ) {
          var T = L.value;
          S.observe(T);
        }
      } catch (e) {
        (E = !0), (x = e);
      } finally {
        try {
          C || null == I.return || I.return();
        } finally {
          if (E) throw x;
        }
      }
      o &&
        new MutationObserver(function () {
          var e = document.querySelectorAll(h),
            t = !0,
            n = !1,
            i = void 0;
          try {
            for (
              var a, o = e[Symbol.iterator]();
              !(t = (a = o.next()).done);
              t = !0
            ) {
              var s = a.value;
              !1 === v.includes(s) &&
                (v.push(s), c(s, r), !0 === l && !1 === u && S.observe(s));
            }
          } catch (e) {
            (n = !0), (i = e);
          } finally {
            try {
              t || null == o.return || o.return();
            } finally {
              if (n) throw i;
            }
          }
        }).observe(document.querySelector(s), d);
    } else if (u)
      try {
        for (
          var A, D = v[Symbol.iterator]();
          !(_ = (A = D.next()).done);
          _ = !0
        ) {
          f(A.value, t, n, i);
        }
      } catch (e) {
        (k = !0), (w = e);
      } finally {
        try {
          _ || null == D.return || D.return();
        } finally {
          if (k) throw w;
        }
      }
  }
  function p(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  function m(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function y(e, t) {
    for (var n = 0; n < t.length; n++) {
      var i = t[n];
      (i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        "value" in i && (i.writable = !0),
        Object.defineProperty(e, i.key, i);
    }
  }
  function g(e, t, n) {
    return t && y(e.prototype, t), n && y(e, n), e;
  }
  function b(e, t) {
    return (
      (b =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        }),
      b(e, t)
    );
  }
  function _(e, t) {
    return b(e, t);
  }
  function k(e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function");
    (e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      t && _(e, t);
  }
  function w(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
    return i;
  }
  function S(e) {
    if (Array.isArray(e)) return w(e);
  }
  function C(e) {
    if (
      ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
      null != e["@@iterator"]
    )
      return Array.from(e);
  }
  function E() {
    throw new TypeError(
      "Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
  function x(e, t) {
    if (e) {
      if ("string" == typeof e) return w(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return (
        "Object" === n && e.constructor && (n = e.constructor.name),
        "Map" === n || "Set" === n
          ? Array.from(n)
          : "Arguments" === n ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          ? w(e, t)
          : void 0
      );
    }
  }
  function L(e) {
    return S(e) || C(e) || x(e) || E();
  }
  function I() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {})
        ),
        !0
      );
    } catch (e) {
      return !1;
    }
  }
  function T(e) {
    return (
      (T = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }),
      T(e)
    );
  }
  function A(e) {
    return T(e);
  }
  function D(e) {
    return e && e.constructor === Symbol ? "symbol" : typeof e;
  }
  function P(e, t) {
    return !t || ("object" !== D(t) && "function" != typeof t) ? p(e) : t;
  }
  function M(e) {
    var t = I();
    return function () {
      var n,
        i = A(e);
      if (t) {
        var a = A(this).constructor;
        n = Reflect.construct(i, arguments, a);
      } else n = i.apply(this, arguments);
      return P(this, n);
    };
  }
  function B(e, t, n) {
    return (
      (B = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      })()
        ? Reflect.construct
        : function (e, t, n) {
            var i = [null];
            i.push.apply(i, t);
            var a = new (Function.bind.apply(e, i))();
            return n && _(a, n.prototype), a;
          }),
      B.apply(null, arguments)
    );
  }
  function q(e, t, n) {
    return B.apply(null, arguments);
  }
  function O(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (
      (O = function (e) {
        if (
          null === e ||
          ((n = e), -1 === Function.toString.call(n).indexOf("[native code]"))
        )
          return e;
        var n;
        if ("function" != typeof e)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, i);
        }
        function i() {
          return q(e, arguments, A(this).constructor);
        }
        return (
          (i.prototype = Object.create(e.prototype, {
            constructor: {
              value: i,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          _(i, e)
        );
      }),
      O(e)
    );
  }
  function R(e) {
    return O(e);
  }
  var N = {
      SECTION_LOAD: "shopify:section:load",
      SECTION_UNLOAD: "shopify:section:unload",
      SECTION_SELECT: "shopify:section:select",
      SECTION_DESELECT: "shopify:section:deselect",
      SECTION_REORDER: "shopify:section:reorder",
      BLOCK_SELECT: "shopify:block:select",
      BLOCK_DESELECT: "shopify:block:deselect",
    },
    F = {
      ARROW_LEFT_STRING_KEY: "ArrowLeft",
      ARROW_RIGHT_STRING_KEY: "ArrowRight",
      ARROW_LEFT_NUMBER_KEY: 37,
      ARROW_RIGHT_NUMBER_KEY: 39,
      ENTER_STRING_KEY: "Enter",
      ENTER_NUMBER_KEY: 13,
      ESCAPE_STRING_KEY: "Escape",
      ESCAPE_NUMBER_KEY: 27,
      SPACE_STRING_KEY: " ",
      SPACE_NUMBER_KEY: 32,
      TAB_STRING_KEY: "Tab",
      TAB_NUMBER_KEY: 9,
    },
    V = function (e) {
      return new Promise(function (t, n) {
        setTimeout(t, e);
      });
    },
    z = function (e, t, n, i) {
      n && e && t && e["".concat(i, "EventListener")](t, n);
    },
    H = function (e, t, n) {
      z(e, t, n, "add");
    },
    U = function (e, t, n) {
      z(e, t, n, "remove");
    },
    K = new IntersectionObserver(function (e, t) {
      e.forEach(function (e) {
        var t = e.isIntersecting,
          n = e.target.closest('[aria-hidden="true"], .hidden');
        e.target.toggleAttribute("data-is-in-viewport", t && !n);
      });
    }),
    W = function () {
      return ["button", "[href]", "[data-focus-trap-target]", "a", "[tabindex]"]
        .map(function (e) {
          return "".concat(
            e,
            ':not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)'
          );
        })
        .join(",");
    },
    j = function (e) {
      var t = document.createElement("div");
      return (
        t.classList.add("hidden"),
        document.body.appendChild(t),
        t.appendChild(e),
        t
      );
    },
    Y = function (e) {
      e.remove();
    },
    X = function (e) {
      return e === F.ENTER_NUMBER_KEY || e === F.ENTER_STRING_KEY;
    },
    Q = function (e) {
      return e === F.ESCAPE_STRING_KEY || e === F.ESCAPE_NUMBER_KEY;
    },
    G = function (e) {
      return e === F.ARROW_RIGHT_NUMBER_KEY || e === F.ARROW_RIGHT_STRING_KEY;
    },
    Z = function (e) {
      return e === F.ARROW_LEFT_NUMBER_KEY || e === F.ARROW_LEFT_STRING_KEY;
    },
    J = function (e) {
      return e === F.TAB_NUMBER_KEY || e === F.TAB_STRING_KEY;
    },
    $ = function (e) {
      return (
        1e3 * parseFloat(e.transitionDuration) +
        1e3 * parseFloat(e.transitionDelay)
      );
    },
    ee = (function () {
      "use strict";
      function e() {
        m(this, e), (this._listeners = {});
      }
      return (
        g(e, [
          {
            key: "subscribe",
            value: function (e, t) {
              this._listeners[e] || (this._listeners[e] = []),
                H(document, N[e], t),
                this._listeners[e].push(t);
            },
          },
          {
            key: "unsubscribe",
            value: function (e, t) {
              this._listeners[e] &&
                (U(document, N[e], t),
                (this._listeners[e] = this._listeners[e].filter(function (e) {
                  return e !== t;
                })));
            },
          },
          {
            key: "destroy",
            value: function () {
              var e = this;
              Object.keys(this._listeners).forEach(function (t) {
                e._listeners[t].forEach(function (n) {
                  e.unsubscribe(t, n);
                });
              }),
                (this._listeners = {});
            },
          },
        ]),
        e
      );
    })(),
    te = window.Shopify,
    ne = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this))._editor = new ee()),
          (e._isEditorMode = te.designMode),
          (e._listeners = {}),
          e
        );
      }
      return (
        g(n, [
          {
            key: "subscribe",
            value: function (e, t) {
              this._listeners[e] || (this._listeners[e] = []),
                this._listeners[e].push(t);
            },
          },
          {
            key: "unsubscribe",
            value: function (e, t) {
              this._listeners[e] &&
                (this._listeners[e] = this._listeners[e].filter(function (e) {
                  return e !== t;
                }));
            },
          },
          {
            key: "emit",
            value: function (e, t) {
              this._listeners[e] &&
                this._listeners[e].forEach(function (e) {
                  return e(t);
                });
            },
          },
        ]),
        n
      );
    })(R(HTMLElement)),
    ie = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleClick", function (t) {
            var n = t.target;
            if (n.hasAttribute("data-login-form-button")) {
              var i = n.dataset.loginFormId || "";
              e.setFormVisibleById(i), e.updateFocus();
            }
          }),
          (e.forms = L(e.querySelectorAll("[data-login-form]"))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateFocus(),
                this.addEventListener("click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleClick);
            },
          },
          {
            key: "setFormVisibleById",
            value: function (e) {
              this.forms.forEach(function (t) {
                var n = t.getAttribute("data-login-form") === e;
                t.classList.toggle("hidden", !n);
              });
            },
          },
          {
            key: "updateFocus",
            value: function () {
              this.forms.forEach(function (e) {
                var t = e.classList.contains("hidden"),
                  n = e.querySelector('[type="email"]');
                !t && n && n.focus();
              });
            },
          },
        ]),
        n
      );
    })(ne),
    ae = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleWindowScroll", function () {
            e.updateButtonVisible();
          }),
          a(p(e), "_handleButtonClick", function () {
            e.scrollToTop();
          }),
          (e.button = e.querySelector("[data-back-to-top-button]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.button &&
                this.button.addEventListener("click", this._handleButtonClick),
                window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "updateButtonVisible",
            value: function () {
              if (this.button) {
                var e = window.scrollY > window.innerHeight;
                this.button.toggleAttribute("visible", e);
              }
            },
          },
          {
            key: "scrollToTop",
            value: function () {
              window.scrollTo({ top: 0, behavior: "smooth" });
            },
          },
        ]),
        n
      );
    })(R(HTMLElement)),
    re = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleWindowScroll", function () {
            var t = document.querySelector(
              ".shopify-section.shopify-section-header"
            );
            if (t && e.button) {
              var n =
                t.getBoundingClientRect().bottom + e.button.offsetHeight < 0;
              e.button.toggleAttribute("visible", n);
            }
          }),
          (e.button = e.querySelector("[data-cart-sticky-button]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
        ]),
        n
      );
    })(R(HTMLElement)),
    oe = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleBlur", function (t) {
            if (e.input) {
              var n = t.target.value || "0";
              (e.input.value = n),
                e._updateButtonsDisabled(),
                (e._prevValue = n);
            }
          }),
          a(p(e), "_handleKeydown", function (t) {
            e.input &&
              X(t.key || t.keyCode) &&
              (t.preventDefault(), e.input.blur());
          }),
          a(p(e), "_handleInput", function (t) {
            if (e.input) {
              var n = t.target.value;
              (e.input.value = e._isMoreThanStock ? e._stockValue : n),
                e._updateButtonsDisabled(),
                (e._prevValue = n);
            }
          }),
          (e.inputSelector = "[data-quantity-input]"),
          (e.input = e.querySelector(e.inputSelector)),
          (e._prevValue = e._value),
          (e._stockValue = e.dataset.stock || "0"),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._updateButtonsDisabled(),
                H(this.input, "keypress", this._handleKeydown),
                H(this.input, "input", this._handleInput),
                H(this.input, "blur", this._handleBlur);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this.input, "keypress", this._handleKeydown),
                U(this.input, "input", this._handleInput),
                U(this.input, "blur", this._handleBlur);
            },
          },
          {
            key: "inputChange",
            value: function (e) {
              this.input &&
                ("minus" === e ? this.input.stepDown() : this.input.stepUp(),
                +this._prevValue != +this._value &&
                  this.input.dispatchEvent(
                    new Event("change", { bubbles: !0 })
                  ),
                this._updateButtonsDisabled());
            },
          },
          {
            key: "_updateButtonsDisabled",
            value: function () {
              this._updateButtonDisabled("minus", this._isLessThanMin),
                this._updateButtonDisabled("plus", this._isMoreThanStock);
            },
          },
          {
            key: "setDisable",
            value: function (e) {
              this._updateButtonDisabled("minus", e),
                this._updateButtonDisabled("plus", e);
            },
          },
          {
            key: "_updateButtonDisabled",
            value: function (e, t) {
              var n = this.querySelector(
                'quantity-btn[data-action="'.concat(e, '"]')
              );
              n && n.toggleAttribute("disabled", t);
            },
          },
          {
            key: "_value",
            get: function () {
              return this.input ? this.input.value : "0";
            },
          },
          {
            key: "_isLessThanMin",
            get: function () {
              return !!this.input && +this._value <= +this.input.min;
            },
          },
          {
            key: "_isMoreThanStock",
            get: function () {
              return +this._value >= +this._stockValue;
            },
          },
        ]),
        n
      );
    })(ne),
    se = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleButtonClick", function (t) {
            t.preventDefault(), e.update();
          }),
          a(p(e), "_handleKeyDown", function (t) {
            var n = X(t.key || t.keyCode),
              i = t.target;
            n &&
              !i.hasAttribute("disabled") &&
              (t.preventDefault(), e.update());
          }),
          (e._quantity = e.closest("quantity-component")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("click", this._handleButtonClick),
                this.addEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleButtonClick),
                this.removeEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.dataset.action;
              this._quantity &&
                e &&
                (this._quantity.inputChange(e),
                "minus" === e && this._setDisabled());
            },
          },
          {
            key: "_setDisabled",
            value: function () {
              if (this._quantity && this._quantity.input) {
                var e = "1" === this._quantity.input.value;
                this.toggleAttribute("disabled", e);
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ce = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleClick", function (t) {
            t.preventDefault();
            var n = t.target;
            n.hasAttribute("data-localization-item") &&
              e.input &&
              e.form &&
              n.dataset.value &&
              ((e.input.value = n.dataset.value), e.form.submit());
          }),
          (e.inputSelector = "[data-localization-input]"),
          (e.formSelector = "form"),
          (e.input = e.querySelector(e.inputSelector)),
          (e.form = e.querySelector(e.formSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this, "click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this, "click", this._handleClick);
            },
          },
        ]),
        n
      );
    })(ne),
    le = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleCloseButtonClick", function () {
            e.hide();
          }),
          (e._closeBtnSelector = "[data-notification-close-button]"),
          (e._alertSelector = "[data-notification-alert]"),
          (e._alertTextSelector = "[data-notification-alert-text]"),
          (e._closeBtn = e.querySelector(e._closeBtnSelector)),
          (e._alert = e.querySelector(e._alertSelector)),
          (e._alertText = e.querySelector(e._alertTextSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._closeBtn &&
                this._closeBtn.addEventListener(
                  "click",
                  this._handleCloseButtonClick
                );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._closeBtn &&
                this._closeBtn.removeEventListener(
                  "click",
                  this._handleCloseButtonClick
                );
            },
          },
          {
            key: "show",
            value: function (e, t) {
              var n = this;
              this._setAlert(e, t || "warning"),
                this.showTimeoutId && clearTimeout(this.showTimeoutId),
                this._setVisible(!0),
                (this.showTimeoutId = setTimeout(function () {
                  n._setVisible(!1);
                }, 3e3));
            },
          },
          {
            key: "hide",
            value: function () {
              this._setVisible(!1);
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.toggleAttribute("open", e);
            },
          },
          {
            key: "_setAlert",
            value: function (e, t) {
              this._alert &&
                this._alertText &&
                (this._alert.setAttribute("alert-type", t),
                (this._alertText.innerHTML = e));
            },
          },
        ]),
        n
      );
    })(ne),
    ue = (function () {
      "use strict";
      function e(t) {
        m(this, e), (this.element = t);
      }
      return (
        g(e, [
          {
            key: "update",
            value: function (e) {
              var t = e === this.element.getAttribute("data-id");
              this.element.classList.toggle("selected", t);
            },
          },
        ]),
        e
      );
    })(),
    de = function (e) {
      e && e.classList.remove("hidden");
    },
    he = function (e) {
      e && e.classList.add("hidden");
    },
    fe = function (e, t) {
      return getComputedStyle(e)[t];
    },
    ve = function (e) {
      return e.content.cloneNode(!0);
    },
    pe = function (e) {
      return e.content.firstElementChild.cloneNode(!0);
    },
    me = function (e, t) {
      document.documentElement.style.setProperty("--gsc-".concat(e), t);
    },
    ye = function (e, t) {
      e && e.classList.toggle("forward-transition", t);
    },
    ge = function (e) {
      return new DOMParser().parseFromString(e, "text/html");
    },
    be = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleTabNameClick", function (t) {
            t.preventDefault();
            var n = t.target;
            n.dataset.id && e.selectTab(n.dataset.id);

            // Storside adding yotpo call to refresh widgets
            // console.log('Storyside - tab name clicked, refresh Yotpo');
            if (yotpoWidgetsContainer) {
              yotpoWidgetsContainer.initWidgets();
            }

          }),
          a(p(e), "_handleKeyDown", function (t) {
            var n = t.target;
            n.dataset.id &&
              X(t.key || t.keyCode) &&
              (t.preventDefault(), e.selectTab(n.dataset.id));
          }),
          (e.containerSelector = "[data-tabs-container]"),
          (e.templateSelector = "[data-tabs-elements-template]"),
          (e.tabSelector = "tab-component, tab-with-dynamic-height"),
          (e.tabNameSelector = "[data-tabs-name]"),
          (e.container = e.querySelector(e.containerSelector)),
          (e.template = e.querySelector(e.templateSelector)),
          (e.templateContent = ve(e.template)),
          (e.tabNames = L(e.querySelectorAll(e.tabNameSelector))),
          (e.tabMap = e.generateTabMap()),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.tabNames.forEach(function (t) {
                t.addEventListener("keydown", e._handleKeyDown),
                  t.addEventListener("click", e._handleTabNameClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.tabNames.forEach(function (t) {
                t.removeEventListener("keydown", e._handleKeyDown),
                  t.removeEventListener("click", e._handleTabNameClick);
              });
            },
          },
          {
            key: "generateTabMap",
            value: function () {
              return [this.querySelector(this.tabSelector)]
                .concat(
                  L(this.templateContent.querySelectorAll(this.tabSelector))
                )
                .reduce(function (e, t) {
                  var n = t.dataset.id;
                  return n ? o(r({}, e), a({}, n, t)) : e;
                }, {});
            },
          },
          {
            key: "selectTab",
            value: function (e) {
              this._updateNameById(e),
                this._setTabById(e),
                this.emit("selectTab", e);
            },
          },
          {
            key: "_unmountTab",
            value: function (e) {
              e.remove();
            },
          },
          {
            key: "_mountTab",
            value: function (e) {
              this.container && this.container.appendChild(e);
            },
          },
          {
            key: "_updateNameById",
            value: function (e) {
              this.tabNames.forEach(function (t) {
                new ue(t).update(e);
              });
            },
          },
          {
            key: "_setTabById",
            value: function (e) {
              var t = this.tabMap[e],
                n = this.tabMap[this.dataset.selectedTabId];
              n &&
                t &&
                (this.showNextTab(t), n !== t && this.hideCurrentTab(n));
            },
          },
          {
            key: "showNextTab",
            value: function (e) {
              var t = e.getAttribute("data-id");
              t &&
                (this._mountTab(e), e.show(), (this.dataset.selectedTabId = t));
            },
          },
          {
            key: "hideCurrentTab",
            value: function (e) {
              var t = this;
              e.hide().then(function () {
                t._unmountTab(e);
              });
            },
          },
        ]),
        n
      );
    })(ne),
    _e = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "collapse", function () {
            e._hideItems(), he(e._collapseBtn), de(e._expandBtn);
          }),
          a(p(e), "expand", function () {
            e._initialHeight || e._setInitialHeight(),
              e._showItems(),
              e._tryHideExpandBtn(),
              de(e._collapseBtn),
              e._setMaxHeight();
          }),
          (e.itemSelector = "[data-list-item]"),
          (e.expandBtnSelector = 'list-btn[data-trigger="expand"]'),
          (e.collapseBtnSelector = 'list-btn[data-trigger="collapse"]'),
          (e.visibleItemSelector = "".concat(e.itemSelector, ":not(.hidden)")),
          (e.hiddenItemSelector = "".concat(e.itemSelector, ".hidden")),
          (e._expandBtn = e.querySelector(e.expandBtnSelector)),
          (e._collapseBtn = e.querySelector(e.collapseBtnSelector)),
          (e.styles = getComputedStyle(p(e))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "_setInitialHeight",
            value: function () {
              (this._initialHeight = this.offsetHeight),
                (this.style.maxHeight = "".concat(this._initialHeight, "px"));
            },
          },
          {
            key: "_setMaxHeight",
            value: function () {
              (this._maxHeight = this.scrollHeight),
                (this.style.maxHeight = "".concat(this._maxHeight, "px"));
            },
          },
          {
            key: "_hideItems",
            value: function () {
              var e = this,
                t = this.querySelectorAll(this.visibleItemSelector);
              (this.style.maxHeight = "".concat(this._initialHeight, "px")),
                setTimeout(function () {
                  t.forEach(function (t, n) {
                    n + 1 >
                      +(e.dataset.initialCount ? +e.dataset.initialCount : 0) &&
                      he(t);
                  });
                }, $(this.styles));
            },
          },
          {
            key: "_showItems",
            value: function () {
              var e = this;
              this.querySelectorAll(this.hiddenItemSelector).forEach(function (
                t,
                n
              ) {
                n + 1 < +(e.dataset.showCount ? e.dataset.showCount : 0) &&
                  de(t);
              }),
                (this.style.maxHeight = "".concat(this._maxHeight, "px"));
            },
          },
          {
            key: "_tryHideExpandBtn",
            value: function () {
              0 === this.querySelectorAll(this.hiddenItemSelector).length &&
                he(this._expandBtn);
            },
          },
        ]),
        n
      );
    })(ne),
    ke = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.update();
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("list-component");
              e &&
                ("collapse" === this.dataset.trigger
                  ? e.collapse()
                  : e.expand(),
                this.emit("click", e));
            },
          },
        ]),
        n
      );
    })(ne),
    we = ke;
  function Se(e, t, n, i, a, r, o) {
    try {
      var s = e[r](o),
        c = s.value;
    } catch (e) {
      return void n(e);
    }
    s.done ? t(c) : Promise.resolve(c).then(i, a);
  }
  function Ce(e) {
    return function () {
      var t = this,
        n = arguments;
      return new Promise(function (i, a) {
        var r = e.apply(t, n);
        function o(e) {
          Se(r, i, a, o, s, "next", e);
        }
        function s(e) {
          Se(r, i, a, o, s, "throw", e);
        }
        o(void 0);
      });
    };
  }
  function Ee(e, t) {
    if (null == e) return {};
    var n,
      i,
      a = {},
      r = Object.keys(e);
    for (i = 0; i < r.length; i++)
      (n = r[i]), t.indexOf(n) >= 0 || (a[n] = e[n]);
    return a;
  }
  function xe(e, t) {
    if (null == e) return {};
    var n,
      i,
      a = Ee(e, t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      for (i = 0; i < r.length; i++)
        (n = r[i]),
          t.indexOf(n) >= 0 ||
            (Object.prototype.propertyIsEnumerable.call(e, n) && (a[n] = e[n]));
    }
    return a;
  }
  function Le(e, t) {
    var n,
      i,
      a,
      r,
      o = function (e) {
        return function (t) {
          return s([e, t]);
        };
      },
      s = function (o) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; r && ((r = 0), o[0] && (c = 0)), c; )
          try {
            if (
              ((n = 1),
              i &&
                (a =
                  2 & o[0]
                    ? i.return
                    : o[0]
                    ? i.throw || ((a = i.return) && a.call(i), 0)
                    : i.next) &&
                !(a = a.call(i, o[1])).done)
            )
              return a;
            switch (((i = 0), a && (o = [2 & o[0], a.value]), o[0])) {
              case 0:
              case 1:
                a = o;
                break;
              case 4:
                return c.label++, { value: o[1], done: !1 };
              case 5:
                c.label++, (i = o[1]), (o = [0]);
                continue;
              case 7:
                (o = c.ops.pop()), c.trys.pop();
                continue;
              default:
                if (
                  !((a = c.trys),
                  (a = a.length > 0 && a[a.length - 1]) ||
                    (6 !== o[0] && 2 !== o[0]))
                ) {
                  c = 0;
                  continue;
                }
                if (3 === o[0] && (!a || (o[1] > a[0] && o[1] < a[3]))) {
                  c.label = o[1];
                  break;
                }
                if (6 === o[0] && c.label < a[1]) {
                  (c.label = a[1]), (a = o);
                  break;
                }
                if (a && c.label < a[2]) {
                  (c.label = a[2]), c.ops.push(o);
                  break;
                }
                a[2] && c.ops.pop(), c.trys.pop();
                continue;
            }
            o = t.call(e, c);
          } catch (e) {
            (o = [6, e]), (i = 0);
          } finally {
            n = a = 0;
          }
        if (5 & o[0]) throw o[1];
        return { value: o[0] ? o[1] : void 0, done: !0 };
      },
      c = {
        label: 0,
        sent: function () {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (r = { next: o(0), throw: o(1), return: o(2) }),
      "function" == typeof Symbol &&
        (r[Symbol.iterator] = function () {
          return this;
        }),
      r
    );
  }
  Object.create;
  Object.create;
  function Ie(e) {
    return e.split("-")[1];
  }
  function Te(e) {
    return "y" === e ? "height" : "width";
  }
  function Ae(e) {
    return e.split("-")[0];
  }
  function De(e) {
    return ["top", "bottom"].includes(Ae(e)) ? "x" : "y";
  }
  function Pe(e, t, n) {
    var i,
      a = e.reference,
      r = e.floating,
      o = a.x + a.width / 2 - r.width / 2,
      s = a.y + a.height / 2 - r.height / 2,
      c = De(t),
      l = Te(c),
      u = a[l] / 2 - r[l] / 2,
      d = "x" === c;
    switch (Ae(t)) {
      case "top":
        i = { x: o, y: a.y - r.height };
        break;
      case "bottom":
        i = { x: o, y: a.y + a.height };
        break;
      case "right":
        i = { x: a.x + a.width, y: s };
        break;
      case "left":
        i = { x: a.x - r.width, y: s };
        break;
      default:
        i = { x: a.x, y: a.y };
    }
    switch (Ie(t)) {
      case "start":
        i[c] -= u * (n && d ? -1 : 1);
        break;
      case "end":
        i[c] += u * (n && d ? -1 : 1);
    }
    return i;
  }
  var Me,
    Be =
      ((Me = Ce(function (e, t, n) {
        var i,
          s,
          c,
          l,
          u,
          d,
          h,
          f,
          v,
          p,
          m,
          y,
          g,
          b,
          _,
          k,
          w,
          S,
          C,
          E,
          x,
          L,
          I,
          T,
          A,
          D;
        return Le(this, function (P) {
          switch (P.label) {
            case 0:
              return (
                (i = n.placement),
                (s = void 0 === i ? "bottom" : i),
                (c = n.strategy),
                (l = void 0 === c ? "absolute" : c),
                (u = n.middleware),
                (d = void 0 === u ? [] : u),
                (h = n.platform),
                (f = d.filter(Boolean)),
                [4, null == h.isRTL ? void 0 : h.isRTL(t)]
              );
            case 1:
              return (
                (v = P.sent()),
                [
                  4,
                  h.getElementRects({ reference: e, floating: t, strategy: l }),
                ]
              );
            case 2:
              (p = P.sent()),
                (m = Pe(p, s, v)),
                (y = m.x),
                (g = m.y),
                (b = s),
                (_ = {}),
                (k = 0),
                (w = 0),
                (P.label = 3);
            case 3:
              return w < f.length
                ? ((S = f[w]),
                  (C = S.name),
                  [
                    4,
                    (0, S.fn)({
                      x: y,
                      y: g,
                      initialPlacement: s,
                      placement: b,
                      strategy: l,
                      middlewareData: _,
                      rects: p,
                      platform: h,
                      elements: { reference: e, floating: t },
                    }),
                  ])
                : [3, 11];
            case 4:
              return (
                (E = P.sent()),
                (x = E.x),
                (L = E.y),
                (I = E.data),
                (T = E.reset),
                (y = null != x ? x : y),
                (g = null != L ? L : g),
                (_ = o(r({}, _), a({}, C, r({}, _[C], I)))),
                T && k <= 50
                  ? (k++,
                    "object" != typeof T
                      ? [3, 9]
                      : (T.placement && (b = T.placement),
                        T.rects
                          ? !0 !== T.rects
                            ? [3, 6]
                            : [
                                4,
                                h.getElementRects({
                                  reference: e,
                                  floating: t,
                                  strategy: l,
                                }),
                              ]
                          : [3, 8]))
                  : [3, 10]
              );
            case 5:
              return (A = P.sent()), [3, 7];
            case 6:
              (A = T.rects), (P.label = 7);
            case 7:
              (p = A), (P.label = 8);
            case 8:
              (D = Pe(p, b, v)), (y = D.x), (g = D.y), (P.label = 9);
            case 9:
              return (w = -1), [3, 10];
            case 10:
              return w++, [3, 3];
            case 11:
              return [
                2,
                { x: y, y: g, placement: b, strategy: l, middlewareData: _ },
              ];
          }
        });
      })),
      function (e, t, n) {
        return Me.apply(this, arguments);
      });
  function qe(e) {
    return "number" != typeof e
      ? (function (e) {
          return r({ top: 0, right: 0, bottom: 0, left: 0 }, e);
        })(e)
      : { top: e, right: e, bottom: e, left: e };
  }
  function Oe(e) {
    return o(r({}, e), {
      top: e.y,
      left: e.x,
      right: e.x + e.width,
      bottom: e.y + e.height,
    });
  }
  function Re(e, t) {
    return Ne.apply(this, arguments);
  }
  function Ne() {
    return (Ne = Ce(function (e, t) {
      var n,
        i,
        a,
        s,
        c,
        l,
        u,
        d,
        h,
        f,
        v,
        p,
        m,
        y,
        g,
        b,
        _,
        k,
        w,
        S,
        C,
        E,
        x,
        L,
        I,
        T,
        A,
        D,
        P,
        M;
      return Le(this, function (B) {
        switch (B.label) {
          case 0:
            return (
              void 0 === t && (t = {}),
              (i = e.x),
              (a = e.y),
              (s = e.platform),
              (c = e.rects),
              (l = e.elements),
              (u = e.strategy),
              (d = t.boundary),
              (h = void 0 === d ? "clippingAncestors" : d),
              (f = t.rootBoundary),
              (v = void 0 === f ? "viewport" : f),
              (p = t.elementContext),
              (m = void 0 === p ? "floating" : p),
              (y = t.altBoundary),
              (g = void 0 !== y && y),
              (b = t.padding),
              (_ = qe(void 0 === b ? 0 : b)),
              (k = "floating" === m ? "reference" : "floating"),
              (w = l[g ? k : m]),
              (C = s.getClippingRect),
              (E = {}),
              [4, null == s.isElement ? void 0 : s.isElement(w)]
            );
          case 1:
            return null == (n = B.sent()) || n ? ((x = w), [3, 5]) : [3, 2];
          case 2:
            return (L = w.contextElement)
              ? [3, 4]
              : [
                  4,
                  null == s.getDocumentElement
                    ? void 0
                    : s.getDocumentElement(l.floating),
                ];
          case 3:
            (L = B.sent()), (B.label = 4);
          case 4:
            (x = L), (B.label = 5);
          case 5:
            return [
              4,
              C.apply(s, [
                ((E.element = x),
                (E.boundary = h),
                (E.rootBoundary = v),
                (E.strategy = u),
                E),
              ]),
            ];
          case 6:
            return (
              (S = Oe.apply(void 0, [B.sent()])),
              (I =
                "floating" === m
                  ? o(r({}, c.floating), { x: i, y: a })
                  : c.reference),
              [
                4,
                null == s.getOffsetParent
                  ? void 0
                  : s.getOffsetParent(l.floating),
              ]
            );
          case 7:
            return (
              (T = B.sent()), [4, null == s.isElement ? void 0 : s.isElement(T)]
            );
          case 8:
            return B.sent()
              ? [4, null == s.getScale ? void 0 : s.getScale(T)]
              : [3, 10];
          case 9:
            return (D = B.sent() || { x: 1, y: 1 }), [3, 11];
          case 10:
            (D = { x: 1, y: 1 }), (B.label = 11);
          case 11:
            return (
              (A = D),
              s.convertOffsetParentRelativeRectToViewportRelativeRect
                ? [
                    4,
                    s.convertOffsetParentRelativeRectToViewportRelativeRect({
                      rect: I,
                      offsetParent: T,
                      strategy: u,
                    }),
                  ]
                : [3, 13]
            );
          case 12:
            return (M = B.sent()), [3, 14];
          case 13:
            (M = I), (B.label = 14);
          case 14:
            return (
              (P = Oe.apply(void 0, [M])),
              [
                2,
                {
                  top: (S.top - P.top + _.top) / A.y,
                  bottom: (P.bottom - S.bottom + _.bottom) / A.y,
                  left: (S.left - P.left + _.left) / A.x,
                  right: (P.right - S.right + _.right) / A.x,
                },
              ]
            );
        }
      });
    })).apply(this, arguments);
  }
  var Fe = Math.min,
    Ve = Math.max;
  function ze(e, t, n) {
    return Ve(e, Fe(t, n));
  }
  var He = function (e) {
      return {
        name: "arrow",
        options: e,
        fn: function (t) {
          return Ce(function () {
            var n,
              i,
              r,
              o,
              s,
              c,
              l,
              u,
              d,
              h,
              f,
              v,
              p,
              m,
              y,
              g,
              b,
              _,
              k,
              w,
              S,
              C,
              E,
              x,
              L,
              I,
              T,
              A,
              D,
              P,
              M,
              B,
              q;
            return Le(this, function (O) {
              switch (O.label) {
                case 0:
                  return (
                    (i = (n = e || {}).element),
                    (r = n.padding),
                    (o = void 0 === r ? 0 : r),
                    (s = t.x),
                    (c = t.y),
                    (l = t.placement),
                    (u = t.rects),
                    (d = t.platform),
                    (h = t.elements),
                    null == i
                      ? [2, {}]
                      : ((f = qe(o)),
                        (v = { x: s, y: c }),
                        (p = De(l)),
                        (m = Te(p)),
                        [4, d.getDimensions(i)])
                  );
                case 1:
                  return (
                    (y = O.sent()),
                    (b = (g = "y" === p) ? "top" : "left"),
                    (_ = g ? "bottom" : "right"),
                    (k = g ? "clientHeight" : "clientWidth"),
                    (w =
                      u.reference[m] + u.reference[p] - v[p] - u.floating[m]),
                    (S = v[p] - u.reference[p]),
                    [
                      4,
                      null == d.getOffsetParent ? void 0 : d.getOffsetParent(i),
                    ]
                  );
                case 2:
                  return (
                    (C = O.sent()),
                    (E = C ? C[k] : 0),
                    (x = !E)
                      ? [3, 4]
                      : [4, null == d.isElement ? void 0 : d.isElement(C)]
                  );
                case 3:
                  (x = !O.sent()), (O.label = 4);
                case 4:
                  return (
                    x && (E = h.floating[k] || u.floating[m]),
                    (L = w / 2 - S / 2),
                    (I = f[b]),
                    (T = E - y[m] - f[_]),
                    (A = E / 2 - y[m] / 2 + L),
                    (D = ze(I, A, T)),
                    (P =
                      null != Ie(l) &&
                      A != D &&
                      u.reference[m] / 2 - (A < I ? f[b] : f[_]) - y[m] / 2 <
                        0),
                    (M = P ? (A < I ? I - A : T - A) : 0),
                    [
                      2,
                      ((q = {}),
                      a(q, p, v[p] - M),
                      a(
                        q,
                        "data",
                        ((B = {}), a(B, p, D), a(B, "centerOffset", A - D), B)
                      ),
                      q),
                    ]
                  );
              }
            });
          })();
        },
      };
    },
    Ue = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function Ke(e) {
    return e.replace(/left|right|bottom|top/g, function (e) {
      return Ue[e];
    });
  }
  function We(e, t, n) {
    void 0 === n && (n = !1);
    var i = Ie(e),
      a = De(e),
      r = Te(a),
      o =
        "x" === a
          ? i === (n ? "end" : "start")
            ? "right"
            : "left"
          : "start" === i
          ? "bottom"
          : "top";
    return (
      t.reference[r] > t.floating[r] && (o = Ke(o)), { main: o, cross: Ke(o) }
    );
  }
  var je = { start: "end", end: "start" };
  function Ye(e) {
    return e.replace(/start|end/g, function (e) {
      return je[e];
    });
  }
  var Xe = function (e) {
    return (
      void 0 === e && (e = {}),
      {
        name: "flip",
        options: e,
        fn: function (t) {
          return Ce(function () {
            var n,
              i,
              a,
              r,
              o,
              s,
              c,
              l,
              u,
              d,
              h,
              f,
              v,
              p,
              m,
              y,
              g,
              b,
              _,
              k,
              w,
              S,
              C,
              E,
              x,
              I,
              T,
              A,
              D,
              P,
              M,
              B,
              q,
              O,
              R,
              N,
              F,
              V;
            return Le(this, function (z) {
              switch (z.label) {
                case 0:
                  return (
                    (a = t.placement),
                    (r = t.middlewareData),
                    (o = t.rects),
                    (s = t.initialPlacement),
                    (c = t.platform),
                    (l = t.elements),
                    (u = e.mainAxis),
                    (d = void 0 === u || u),
                    (h = e.crossAxis),
                    (f = void 0 === h || h),
                    (v = e.fallbackPlacements),
                    (p = e.fallbackStrategy),
                    (m = void 0 === p ? "bestFit" : p),
                    (y = e.fallbackAxisSideDirection),
                    (g = void 0 === y ? "none" : y),
                    (b = e.flipAlignment),
                    (_ = void 0 === b || b),
                    (k = xe(e, [
                      "mainAxis",
                      "crossAxis",
                      "fallbackPlacements",
                      "fallbackStrategy",
                      "fallbackAxisSideDirection",
                      "flipAlignment",
                    ])),
                    (w = Ae(a)),
                    (S = Ae(s) === s),
                    [4, null == c.isRTL ? void 0 : c.isRTL(l.floating)]
                  );
                case 1:
                  return (
                    (C = z.sent()),
                    (E =
                      v ||
                      (S || !_
                        ? [Ke(s)]
                        : (function (e) {
                            var t = Ke(e);
                            return [Ye(e), t, Ye(t)];
                          })(s))),
                    v ||
                      "none" === g ||
                      (n = E).push.apply(
                        n,
                        L(
                          (function (e, t, n, i) {
                            var a = Ie(e),
                              r = (function (e, t, n) {
                                var i = ["left", "right"],
                                  a = ["right", "left"];
                                switch (e) {
                                  case "top":
                                  case "bottom":
                                    return n ? (t ? a : i) : t ? i : a;
                                  case "left":
                                  case "right":
                                    return t
                                      ? ["top", "bottom"]
                                      : ["bottom", "top"];
                                  default:
                                    return [];
                                }
                              })(Ae(e), "start" === n, i);
                            return (
                              a &&
                                ((r = r.map(function (e) {
                                  return e + "-" + a;
                                })),
                                t && (r = r.concat(r.map(Ye)))),
                              r
                            );
                          })(s, _, g, C)
                        )
                      ),
                    (x = [s].concat(L(E))),
                    [4, Re(t, k)]
                  );
                case 2:
                  if (
                    ((I = z.sent()),
                    (T = []),
                    (A = (null == (i = r.flip) ? void 0 : i.overflows) || []),
                    d && T.push(I[w]),
                    f &&
                      ((D = We(a, o, C)),
                      (P = D.main),
                      (M = D.cross),
                      T.push(I[P], I[M])),
                    (A = L(A).concat([{ placement: a, overflows: T }])),
                    !T.every(function (e) {
                      return e <= 0;
                    }))
                  ) {
                    if (
                      ((O =
                        ((null == (B = r.flip) ? void 0 : B.index) || 0) + 1),
                      (R = x[O]))
                    )
                      return [
                        2,
                        {
                          data: { index: O, overflows: A },
                          reset: { placement: R },
                        },
                      ];
                    if (
                      !(N =
                        null ==
                        (q = A.filter(function (e) {
                          return e.overflows[0] <= 0;
                        }).sort(function (e, t) {
                          return e.overflows[1] - t.overflows[1];
                        })[0])
                          ? void 0
                          : q.placement)
                    )
                      switch (m) {
                        case "bestFit":
                          (V =
                            null ==
                            (F = A.map(function (e) {
                              return [
                                e.placement,
                                e.overflows
                                  .filter(function (e) {
                                    return e > 0;
                                  })
                                  .reduce(function (e, t) {
                                    return e + t;
                                  }, 0),
                              ];
                            }).sort(function (e, t) {
                              return e[1] - t[1];
                            })[0])
                              ? void 0
                              : F[0]),
                            V && (N = V);
                          break;
                        case "initialPlacement":
                          N = s;
                      }
                    if (a !== N) return [2, { reset: { placement: N } }];
                  }
                  return [2, {}];
              }
            });
          })();
        },
      }
    );
  };
  function Qe(e, t) {
    return Ge.apply(this, arguments);
  }
  function Ge() {
    return (
      (Ge = Ce(function (e, t) {
        var n, i, a, o, s, c, l, u, d, h, f, v, p, m;
        return Le(this, function (y) {
          switch (y.label) {
            case 0:
              return (
                (n = e.placement),
                (i = e.platform),
                (a = e.elements),
                [4, null == i.isRTL ? void 0 : i.isRTL(a.floating)]
              );
            case 1:
              return (
                (o = y.sent()),
                (s = Ae(n)),
                (c = Ie(n)),
                (l = "x" === De(n)),
                (u = ["left", "top"].includes(s) ? -1 : 1),
                (d = o && l ? -1 : 1),
                (h = "function" == typeof t ? t(e) : t),
                (f =
                  "number" == typeof h
                    ? { mainAxis: h, crossAxis: 0, alignmentAxis: null }
                    : r({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, h)),
                (v = f.mainAxis),
                (p = f.crossAxis),
                (m = f.alignmentAxis),
                c && "number" == typeof m && (p = "end" === c ? -1 * m : m),
                [2, l ? { x: p * d, y: v * u } : { x: v * u, y: p * d }]
              );
          }
        });
      })),
      Ge.apply(this, arguments)
    );
  }
  var Ze = function (e) {
    return (
      void 0 === e && (e = 0),
      {
        name: "offset",
        options: e,
        fn: function (t) {
          return Ce(function () {
            var n, i, a;
            return Le(this, function (r) {
              switch (r.label) {
                case 0:
                  return (n = t.x), (i = t.y), [4, Qe(t, e)];
                case 1:
                  return (
                    (a = r.sent()), [2, { x: n + a.x, y: i + a.y, data: a }]
                  );
              }
            });
          })();
        },
      }
    );
  };
  function Je(e) {
    return "x" === e ? "y" : "x";
  }
  var $e,
    et = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          name: "shift",
          options: e,
          fn: function (t) {
            return Ce(function () {
              var n,
                i,
                s,
                c,
                l,
                u,
                d,
                h,
                f,
                v,
                p,
                m,
                y,
                g,
                b,
                _,
                k,
                w,
                S,
                C,
                E,
                x,
                L,
                I;
              return Le(this, function (T) {
                switch (T.label) {
                  case 0:
                    return (
                      (n = t.x),
                      (i = t.y),
                      (s = t.placement),
                      (c = e.mainAxis),
                      (l = void 0 === c || c),
                      (u = e.crossAxis),
                      (d = void 0 !== u && u),
                      (h = e.limiter),
                      (f =
                        void 0 === h
                          ? {
                              fn: function (e) {
                                return { x: e.x, y: e.y };
                              },
                            }
                          : h),
                      (v = xe(e, ["mainAxis", "crossAxis", "limiter"])),
                      (p = { x: n, y: i }),
                      [4, Re(t, v)]
                    );
                  case 1:
                    return (
                      (m = T.sent()),
                      (y = De(Ae(s))),
                      (g = Je(y)),
                      (b = p[y]),
                      (_ = p[g]),
                      l &&
                        ((k = "y" === y ? "bottom" : "right"),
                        (w = b + m["y" === y ? "top" : "left"]),
                        (S = b - m[k]),
                        (b = ze(w, b, S))),
                      d &&
                        ((C = "y" === g ? "bottom" : "right"),
                        (E = _ + m["y" === g ? "top" : "left"]),
                        (x = _ - m[C]),
                        (_ = ze(E, _, x))),
                      (I = f.fn(
                        o(r({}, t), (a((L = {}), y, b), a(L, g, _), L))
                      )),
                      [2, o(r({}, I), { data: { x: I.x - n, y: I.y - i } })]
                    );
                }
              });
            })();
          },
        }
      );
    };
  function tt(e) {
    var t;
    return (null == (t = e.ownerDocument) ? void 0 : t.defaultView) || window;
  }
  function nt(e) {
    return tt(e).getComputedStyle(e);
  }
  function it(e) {
    return e instanceof tt(e).Node;
  }
  function at(e) {
    return it(e) ? (e.nodeName || "").toLowerCase() : "";
  }
  function rt() {
    if ($e) return $e;
    var e = navigator.userAgentData;
    return e && Array.isArray(e.brands)
      ? ($e = e.brands
          .map(function (e) {
            return e.brand + "/" + e.version;
          })
          .join(" "))
      : navigator.userAgent;
  }
  function ot(e) {
    return e instanceof tt(e).HTMLElement;
  }
  function st(e) {
    return e instanceof tt(e).Element;
  }
  function ct(e) {
    return (
      "undefined" != typeof ShadowRoot &&
      (e instanceof tt(e).ShadowRoot || e instanceof ShadowRoot)
    );
  }
  function lt(e) {
    var t = nt(e),
      n = t.overflow,
      i = t.overflowX,
      a = t.overflowY,
      r = t.display;
    return (
      /auto|scroll|overlay|hidden|clip/.test(n + a + i) &&
      !["inline", "contents"].includes(r)
    );
  }
  function ut(e) {
    return ["table", "td", "th"].includes(at(e));
  }
  function dt(e) {
    var t = /firefox/i.test(rt()),
      n = nt(e),
      i = n.backdropFilter || n.WebkitBackdropFilter;
    return (
      "none" !== n.transform ||
      "none" !== n.perspective ||
      (!!i && "none" !== i) ||
      (t && "filter" === n.willChange) ||
      (t && !!n.filter && "none" !== n.filter) ||
      ["transform", "perspective"].some(function (e) {
        return n.willChange.includes(e);
      }) ||
      ["paint", "layout", "strict", "content"].some(function (e) {
        var t = n.contain;
        return null != t && t.includes(e);
      })
    );
  }
  function ht() {
    return /^((?!chrome|android).)*safari/i.test(rt());
  }
  function ft(e) {
    return ["html", "body", "#document"].includes(at(e));
  }
  var vt = Math.min,
    pt = Math.max,
    mt = Math.round;
  function yt(e) {
    var t = nt(e),
      n = parseFloat(t.width),
      i = parseFloat(t.height),
      a = ot(e),
      r = a ? e.offsetWidth : n,
      o = a ? e.offsetHeight : i,
      s = mt(n) !== r || mt(i) !== o;
    return s && ((n = r), (i = o)), { width: n, height: i, fallback: s };
  }
  function gt(e) {
    return st(e) ? e : e.contextElement;
  }
  var bt = { x: 1, y: 1 };
  function _t(e) {
    var t = gt(e);
    if (!ot(t)) return bt;
    var n = t.getBoundingClientRect(),
      i = yt(t),
      a = i.width,
      r = i.height,
      o = i.fallback,
      s = (o ? mt(n.width) : n.width) / a,
      c = (o ? mt(n.height) : n.height) / r;
    return (
      (s && Number.isFinite(s)) || (s = 1),
      (c && Number.isFinite(c)) || (c = 1),
      { x: s, y: c }
    );
  }
  function kt(e, t, n, i) {
    var a, r;
    void 0 === t && (t = !1), void 0 === n && (n = !1);
    var o = e.getBoundingClientRect(),
      s = gt(e),
      c = bt;
    t && (i ? st(i) && (c = _t(i)) : (c = _t(e)));
    var l = s ? tt(s) : window,
      u = ht() && n,
      d =
        (o.left +
          ((u && (null == (a = l.visualViewport) ? void 0 : a.offsetLeft)) ||
            0)) /
        c.x,
      h =
        (o.top +
          ((u && (null == (r = l.visualViewport) ? void 0 : r.offsetTop)) ||
            0)) /
        c.y,
      f = o.width / c.x,
      v = o.height / c.y;
    if (s)
      for (
        var p = tt(s), m = i && st(i) ? tt(i) : i, y = p.frameElement;
        y && i && m !== p;

      ) {
        var g = _t(y),
          b = y.getBoundingClientRect(),
          _ = getComputedStyle(y);
        (b.x += (y.clientLeft + parseFloat(_.paddingLeft)) * g.x),
          (b.y += (y.clientTop + parseFloat(_.paddingTop)) * g.y),
          (d *= g.x),
          (h *= g.y),
          (f *= g.x),
          (v *= g.y),
          (d += b.x),
          (h += b.y),
          (y = tt(y).frameElement);
      }
    return Oe({ width: f, height: v, x: d, y: h });
  }
  function wt(e) {
    return ((it(e) ? e.ownerDocument : e.document) || window.document)
      .documentElement;
  }
  function St(e) {
    return st(e)
      ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop }
      : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
  }
  function Ct(e) {
    return kt(wt(e)).left + St(e).scrollLeft;
  }
  function Et(e) {
    if ("html" === at(e)) return e;
    var t = e.assignedSlot || e.parentNode || (ct(e) && e.host) || wt(e);
    return ct(t) ? t.host : t;
  }
  function xt(e) {
    var t = Et(e);
    return ft(t) ? t.ownerDocument.body : ot(t) && lt(t) ? t : xt(t);
  }
  function Lt(e, t) {
    var n;
    void 0 === t && (t = []);
    var i = xt(e),
      a = i === (null == (n = e.ownerDocument) ? void 0 : n.body),
      r = tt(i);
    return a
      ? t.concat(r, r.visualViewport || [], lt(i) ? i : [])
      : t.concat(i, Lt(i));
  }
  function It(e, t, n) {
    var i;
    if ("viewport" === t)
      i = (function (e, t) {
        var n = tt(e),
          i = wt(e),
          a = n.visualViewport,
          r = i.clientWidth,
          o = i.clientHeight,
          s = 0,
          c = 0;
        if (a) {
          (r = a.width), (o = a.height);
          var l = ht();
          (!l || (l && "fixed" === t)) &&
            ((s = a.offsetLeft), (c = a.offsetTop));
        }
        return { width: r, height: o, x: s, y: c };
      })(e, n);
    else if ("document" === t)
      i = (function (e) {
        var t = wt(e),
          n = St(e),
          i = e.ownerDocument.body,
          a = pt(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth),
          r = pt(
            t.scrollHeight,
            t.clientHeight,
            i.scrollHeight,
            i.clientHeight
          ),
          o = -n.scrollLeft + Ct(e),
          s = -n.scrollTop;
        return (
          "rtl" === nt(i).direction &&
            (o += pt(t.clientWidth, i.clientWidth) - a),
          { width: a, height: r, x: o, y: s }
        );
      })(wt(e));
    else if (st(t))
      i = (function (e, t) {
        var n = kt(e, !0, "fixed" === t),
          i = n.top + e.clientTop,
          a = n.left + e.clientLeft,
          r = ot(e) ? _t(e) : { x: 1, y: 1 };
        return {
          width: e.clientWidth * r.x,
          height: e.clientHeight * r.y,
          x: a * r.x,
          y: i * r.y,
        };
      })(t, n);
    else {
      var a = r({}, t);
      if (ht()) {
        var o,
          s,
          c = tt(e);
        (a.x -= (null == (o = c.visualViewport) ? void 0 : o.offsetLeft) || 0),
          (a.y -= (null == (s = c.visualViewport) ? void 0 : s.offsetTop) || 0);
      }
      i = a;
    }
    return Oe(i);
  }
  function Tt(e, t) {
    var n = Et(e);
    return (
      !(n === t || !st(n) || ft(n)) && ("fixed" === nt(n).position || Tt(n, t))
    );
  }
  function At(e, t) {
    return ot(e) && "fixed" !== nt(e).position
      ? t
        ? t(e)
        : e.offsetParent
      : null;
  }
  function Dt(e, t) {
    var n = tt(e);
    if (!ot(e)) return n;
    for (var i = At(e, t); i && ut(i) && "static" === nt(i).position; )
      i = At(i, t);
    return i &&
      ("html" === at(i) ||
        ("body" === at(i) && "static" === nt(i).position && !dt(i)))
      ? n
      : i ||
          (function (e) {
            for (var t = Et(e); ot(t) && !ft(t); ) {
              if (dt(t)) return t;
              t = Et(t);
            }
            return null;
          })(e) ||
          n;
  }
  function Pt(e, t, n) {
    var i = ot(t),
      a = wt(t),
      r = kt(e, !0, "fixed" === n, t),
      o = { scrollLeft: 0, scrollTop: 0 },
      s = { x: 0, y: 0 };
    if (i || (!i && "fixed" !== n))
      if ((("body" !== at(t) || lt(a)) && (o = St(t)), ot(t))) {
        var c = kt(t, !0);
        (s.x = c.x + t.clientLeft), (s.y = c.y + t.clientTop);
      } else a && (s.x = Ct(a));
    return {
      x: r.left + o.scrollLeft - s.x,
      y: r.top + o.scrollTop - s.y,
      width: r.width,
      height: r.height,
    };
  }
  var Mt = {
    getClippingRect: function (e) {
      var t = e.element,
        n = e.boundary,
        i = e.rootBoundary,
        a = e.strategy,
        r = L(
          "clippingAncestors" === n
            ? (function (e, t) {
                var n = t.get(e);
                if (n) return n;
                for (
                  var i = Lt(e).filter(function (e) {
                      return st(e) && "body" !== at(e);
                    }),
                    a = null,
                    r = "fixed" === nt(e).position,
                    o = r ? Et(e) : e;
                  st(o) && !ft(o);

                ) {
                  var s = nt(o),
                    c = dt(o);
                  c || "fixed" !== s.position || (a = null),
                    (
                      r
                        ? !c && !a
                        : (!c &&
                            "static" === s.position &&
                            a &&
                            ["absolute", "fixed"].includes(a.position)) ||
                          (lt(o) && !c && Tt(e, o))
                    )
                      ? (i = i.filter(function (e) {
                          return e !== o;
                        }))
                      : (a = s),
                    (o = Et(o));
                }
                return t.set(e, i), i;
              })(t, this._c)
            : [].concat(n)
        ).concat([i]),
        o = r[0],
        s = r.reduce(function (e, n) {
          var i = It(t, n, a);
          return (
            (e.top = pt(i.top, e.top)),
            (e.right = vt(i.right, e.right)),
            (e.bottom = vt(i.bottom, e.bottom)),
            (e.left = pt(i.left, e.left)),
            e
          );
        }, It(t, o, a));
      return {
        width: s.right - s.left,
        height: s.bottom - s.top,
        x: s.left,
        y: s.top,
      };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
      var t = e.rect,
        n = e.offsetParent,
        i = e.strategy,
        a = ot(n),
        r = wt(n);
      if (n === r) return t;
      var o = { scrollLeft: 0, scrollTop: 0 },
        s = { x: 1, y: 1 },
        c = { x: 0, y: 0 };
      if (
        (a || (!a && "fixed" !== i)) &&
        (("body" !== at(n) || lt(r)) && (o = St(n)), ot(n))
      ) {
        var l = kt(n);
        (s = _t(n)), (c.x = l.x + n.clientLeft), (c.y = l.y + n.clientTop);
      }
      return {
        width: t.width * s.x,
        height: t.height * s.y,
        x: t.x * s.x - o.scrollLeft * s.x + c.x,
        y: t.y * s.y - o.scrollTop * s.y + c.y,
      };
    },
    isElement: st,
    getDimensions: function (e) {
      return yt(e);
    },
    getOffsetParent: Dt,
    getDocumentElement: wt,
    getScale: _t,
    getElementRects: function (e) {
      return Ce(function () {
        var t, n, i, a, o, s, c, l;
        return Le(this, function (u) {
          switch (u.label) {
            case 0:
              return (
                (t = e.reference),
                (n = e.floating),
                (i = e.strategy),
                (a = this.getOffsetParent || Dt),
                (o = this.getDimensions),
                (s = {}),
                (c = [t]),
                [4, a(n)]
              );
            case 1:
              return (
                (s.reference = Pt.apply(void 0, c.concat([u.sent(), i]))),
                (l = [{ x: 0, y: 0 }]),
                [4, o(n)]
              );
            case 2:
              return [
                2,
                ((s.floating = r.apply(void 0, l.concat([u.sent()]))), s),
              ];
          }
        });
      }).apply(this);
    },
    getClientRects: function (e) {
      return Array.from(e.getClientRects());
    },
    isRTL: function (e) {
      return "rtl" === nt(e).direction;
    },
  };
  function Bt(e, t, n, i) {
    void 0 === i && (i = {});
    var a = i.ancestorScroll,
      r = void 0 === a || a,
      o = i.ancestorResize,
      s = void 0 === o || o,
      c = i.elementResize,
      l = void 0 === c || c,
      u = i.animationFrame,
      d = void 0 !== u && u,
      h =
        r || s
          ? L(
              st(e) ? Lt(e) : e.contextElement ? Lt(e.contextElement) : []
            ).concat(L(Lt(t)))
          : [];
    h.forEach(function (e) {
      var t = !st(e) && e.toString().includes("V");
      !r || (d && !t) || e.addEventListener("scroll", n, { passive: !0 }),
        s && e.addEventListener("resize", n);
    });
    var f,
      v = null;
    l &&
      ((v = new ResizeObserver(function () {
        n();
      })),
      st(e) && !d && v.observe(e),
      st(e) || !e.contextElement || d || v.observe(e.contextElement),
      v.observe(t));
    var p = d ? kt(e) : null;
    return (
      d &&
        (function t() {
          var i = kt(e);
          !p ||
            (i.x === p.x &&
              i.y === p.y &&
              i.width === p.width &&
              i.height === p.height) ||
            n();
          (p = i), (f = requestAnimationFrame(t));
        })(),
      n(),
      function () {
        var e;
        h.forEach(function (e) {
          r && e.removeEventListener("scroll", n),
            s && e.removeEventListener("resize", n);
        }),
          null == (e = v) || e.disconnect(),
          (v = null),
          d && cancelAnimationFrame(f);
      }
    );
  }
  var qt = function (e, t, n) {
      var i = new Map(),
        a = r({ platform: Mt }, n),
        s = o(r({}, a.platform), { _c: i });
      return Be(e, t, o(r({}, a), { platform: s }));
    },
    Ot = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "setCollectionPage", function (t) {
            if (t) {
              var n = JSON.parse(t);
              e.collectionLink &&
                ((e.collectionLink.href = n.url),
                (e.collectionLink.ariaLabel = n.title),
                (e.collectionLink.textContent = n.title));
            }
          }),
          (e.collectionLinkSelector = "[data-collection-link]"),
          (e.collectionLink = e.querySelector(e.collectionLinkSelector)),
          e
        );
      }
      return n;
    })(ne),
    Rt = (function () {
      "use strict";
      function e(t) {
        m(this, e), (this._notification = t);
      }
      return (
        g(e, [
          {
            key: "show",
            value: function (e, t) {
              this._notification.show(e, t);
            },
          },
        ]),
        e
      );
    })(),
    Nt = new ((function () {
      "use strict";
      function e() {
        var t = this;
        m(this, e),
          a(this, "_handleWindowScroll", function () {
            t._timeoutScrollId &&
              (clearTimeout(t._timeoutScrollId), (t.isScrolling = !0)),
              (t._timeoutScrollId = setTimeout(function () {
                t.isScrolling = !1;
              }, 300));
          }),
          a(this, "_setBreadcrumbs", function () {
            var e = document.querySelectorAll("product-breadcrumbs");
            if (e.length) {
              var t = localStorage.getItem("prevCollectionPage");
              e.forEach(function (e) {
                e.setCollectionPage(t);
              }),
                localStorage.removeItem("prevCollectionPage");
            }
          });
        var n = document.querySelector("#GlobalNotification");
        n && (this.notification = new Rt(n)),
          (this.isScrolling = !1),
          (this.overlaySelector = "#BodyOverlay"),
          window.addEventListener("wheel", this._handleWindowScroll),
          (this.overlayCalls = []),
          window.location.pathname.includes("products") &&
            (customElements.define("product-breadcrumbs", Ot),
            this._setBreadcrumbs());
      }
      return (
        g(e, [
          {
            key: "showOverlay",
            value: function (e, t) {
              var n = document.querySelector(this.overlaySelector);
              n &&
                ((this.overlayCalls = L(this.overlayCalls).concat([
                  { key: e, styles: t },
                ])),
                this.setBodyOverlayStyles(
                  r(
                    {},
                    { zIndex: 3, backgroundColor: "var(--gsc-black-color-50)" },
                    t
                  )
                ),
                n.setAttribute("visible", ""),
                this.setScrollLock());
            },
          },
          {
            key: "hideOverlay",
            value: function (e) {
              var t = document.querySelector(this.overlaySelector);
              if (t && t.hasAttribute("visible")) {
                this.overlayCalls = this.overlayCalls.filter(function (t) {
                  return t.key !== e;
                });
                var n = this.overlayCalls[this.overlayCalls.length - 1];
                n
                  ? this.setBodyOverlayStyles(n.styles)
                  : (t.removeAttribute("visible"),
                    t.setAttribute("style", ""),
                    this.unsetScrollLock());
              }
            },
          },
          {
            key: "setScrollLock",
            value: function () {
              (document.body.style.top = "-".concat(
                window.scrollY ||
                  Math.abs(parseInt(document.body.style.top || "0")),
                "px"
              )),
                document.body.setAttribute("scroll-y-off", "");
            },
          },
          {
            key: "unsetScrollLock",
            value: function () {
              var e = document.body.style.top;
              document.body.removeAttribute("scroll-y-off"),
                (document.body.style.top = ""),
                window.scrollTo(0, -1 * parseInt(e || "0"));
            },
          },
          {
            key: "setBodyOverlayStyles",
            value: function (e) {
              var t = document.querySelector(this.overlaySelector);
              t &&
                e &&
                Object.keys(e).forEach(function (n) {
                  t.style[n] = e[n];
                });
            },
          },
          {
            key: "isFixed",
            get: function () {
              return document.body.hasAttribute("scroll-y-off");
            },
          },
        ]),
        e
      );
    })())(),
    Ft = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        m(this, n),
          a(p((e = t.call(this))), "_handleScroll", function () {
            "tooltip" === e._type &&
              (e.hide(), U(window, "wheel", e._handleScroll));
          }),
          a(p(e), "_handleBlockSelect", function (t) {
            if (e.dataset.sectionId === t.detail.sectionId) {
              var n = e.element.querySelector(
                '[block-id="'.concat(t.detail.blockId, '"]')
              );
              if (!(e.getAttribute("block-id") === t.detail.blockId || n))
                return;
              e._btn ? e._btn.trigger() : e.hide();
            }
          }),
          a(p(e), "_handleBlockDeselect", function (t) {
            if (e.dataset.sectionId === t.detail.sectionId) {
              var n = e.element.querySelector(
                '[block-id="'.concat(t.detail.blockId, '"]')
              );
              if (!(e.getAttribute("block-id") === t.detail.blockId || n))
                return;
              e.hide();
            }
          }),
          a(p(e), "init", function () {
            var t =
              document.querySelector("#".concat(e.dataset.floatingElementId)) ||
              e._btn;
            t &&
              Bt(t, p(e), function () {
                qt(t, e, e._getOptions()).then(function (t) {
                  e.dataset.placement !== t.placement &&
                    (e.dataset.placement = t.placement),
                    e._updatePosition(t),
                    e._arrow && e._updateArrow(t);
                });
              });
          }),
          a(p(e), "show", function () {

            // Storyside check is this what fires for nav
            // console.log("Storyside show function on floating-element");

            ("tooltip" === e._type && Nt.isScrolling) ||
              (e.element.querySelectorAll("video").forEach(function (e) {
                e.play();
              }),
              e._mount(),
              e._setVisible(!0),
              e.emit("show", {}),
              H(window, "wheel", e._handleScroll));
          }),
          a(p(e), "hide", function () {

            // Storyside check is this what fires for nav
            // console.log("Storyside hide function on floating-element");
            
            e._setVisible(!1),
              e._unmount(),
              e.emit("hide", {}),
              (e.dataset.placement = e._initialPlacement);
          }),
          (e._withOverlay = e.hasAttribute("data-with-overlay"));
        var i,
          r,
          o,
          s = e.querySelector("template");
        return (
          (e.element = pe(s)),
          (e._arrow = e.element.querySelector("[data-float-element-arrow]")),
          (e.withPortal = e.hasAttribute("with-portal")),
          (e._initialPlacement = e.dataset.placement),
          e.withPortal &&
            ((i = p(e)),
            (o = document.getElementById("Portal")).appendChild(i),
            (r && r.appendChild ? r : document.body).appendChild(o)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.init(),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._unmount(),
                this._isEditorMode && this._editor.destroy(),
                U(window, "wheel", this._handleScroll);
            },
          },
          {
            key: "_updatePosition",
            value: function (e) {
              var t = e.x,
                n = e.y;
              Object.assign(this.style, {
                left: "".concat(t, "px"),
                top: "".concat(n, "px"),
              });
            },
          },
          {
            key: "_getOptions",
            value: function () {
              return {
                placement: this.dataset.placement,
                middleware: this._getMiddleware(),
                strategy: this._strategy,
              };
            },
          },
          {
            key: "_getMiddleware",
            value: function () {
              var e = this.dataset.alignmentAxisOffset || 0,
                t = this.dataset.mainAxisOffset || 0,
                n = [Ze({ alignmentAxis: +e, mainAxis: +t }), Xe(), et()];
              return this._arrow && n.push(He({ element: this._arrow })), n;
            },
          },
          {
            key: "checkCursorOutside",
            value: function (e, t) {
              var n = +(this.dataset.mainAxisOffset || 0),
                i = this.getBoundingClientRect(),
                a = i.top - (t + n) > 2,
                r = t - i.bottom - n > 2,
                o = i.left - (e + n) > 2,
                s = e - i.right - n > 2;
              return a || r || o || s;
            },
          },
          {
            key: "_updateArrow",
            value: function (e) {
              var t = e.placement,
                n = e.middlewareData;
              if (this._arrow) {
                var i = n.arrow,
                  r = i.x,
                  o = i.y,
                  s = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right",
                  }[t.split("-")[0]];
                Object.assign(
                  this._arrow.style,
                  a(
                    {
                      left: null != r ? "".concat(r, "px") : "",
                      top: null != o ? "".concat(o, "px") : "",
                      right: "",
                      bottom: "",
                    },
                    s,
                    "-5px"
                  )
                );
              }
            },
          },
          {
            key: "_mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.isOpen && this._withOverlay && Nt.hideOverlay(this.id),
                this.element && this.element.remove();
            },
          },
          {
            key: "_setVisible",
            value: function (e) {

              // Storyside check if this runs on every mega-menu dropdown open 
              // Could use this to set a body close to note that drawer is open
              // console.log("Storyside _setVisible", e);

              if (
                (this.setAttribute("aria-hidden", e ? "false" : "true"),
                this._btn && this._btn.setExpand(e),
                this._withOverlay)
              ) {
                var t = {
                  backdropFilter: this.hasAttribute("data-overlay-with-blur")
                    ? "blur(16.5px)"
                    : "none",
                };
                this.isOpen
                  ? Nt.showOverlay(this.id, t)
                  : Nt.hideOverlay(this.id);
              }
            },
          },
          {
            key: "_btn",
            get: function () {
              return document.querySelector(
                '[data-float-element-id="'
                  .concat(this.id, '"], [data-tooltip-id="')
                  .concat(this.id, '"]')
              );
            },
          },
          {
            key: "isOpen",
            get: function () {
              return "false" === this.getAttribute("aria-hidden");
            },
          },
          {
            key: "_strategy",
            get: function () {
              return this.dataset.strategy || "absolute";
            },
          },
          {
            key: "_type",
            get: function () {
              return this.dataset.type;
            },
          },
        ]),
        n
      );
    })(ne),
    Vt = Ft;
  function zt(e) {
    if (Array.isArray(e)) return e;
  }
  function Ht() {
    throw new TypeError(
      "Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
  function Ut(e, t) {
    return zt(e) || C(e) || x(e, t) || Ht();
  }
  var Kt = "http://www.w3.org/2000/svg",
    Wt = function (e, t) {
      return !(!e || !t) && e.contains(t);
    },
    jt = function (e, t) {
      var n,
        i,
        a = /apple/i.test(navigator.vendor),
        r = document.defaultView || window,
        o = document.createElementNS(Kt, "svg");
      Object.assign(o.style, {
        position: "fixed",
        left: "".concat(
          (a &&
            (null === (n = r.visualViewport) || void 0 === n
              ? void 0
              : n.offsetLeft)) ||
            0,
          "px"
        ),
        top: "".concat(
          (a &&
            (null === (i = r.visualViewport) || void 0 === i
              ? void 0
              : i.offsetTop)) ||
            0,
          "px"
        ),
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 2147483647,
      }),
        o.setAttribute("data-type", t ? "rect" : "triangle");
      var s = document.createElementNS(Kt, "polygon");
      return (
        s.setAttribute(
          "points",
          e
            .map(function (e) {
              var t = Ut(e, 2),
                n = t[0],
                i = t[1];
              return "".concat(n, ",").concat(i);
            })
            .join(" ")
        ),
        Object.assign(s.style, {
          pointerEvents: "auto",
          fill: "transparent",
          opacity: 0,
        }),
        o.appendChild(s),
        o
      );
    },
    Yt = function (e) {
      e.current && (e.current.remove(), (e.current = null));
    },
    Xt = function () {
      var e,
        t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = t.restMs,
        i = void 0 === n ? 0 : n,
        a = t.buffer,
        r = void 0 === a ? 0.5 : a,
        o = t.blockPointerEvents,
        s = void 0 === o || o,
        c = !1,
        l = !1;
      return function (t) {
        var n = t.x,
          a = t.y,
          o = t.placement,
          u = t.elements,
          d = t.onClose,
          h = t.polygonRef;
        return function (t) {
          var f,
            v = function () {
              Yt(h), clearTimeout(e), d();
            };
          if (
            (clearTimeout(e),
            u.domReference && u.floating && null != o && null != n && null != a)
          ) {
            var p,
              m = t.clientX,
              y = t.clientY,
              g = t.target,
              b = "mouseleave" === t.type,
              _ = Wt(u.domReference, g),
              k = Wt(u.floating, g);
            if (b || !_) {
              if (b || !(_ || (c && Wt(h.current, g))))
                if (
                  !(
                    b &&
                    ((p = t.relatedTarget),
                    p &&
                      p instanceof (document.defaultView || window).Element) &&
                    Wt(u.floating, t.relatedTarget)
                  )
                )
                  if (
                    !u.floating.querySelector(
                      'float-element[aria-hidden="false"]'
                    )
                  )
                    if (
                      (k && (l = !0),
                      !k ||
                        b ||
                        "rect" ===
                          (null === (f = h.current) || void 0 === f
                            ? void 0
                            : f.dataset.type))
                    ) {
                      var w = u.domReference.getBoundingClientRect(),
                        S = u.floating.getBoundingClientRect(),
                        C = o.split("-")[0],
                        E = n > S.right - S.width / 2,
                        x = a > S.bottom - S.height / 2;
                      if (
                        ("top" === C && a >= w.bottom - 1) ||
                        ("bottom" === C && a <= w.top + 1) ||
                        ("left" === C && n >= w.right - 1) ||
                        ("right" === C && n <= w.left + 1)
                      )
                        return v();
                      var I = [];
                      switch (C) {
                        case "top":
                          (I = [
                            [S.left, w.top + 1],
                            [S.left, S.bottom - 1],
                            [S.right, S.bottom - 1],
                            [S.right, w.top + 1],
                          ]),
                            (c =
                              m >= S.left &&
                              m <= S.right &&
                              y >= S.top &&
                              y <= w.top + 1);
                          break;
                        case "bottom":
                          (I = [
                            [S.left, S.top + 1],
                            [S.left, w.bottom - 1],
                            [S.right, w.bottom - 1],
                            [S.right, S.top + 1],
                          ]),
                            (c =
                              m >= S.left &&
                              m <= S.right &&
                              y >= w.bottom - 1 &&
                              y <= S.bottom);
                          break;
                        case "left":
                          (I = [
                            [S.right - 1, S.bottom],
                            [S.right - 1, S.top],
                            [w.left + 1, S.top],
                            [w.left + 1, S.bottom],
                          ]),
                            (c =
                              m >= S.left &&
                              m <= w.left + 1 &&
                              y >= S.top &&
                              y <= S.bottom);
                          break;
                        case "right":
                          (I = [
                            [w.right - 1, S.bottom],
                            [w.right - 1, S.top],
                            [S.left + 1, S.top],
                            [S.left + 1, S.bottom],
                          ]),
                            (c =
                              m >= w.right - 1 &&
                              m <= S.right &&
                              y >= S.top &&
                              y <= S.bottom);
                      }
                      var T = c
                        ? I
                        : (function (e) {
                            var t = Ut(e, 2),
                              n = t[0],
                              i = t[1],
                              a = S.width > w.width,
                              o = S.height > w.height;
                            switch (C) {
                              case "top":
                                var s = [
                                    a ? n + r / 2 : E ? n + 4 * r : n - 4 * r,
                                    i + r + 1,
                                  ],
                                  c = [
                                    a ? n - r / 2 : E ? n + 4 * r : n - 4 * r,
                                    i + r + 1,
                                  ],
                                  l = [
                                    [S.left, E || a ? S.bottom - r : S.top],
                                    [
                                      S.right,
                                      E
                                        ? a
                                          ? S.bottom - r
                                          : S.top
                                        : S.bottom - r,
                                    ],
                                  ];
                                return [s, c].concat(L(l));
                              case "bottom":
                                var u = [
                                    a ? n + r / 2 : E ? n + 4 * r : n - 4 * r,
                                    i - r,
                                  ],
                                  d = [
                                    a ? n - r / 2 : E ? n + 4 * r : n - 4 * r,
                                    i - r,
                                  ],
                                  h = [
                                    [S.left, E || a ? S.top + r : S.bottom],
                                    [
                                      S.right,
                                      E
                                        ? a
                                          ? S.top + r
                                          : S.bottom
                                        : S.top + r,
                                    ],
                                  ];
                                return [u, d].concat(L(h));
                              case "left":
                                var f = [
                                    n + r + 1,
                                    o ? i + r / 2 : x ? i + 4 * r : i - 4 * r,
                                  ],
                                  v = [
                                    n + r + 1,
                                    o ? i - r / 2 : x ? i + 4 * r : i - 4 * r,
                                  ];
                                return L([
                                  [x || o ? S.right - r : S.left, S.top],
                                  [
                                    x
                                      ? o
                                        ? S.right - r
                                        : S.left
                                      : S.right - r,
                                    S.bottom,
                                  ],
                                ]).concat([f, v]);
                              case "right":
                                var p = [
                                    n - r,
                                    o ? i + r / 2 : x ? i + 4 * r : i - 4 * r,
                                  ],
                                  m = [
                                    n - r,
                                    o ? i - r / 2 : x ? i + 4 * r : i - 4 * r,
                                  ],
                                  y = [
                                    [x || o ? S.left + r : S.right, S.top],
                                    [
                                      x
                                        ? o
                                          ? S.left + r
                                          : S.right
                                        : S.left + r,
                                      S.bottom,
                                    ],
                                  ];
                                return [p, m].concat(L(y));
                            }
                          })([n, a]);
                      !h.current &&
                        s &&
                        b &&
                        ((h.current = jt(T, c)),
                        document.body.appendChild(h.current)),
                        c ||
                          (!(function (e, t) {
                            for (
                              var n = Ut(e, 2),
                                i = n[0],
                                a = n[1],
                                r = !1,
                                o = t.length,
                                s = 0,
                                c = o - 1;
                              s < o;
                              c = s++
                            ) {
                              var l = Ut(t[s] || [0, 0], 2),
                                u = l[0],
                                d = l[1],
                                h = Ut(t[c] || [0, 0], 2),
                                f = h[0],
                                v = h[1];
                              d >= a != v >= a &&
                                i <= ((f - u) * (a - d)) / (v - d) + u &&
                                (r = !r);
                            }
                            return r;
                          })([m, y], T)
                            ? v()
                            : i && !l && (e = setTimeout(d, i)));
                    } else Yt(h);
            } else Yt(h);
          }
        };
      };
    },
    Qt = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleBlur", function () {
            e.blurElementTimeoutId = setTimeout(function () {
              e._floatElement && e._floatElement.hide();
            }, 0);
          }),
          a(p(e), "_handleKeyUp", function (t) {
            var n = t.key || t.keyCode;
            (n || J(n)) &&
              (e._floatElement.show(), e.setTargetListeners("add"));
          }),
          a(p(e), "_handleFirstTargetFocus", function () {
            clearTimeout(e.blurElementTimeoutId);
          }),
          a(p(e), "_handleTargetFocus", function () {
            clearTimeout(e.blurLastTargetTimeoutId);
          }),
          a(p(e), "_handleLastTargetBlur", function () {
            e.blurLastTargetTimeoutId = setTimeout(function () {
              e.setTargetListeners("remove"), e._floatElement.hide();
            }, 0);
          }),
          a(p(e), "_handleMouseEnter", function () {
            e.mouseenterTimeout = setTimeout(function () {
              e.trigger();
            }, 0);
          }),
          a(p(e), "_handleElementClick", function () {
            e.trigger();
          }),
          a(p(e), "_handleWindowClick", function (t) {
            var n = e._floatElement.checkCursorOutside(t.clientX, t.clientX),
              i = e._isTargetOutsideFloatElements(t.target);
            n &&
              i &&
              (U(window, "click", e._handleWindowClick),
              e._floatElement.hide());
          }),
          a(p(e), "_handleMouseLeave", function (t) {
            clearTimeout(e.mouseenterTimeout),
              e.safePolygonFn &&
                window.removeEventListener("mousemove", e._handleMouseMove),
              (e.safePolygonFn = Xt()({
                x: t.clientX,
                y: t.clientY,
                placement: e._floatElement.dataset.placement,
                onClose: function () {
                  window.removeEventListener("mousemove", e._handleMouseMove),
                    e._floatElement && e._floatElement.hide(),
                    Yt(e.polygonRef);
                },
                elements: {
                  domReference: e.element,
                  floating: e._floatElement,
                },
                polygonRef: e.polygonRef,
              })),
              e.safePolygonFn(t),
              window.addEventListener("mousemove", e._handleMouseMove);
          }),
          a(p(e), "_handleMouseMove", function (t) {
            e.safePolygonFn(t);
          }),
          a(p(e), "trigger", function () {

            // Storyside nav work
            // NOPE
            // console.log("Storyside click trigger on float element button", e);

            "click" === e._trigger
              ? (e._floatElement.isOpen
                  ? e._floatElement.hide()
                  : e._floatElement.show(),
                H(window, "click", e._handleWindowClick))
              : (e._floatElement.show(),
                H(e.element, "mouseleave", e._handleMouseLeave));
          }),
          (e._trigger = "click" === e.dataset.trigger ? "click" : "mouseenter"),
          (e.element = e.getElement()),
          (e.polygonRef = { current: null }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this.element, "keyup", this._handleKeyUp),
                H(this.element, "blur", this._handleBlur),
                "click" === this.dataset.trigger
                  ? (H(window, "click", this._handleWindowClick),
                    H(this.element, "click", this._handleElementClick))
                  : (H(this.element, "mouseleave", this._handleMouseLeave),
                    H(this.element, "mouseenter", this._handleMouseEnter));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this.element, "keyup", this._handleKeyUp),
                U(this.element, "blur", this._handleBlur),
                "click" === this.dataset.trigger
                  ? (U(window, "click", this._handleWindowClick),
                    U(this.element, "click", this._handleElementClick))
                  : (U(this.element, "mouseleave", this._handleMouseLeave),
                    U(this.element, "mouseenter", this._handleMouseEnter));
            },
          },
          {
            key: "setTargetListeners",
            value: function (e) {
              var t = this,
                n = this.getTargets(),
                i = n.targets,
                a = n.firstTarget,
                r = n.lastTarget,
                o = "add" === e ? H : U;
              o(a, "focus", this._handleFirstTargetFocus),
                i.forEach(function (e) {
                  o(e, "focus", t._handleTargetFocus);
                }),
                o(r, "blur", this._handleLastTargetBlur),
                o(window, "click", this._handleWindowClick);
            },
          },
          {
            key: "getElement",
            value: function () {
              var e = '[data-float-element-trigger="'.concat(
                this.dataset.floatElementId,
                '"]'
              );
              return this.querySelector(e) || this;
            },
          },
          {
            key: "getTargets",
            value: function () {
              var e = L(this._floatElement.element.querySelectorAll(W()));
              return {
                targets: e,
                firstTarget: e[0],
                lastTarget: e[e.length - 1],
              };
            },
          },
          {
            key: "_isTargetOutsideFloatElements",
            value: function (e) {
              var t = this._floatElement.contains(e),
                n = this.contains(e);
              return !t && !n;
            },
          },
          {
            key: "setExpand",
            value: function (e) {

              // Storyside
              // console.log("Storyside setExpand", e);

              this.setAttribute("data-aria-expanded", e);
            },
          },
          {
            key: "_floatElement",
            get: function () {
              if (this.dataset.floatElementId)
                return document.getElementById(this.dataset.floatElementId);
            },
          },
          {
            key: "isOpen",
            get: function () {
              return this._floatElement.isOpen;
            },
          },
        ]),
        n
      );
    })(ne);
  function Gt(e, t) {
    for (
      ;
      !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = A(e));

    );
    return e;
  }
  function Zt(e, t, n) {
    return (
      (Zt =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (e, t, n) {
              var i = Gt(e, t);
              if (i) {
                var a = Object.getOwnPropertyDescriptor(i, t);
                return a.get ? a.get.call(n || e) : a.value;
              }
            }),
      Zt(e, t, n)
    );
  }
  function Jt(e, t, n) {
    return Zt(e, t, n);
  }
  var $t = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n), ((e = t.call(this)).styles = getComputedStyle(p(e))), e
        );
      }
      return (
        g(n, [
          {
            key: "_unmount",
            value: function () {
              var e = this;
              return V($(this.styles)).then(function () {
                Jt(A(n.prototype), "_unmount", e).call(e);
              });
            },
          },
        ]),
        n
      );
    })(Vt),
    en = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleBlur", function () {
            var t = e.getTargets().targets;
            e.blurElementTimeoutId = setTimeout(function () {
              if (!t.includes(document.activeElement)) {
                if (!e._floatElement) return;
                e.setTargetListeners("remove"), e._floatElement.hide();
              }
            }, 0);
          }),
          a(p(e), "_handleDropdownShow", function () {
            H(window, "keydown", e._handleDropdownKeyDown);
          }),
          a(p(e), "_handleDropdownHide", function () {
            U(window, "keydown", e._handleDropdownKeyDown);
          }),
          a(p(e), "_handleKeyUp", function (t) {

            // Storyside nav test
            // console.log('Storyside _handleKeyUp fires for dropdown-opener', t);

            if (e._floatElement) {
              var n = t.key || t.keyCode;
              X(n) &&
                (e._floatElement.isOpen ||
                  (e._floatElement.show(), e.setTargetListeners("add")));
            }
          }),
          a(p(e), "_handleDropdownKeyDown", function (t) {
            if (e._floatElement) {
              var n = t.key || t.keyCode,
                i = Q(n);
              e._floatElement.isOpen &&
                i &&
                (e.element.focus(),
                e.setTargetListeners("remove"),
                e._floatElement.hide());
            }
          }),
          a(p(e), "_handleFirstTargetFocus", function () {
            clearTimeout(e.blurElementTimeoutId);
          }),
          a(p(e), "_handleTargetFocus", function () {
            clearTimeout(e.blurLastTargetTimeoutId);
          }),
          a(p(e), "_handleLastTargetBlur", function () {
            e.blurLastTargetTimeoutId = setTimeout(function () {
              e._floatElement &&
                (e.setTargetListeners("remove"), e._floatElement.hide());
            }, 0);
          }),
          a(p(e), "_handleTrigger", function (t) {

            // Storyside nav test
            // console.log('Storyside _handleTrigger fires for dropdown-opener', t);

            t.preventDefault(), e.trigger();
          }),
          a(p(e), "_handleUntrigger", function (t) {

            // Storyside nav test
            // console.log('Storyside _handleUntrigger this is what runs the hide after show ran');

            var n = t.clientX,
              i = t.clientY,
              a = t.target;
            if (e._floatElement) {
              var r = e._floatElement.checkCursorOutside(n, i),
                o = e._isTargetOutsideFloatElements(a);

              // Storyside add
              // This FINALL gets it by forcing the class header--light-bordered to be added back even after removal
              // console.log('Storyside _isTargetOutsideFloatElements 4626', o, e);
              if (!o) {
                // console.log('Storyside click is on the floating element or the trigger');
                // document.getElementById('header-component').classList.add("header--light-bordered");
                // Storyside last effort to just look for aria labels expanded after handleUntrigger is done
                // Little overkill but otherwise it added the class even when it was wanting to close
                var headerToggles = document.getElementsByClassName('header__dropdown-toggle');
                var headerTogglesLength = headerToggles.length;
                var isSomethingOpen = false;
                for (var i=0; i<headerTogglesLength; i++) {
                    var isExpanded = headerToggles[i].dataset.ariaExpanded;
                    // console.log('Storyside last nav effort', i, isExpanded);
                    if (isExpanded == "true") {
                      isSomethingOpen = true; 
                    }
                    // console.log('Storyside isSomethingOpen specific', i, isSomethingOpen);
                }
                if (isSomethingOpen) {
                  // console.log('Storyside isSomethingOpen', isSomethingOpen);
                  document.getElementById('header-component').classList.add("header--light-bordered");
                } else {
                  // console.log('Storyside isSomethingOpen', isSomethingOpen);
                  document.getElementById('header-component').classList.remove("header--light-bordered");
                }
              } else {
                // console.log('Storyside click is NOT on the floating element or the trigger');
              }

              r &&
                o &&
                (e._floatElement.hide(),
                U(window, "click", e._handleUntrigger));
            }
          }),
          a(p(e), "trigger", function () {

            // Storyside nav test
            // console.log('Storyside trigger fires for dropdown-opener');

            e._floatElement &&
              (e._floatElement.isOpen
                ? e._floatElement.hide()
                : e._floatElement.show(),
              H(window, "click", e._handleUntrigger));
          }),
          (e.element = e.getElement()),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {

              // Storyside trying to reverse order of Show and Hide here too
              // console.log('Storyside reverse default _handleDropdownShow and Hide');

              this._floatElement &&
                (customElements.upgrade(this._floatElement),
                this._floatElement.subscribe("hide", this._handleDropdownHide),
                this._floatElement.subscribe("show", this._handleDropdownShow)),
                H(this.element, "blur", this._handleBlur),
                H(this.element, "keyup", this._handleKeyUp),
                H(this.element, "mousedown", this._handleTrigger);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._floatElement &&
                (customElements.upgrade(this._floatElement),
                this._floatElement.unsubscribe(
                  "show",
                  this._handleDropdownShow
                ),
                this._floatElement.unsubscribe(
                  "hide",
                  this._handleDropdownHide
                )),
                U(this.element, "blur", this._handleBlur),
                U(this.element, "keyup", this._handleKeyUp),
                U(this.element, "mousedown", this._handleTrigger),
                U(window, "click", this._handleUntrigger);
            },
          },
          {
            key: "setTargetListeners",
            value: function (e) {
              var t = this,
                n = this.getTargets(),
                i = n.targets,
                a = n.firstTarget,
                r = n.lastTarget,
                o = "add" === e ? H : U;
              o(a, "focus", this._handleFirstTargetFocus),
                i.forEach(function (e) {
                  o(e, "focus", t._handleTargetFocus);
                }),
                o(r, "blur", this._handleLastTargetBlur),
                o(window, "click", this._handleUntrigger);
            },
          },
          {
            key: "getTargets",
            value: function () {
              if (this._floatElement) {
                var e = L(this._floatElement.element.querySelectorAll(W()));
                return {
                  targets: e,
                  firstTarget: e[0],
                  lastTarget: e[e.length - 1],
                };
              }
            },
          },
          {
            key: "_isTargetOutsideFloatElements",
            value: function (e) {

              // Storyside nav work
              // Note that I probably added class storyside_is_mega-menu_opener too much to make this work
              // Did not want to look for parent and such in case another element calls same thing
              // console.log('Storyside _isTargetOutsideFloatElements 4721', e, e.classList);
              var checkNav = true;
              if (e.classList.contains('storyside_is_mega-menu_opener')) {
                // console.log('Storyside confirming element classlist contains storyside_is_mega-menu_opener');
                checkNav = false;
              };


              if (this._floatElement) {
                var t = this._floatElement.contains(e),
                  n = this.contains(e);

                // Storyside adding && checkNav to below
                // DOES NOT WORK because it then NEVER collapses initial dropdown
                return !t && !n;
              }
            },
          },
          {
            key: "getElement",
            value: function () {
              var e = '[data-float-element-trigger="'.concat(
                this.dataset.floatElementId,
                '"]'
              );
              return this.querySelector(e) || this;
            },
          },
          {
            key: "setExpand",
            value: function (e) {

              // Storyside setExpand
              // console.log('Storyside setExpand', e);

              this.setAttribute("data-aria-expanded", e);
            },
          },
          {
            key: "_floatElement",
            get: function () {
              return document.querySelector(
                "#".concat(this.dataset.floatElementId)
              );
            },
          },
        ]),
        n
      );
    })(ne),
    tn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleMouseEnter",
            function () {
              e._floatElement && e._floatElement.show();
            }
          ),
          a(p(e), "_handleMouseLeave", function () {
            e._floatElement && e._floatElement.hide();
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this, "mouseenter", this._handleMouseEnter),
                H(this, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this, "mouseenter", this._handleMouseEnter),
                U(this, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "setExpand",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e ? "true" : "false");
            },
          },
          {
            key: "_floatElement",
            get: function () {
              return this.dataset.floatElementId
                ? document.querySelector(
                    "#".concat(this.dataset.floatElementId)
                  )
                : null;
            },
          },
        ]),
        n
      );
    })(ne),
    nn = tn,
    an = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleContentResize", function () {
            e.updateMaxHeight();
          }),
          a(p(e), "_handleBlockSelect", function (t) {
            var n = t.detail,
              i = n.sectionId,
              a = n.blockId,
              r = n.load,
              o = e.querySelector(e._contentWrapperSelector),
              s = e.dataset.sectionId === i,
              c = e.dataset.blockId === a;
            s &&
              c &&
              !e.isExpanded &&
              (ye(o, r),
              ye(p(e), r),
              e.show().then(function () {
                ye(o, !1), ye(p(e), !1);
              }));
          }),
          a(p(e), "_handleBlockDeselect", function (t) {
            var n = t.detail,
              i = n.sectionId,
              a = n.blockId;
            e.dataset.sectionId === i &&
              e.dataset.blockId === a &&
              e.isExpanded &&
              e.hide();
          }),
          (e._contentSelector = "[data-accordeon-content]"),
          (e._contentWrapperSelector = "[data-accordeon-content-wrapper]"),
          (e._content = e.querySelector(e._contentSelector)),
          (e._resizeObserver = new ResizeObserver(e._handleContentResize)),
          e._content && e._resizeObserver.observe(e._content),
          (e.styles = getComputedStyle(p(e))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateMaxHeight(),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._resizeObserver.disconnect(),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "hide",
            value: function () {
              return this._setExpand(!1), V($(this.styles));
            },
          },
          {
            key: "show",
            value: function () {
              return this._setExpand(!0), V($(this.styles));
            },
          },
          {
            key: "toggle",
            value: function () {
              this._setExpand(!this.isExpanded);
            },
          },
          {
            key: "updateMaxHeight",
            value: function () {
              var e = this.closest("accordeon-component"),
                t = this.querySelector(this._contentSelector),
                n = this.querySelector(this._contentWrapperSelector);
              if (e && t && n) {
                var i = Math.ceil(e.isExpanded ? t.offsetHeight : 0);
                n.style.maxHeight = "".concat(i, "px");
              }
            },
          },
          {
            key: "_setExpand",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e ? "true" : "false"),
                this.updateMaxHeight();
            },
          },
          {
            key: "isExpanded",
            get: function () {
              return "true" === this.getAttribute("data-aria-expanded");
            },
          },
          {
            key: "_contentWrapper",
            get: function () {
              return this.querySelector(this._contentWrapperSelector);
            },
          },
        ]),
        n
      );
    })(ne),
    rn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function (t) {
              t.preventDefault(), e.update();
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("click", this._handleButtonClick),
                this.addEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleButtonClick),
                this.removeEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("accordeon-component");
              e && e.toggle();
            },
          },
        ]),
        n
      );
    })(ne),
    on = rn,
    sn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleTabEnter", function (t) {
            var n = t.currentTarget,
              i = e._productCard.querySelector(
                '[data-id="'.concat(n.dataset.id, '"]')
              );
            e._selected && e._reset(),
              e._setTabSelect(n, !0),
              e._setImageVisible(i, !0),
              e._setImageVisible(e._mainImage, !1),
              (e._selected = { tab: n, img: i });
          }),
          a(p(e), "handleTabLeave", function () {
            e._selected && e._reset(), e._setImageVisible(e._mainImage, !0);
          }),
          (e._productCard = e.closest("product-card")),
          (e._mainImage = e._productCard.querySelector("[data-main-media]")),
          (e._tabs = L(e.querySelectorAll("[data-product-media-tabs-item]"))),
          (e._selected = null),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._tabs.forEach(function (t) {
                t.addEventListener("mouseenter", e.handleTabEnter),
                  t.addEventListener("mouseleave", e.handleTabLeave);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this._tabs.forEach(function (t) {
                t.removeEventListener("mouseenter", e.handleTabEnter),
                  t.removeEventListener("mouseleave", e.handleTabLeave);
              });
            },
          },
          {
            key: "_setTabSelect",
            value: function (e, t) {
              e.classList.toggle("selected", t);
            },
          },
          {
            key: "_setImageVisible",
            value: function (e, t) {
              e.classList.toggle("product-card__img--visible", t);
            },
          },
          {
            key: "_reset",
            value: function () {
              this._selected &&
                (this._selected.img.classList.remove(
                  "product-card__img--visible"
                ),
                this._selected.tab.classList.remove("selected"),
                (this._selected = null));
            },
          },
        ]),
        n
      );
    })(ne),
    cn = sn,
    ln = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleSwatchEnter", function (t) {

            // Storyside commented out event so this never fires, uses custom JS instead for click event
            // When set event to just use click instead of mouseenter, the function here ran but image didn't change
            // console.log('Storyside handleSwatchEnter as click', e, t);

            if (e.productCard) {
              var n = t.target,
                i = n.dataset.variantId,
                a = e.productCard.querySelector(
                  '[data-variant-id="'.concat(i, '"]')
                ),
                r = n.dataset.color;
              a &&
                e.mainImage &&
                r &&
                (e.updateLabel(r),
                e.setImageVisible(a, !0),
                e.setImageVisible(e.mainImage, !1),
                (e.currentVisibleImage = a),
                e.setHoverStatus(!0));
            }
          }),
          a(p(e), "handleSwatchLeave", function () {
            e.updateLabel(""),
              e.currentVisibleImage &&
                e.setImageVisible(e.currentVisibleImage, !1),
              e.mainImage && e.setImageVisible(e.mainImage, !0),
              e.setHoverStatus(!1);
          }),
          (e.hiddenCountSelector = "[data-color-swatches-hidden-count]"),
          (e.hiddenCountLabelSelector =
            "[data-color-swatches-hidden-count-label]"),
          (e.labelSelector = "[data-color-swatches-label]"),
          (e.itemSelector = "[data-color-swatches-item]"),
          (e.hiddenCount = e.querySelector(e.hiddenCountSelector)),
          (e.hiddenCountLabel = e.querySelector(e.hiddenCountLabelSelector)),
          (e.label = e.querySelector(e.labelSelector)),
          (e.items = L(e.querySelectorAll(e.itemSelector))),
          (e.productCard = e.closest("product-card")),
          e.productCard &&
            (e.mainImage = e.productCard.querySelector("[data-main-media]")),
          (e.hiddenCountLabelStyles = getComputedStyle(e.hiddenCountLabel)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              (this.hiddenCountLabelWidth = parseInt(
                this.hiddenCountLabelStyles.width
              )),
                this.initOffsets(),
                this.update(),
                this.items.forEach(function (t) {
                  // Storyside removing in favor of custom JS
                  // t.addEventListener("mouseenter", e.handleSwatchEnter);
                  // t.addEventListener("mouseleave", e.handleSwatchLeave);

                  // t.addEventListener("mouseenter", e.handleSwatchEnter),
                  //   t.addEventListener("mouseleave", e.handleSwatchLeave);
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.items.forEach(function (t) {
                // Storyside removing in favor of custom JS
                // t.removeEventListener("mouseenter", e.handleSwatchEnter);
                // t.removeEventListener("mouseleave", e.handleSwatchLeave);

                // t.removeEventListener("mouseenter", e.handleSwatchEnter),
                //   t.removeEventListener("mouseleave", e.handleSwatchLeave);
              });
            },
          },
          {
            key: "update",
            value: function () {
              this.updateSwatchesVisible(), this.updateCount();
            },
          },
          {
            key: "setImageVisible",
            value: function (e, t) {
              e.classList.toggle("product-card__img--visible", t);
            },
          },
          {
            key: "updateSwatchesVisible",
            value: function () {
              var e = this;
              this.productCard &&
                this.items.forEach(function (t) {
                  var n =
                    t.offsetLeft + t.offsetWidth >
                    e.parentNode.offsetWidth - t.offsetWidth;
                  t.classList.toggle("hidden-swatch", n);
                });
            },
          },
          {
            key: "initOffsets",
            value: function () {
              this.items.forEach(function (e) {
                e.style.left = "".concat(e.offsetLeft, "px");
              });
            },
          },
          {
            key: "updateCount",
            value: function () {
              if (this.hiddenCount) {
                var e = this.items.filter(function (e) {
                    return !e.classList.contains("hidden-swatch");
                  }),
                  t = +(this.dataset.count || 0) - e.length;
                t > 0
                  ? (de(this.hiddenCount),
                    (this.hiddenCountLabel.innerText = "+".concat(t)))
                  : (he(this.hiddenCount),
                    (this.hiddenCountLabel.innerText = ""));
              }
            },
          },
          {
            key: "updateLabel",
            value: function (e) {
              var t, n, i;
              this.label &&
                (this.label.innerText = e
                  ? ((n = (t = e).slice(0, 1)),
                    (i = t.slice(1)),
                    n.toUpperCase() + i)
                  : "");
            },
          },
          {
            key: "setHoverStatus",
            value: function (e) {
              this.productCard.toggleAttribute("is-color-swatch-hover", e);
            },
          },
        ]),
        n
      );
    })(ne),
    un = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleKeydown", function (t) {
            var n = t.key || t.keyCode;
            Q(n) && e.hide();
          }),
          a(p(e), "_handleOutsideClick", function (t) {
            var n = document.getElementById("BodyOverlay"),
              i = parseFloat(fe(n, "zIndex")),
              a = parseFloat(e.styles.zIndex) - 1;
            t.target === n && i <= a && e.isOpen && e.hide();
          }),
          (e._template = e.querySelector("template")),
          (e.element = pe(e._template)),
          (e.styles = getComputedStyle(p(e))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "show",
            value: function () {
              var e = this;
              this._mount(),
                this.element.querySelectorAll("video").forEach(function (e) {
                  e.play();
                }),
                this.focus(),
                setTimeout(function () {
                  e._setOpenState(!0);
                }, 0),
                (this.isOpen = !0);
            },
          },
          {
            key: "hide",
            value: function () {
              var e = this;
              return (
                this._setOpenState(!1),
                V($(this.styles)).then(function () {
                  e._unmount(), (e.isOpen = !1);
                })
              );
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.hide() : this.show();
            },
          },
          {
            key: "_mount",
            value: function () {
              this.element &&
                !this.contains(this.element) &&
                this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "_setOpenState",
            value: function (e) {

              // Storyside checking if this runs on nav mega menu click open
              // NOPE
              // console.log('Storyside _setOpenState 1', e);

              var t = this;
              if (this.hasAttribute("data-with-overlay")) {
                var n = this.hasAttribute("data-overlay-important"),
                  i = this.getAttribute("data-overlay-opacity") || 50,
                  a = {
                    zIndex: n ? parseFloat(this.styles.zIndex) - 1 : 3,
                    backgroundColor: "var(--gsc-black-color-".concat(i, ")"),
                  };
                e
                  ? Nt.showOverlay(this.id, a)
                  : V($(this.styles)).then(function () {
                      Nt.hideOverlay(t.id);
                    });
              }
              this._setVisible(e),
                this._setListeners(e ? "add" : "remove"),
                this.emit(e ? "show" : "hide", {});
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.toggleAttribute("open", e);
            },
          },
          {
            key: "_setListeners",
            value: function (e) {
              var t = this.hasAttribute("data-with-close-on-outside"),
                n = "".concat(e, "EventListener");
              t && window[n]("click", this._handleOutsideClick),
                window[n]("keydown", this._handleKeydown);
            },
          },
        ]),
        n
      );
    })(ne),
    dn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).passwordInput = e.querySelector(
            "[password-modal-input]"
          )),
          e
        );
      }
      return (
        g(n, [
          {
            key: "show",
            value: function () {
              Jt(A(n.prototype), "show", this).call(this),
                this.passwordInput && this.passwordInput.focus();
            },
          },
        ]),
        n
      );
    })(un),
    hn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "showProductFromParsedState",
            value: function (e, t) {
              var n = e.sections["cart-notification-popup-content"],
                i = ge(n);
              if (this.element) {
                var a = i.querySelector(
                    "#CartNotificationPopupItem-".concat(t)
                  ),
                  r = this.element.querySelector(
                    "[data-cart-notification-popup]"
                  );
                if (r && a) {
                  var o = a.cloneNode(!0);
                  r.replaceChildren(o);
                }
                this._updateCartCountInHeader(e), this.show();
              }
            },
          },
          {
            key: "_updateCartCountInHeader",
            value: function (e) {
              var t,
                n,
                i = e.sections["cart-count"],
                a = ge(i),
                r = document.getElementById("CartCount"),
                o = document.getElementById("StickyCartCount"),
                s = a.getElementById("CartCount");
              if (s) {
                var c = null == s ? void 0 : s.cloneNode(!0);
                o && (t = o).replaceChildren.apply(t, L(c.childNodes)),
                  r && (n = r).replaceChildren.apply(n, L(c.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(un),
    fn = hn,
    vn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.showModal(), e.emit("click", {});
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            if (X(t.key || t.keyCode) && e.dataset.modal) {
              t.preventDefault();
              var n = document.querySelector(e.dataset.modal);
              n && n.toggle();
            }
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "showModal",
            value: function () {
              if (this.dataset.modal) {
                var e = document.querySelector(this.dataset.modal);
                e && e.show();
              }
            },
          },
        ]),
        n
      );
    })(ne),
    pn = vn,
    mn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              Jt(A(n.prototype), "connectedCallback", this).call(this),
                this.focus();
            },
          },
        ]),
        n
      );
    })(pn),
    yn = mn,
    gn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.hide();
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.hide());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "hide",
            value: function () {
              if (this.dataset.modal) {
                var e = document.querySelector(this.dataset.modal);
                e && e.hide();
              }
            },
          },
        ]),
        n
      );
    })(ne),
    bn = gn,
    _n = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleButtonClick", function (e) {
            e.preventDefault();
          }),
          a(p(e), "handleButtonMouseDown", function (t) {
            t.preventDefault();
            var n = e.closest("carousel-component"),
              i = e.closest("carousel-dots");
            (e.isDraggingInCarousel = !(!n && !i)),
              e.isDraggingInCarousel
                ? (e.setMoveStartPoint(t.clientX, t.clientY),
                  (e.toggleAfterDraggingInCarousel = !0))
                : e.toggle();
          }),
          a(p(e), "handleButtonMouseMove", function (t) {
            if (e.isDraggingInCarousel) {
              var n = Math.abs(e.startPointX - t.clientX),
                i = Math.abs(e.startPointY - t.clientY);
              (n > 24 || i > 24) && (e.toggleAfterDraggingInCarousel = !1);
            }
          }),
          a(p(e), "handleButtonMouseUp", function () {
            e.isDraggingInCarousel &&
              (e.toggleAfterDraggingInCarousel && e.toggle(),
              (e.isDraggingInCarousel = !1),
              (e.toggleAfterDraggingInCarousel = !1),
              e.setMoveStartPoint(0, 0));
          }),
          a(p(e), "_handleButtonFocus", function () {
            e.button && e.button.addEventListener("keydown", e.handleKeyDown);
          }),
          a(p(e), "_handleButtonBlur", function () {
            e.button &&
              e.button.removeEventListener("keydown", e.handleKeyDown);
          }),
          a(p(e), "handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.toggle());
          }),
          (e.buttonSelector = "[data-sidebar-button]"),
          (e.button = e.querySelector(e.buttonSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.button &&
                (this.button.addEventListener("click", this._handleButtonClick),
                this.button.addEventListener("focus", this._handleButtonFocus),
                this.button.addEventListener("blur", this._handleButtonBlur),
                this.button.addEventListener(
                  "mousedown",
                  this.handleButtonMouseDown
                ),
                this.button.addEventListener(
                  "mousemove",
                  this.handleButtonMouseMove
                ),
                this.button.addEventListener(
                  "mouseup",
                  this.handleButtonMouseUp
                ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                (this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                this.button.removeEventListener(
                  "focus",
                  this._handleButtonFocus
                ),
                this.button.removeEventListener("blur", this._handleButtonBlur),
                this.button.removeEventListener(
                  "mousedown",
                  this.handleButtonMouseDown
                ),
                this.button.removeEventListener(
                  "mousemove",
                  this.handleButtonMouseMove
                ),
                this.button.removeEventListener(
                  "mouseup",
                  this.handleButtonMouseUp
                ));
            },
          },
          {
            key: "setMoveStartPoint",
            value: function (e, t) {
              (this.startPointX = e), (this.startPointY = t);
            },
          },
          {
            key: "toggle",
            value: function () {

              // Storyside sidebar-button keydown triggered toggle event on something
              // console.log('Storyside sidebar-button keydown toggle', this)

              if (this.button) {
                var e = this.button.dataset.sidebarId || "",
                  t = document.querySelector("#".concat(e));
                t && (t.toggle(), this.update());
              }
            },
          },
          {
            key: "update",
            value: function () {

              // Storyside update function to check if this happens when cart opens
              // console.log('Storyside update function try rebuy here'); 
              if (window.Rebuy) {
                Rebuy.init();
              }

              if (this.button) {
                var e = this.button.dataset.sidebarId || "",
                  t = document.querySelector("#".concat(e));
                t &&
                  this.button.setAttribute(
                    "data-aria-expanded",
                    t.isOpen ? "true" : "false"
                  );
              }
            },
          },
        ]),
        n
      );
    })(ne),
    kn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleSectionLoad", function () {
            e._isSection || e.hide();
          }),
          a(p(e), "_handleSectionSelect", function (t) {
            var n = t.detail.sectionId;
            e._isSection && e.dataset.sectionId === n && e.open();
          }),
          a(p(e), "_handleSectionDeselect", function (t) {
            var n = t.detail.sectionId;
            e._isSection && e.dataset.sectionId === n && e.hide();
          }),
          a(p(e), "_handleOutsideClick", function (t) {
            var n = document.getElementById("BodyOverlay"),
              i = parseFloat(fe(n, "zIndex")),
              a = parseFloat(e.styles.zIndex) - 1;
            t.target === n && i <= a && e.isOpen && e.hide();
          }),
          a(p(e), "_handleTouchStart", function (t) {
            (e._touchStartX = t.targetTouches[0].clientX),
              (e._touchStartY = t.targetTouches[0].clientY);
          }),
          a(p(e), "_handleTouchMove", function (t) {
            (e._touchEndX = t.targetTouches[0].clientX),
              (e._touchEndY = t.targetTouches[0].clientY);
          }),
          a(p(e), "_handleTouchEnd", function (t) {
            var n = Math.abs(e._touchStartX - e._touchEndX),
              i = Math.abs(e._touchStartY - e._touchEndY);
            if (
              !(
                t.target.closest("[data-carousel-viewport]") ||
                0 === e._touchEndX ||
                i > 48
              )
            ) {
              var a =
                "right" === e.dataset.openDirection
                  ? e._touchStartX < e._touchEndX
                  : e._touchStartX > e._touchEndX;
              e.isOpen && n > 96 && a && e.hide(), e.cleanTouchPoints();
            }
          }),
          a(p(e), "_handleKeydown", function (t) {
            var n = t.key || t.keyCode,
              i = e.hasAttribute("data-with-close-on-escape"),
              a = Q(n);
            i && a && e.hide();
          }),
          (e._template = e.isOpenOnInit ? null : e.querySelector("template")),
          (e.element = e.isOpenOnInit
            ? e.querySelector("[data-sidebar-body]")
            : pe(e._template)),
          (e.buttonSelector = '[data-sidebar-button][data-sidebar-id="'.concat(
            e.id,
            '"]'
          )),
          (e.styles = getComputedStyle(p(e))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("touchstart", this._handleTouchStart),
                this.addEventListener("touchmove", this._handleTouchMove),
                this.addEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  ),
                  this._editor.subscribe(
                    "SECTION_SELECT",
                    this._handleSectionSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_DESELECT",
                    this._handleSectionDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("touchstart", this._handleTouchStart),
                this.removeEventListener("touchmove", this._handleTouchMove),
                this.removeEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "cleanTouchPoints",
            value: function () {
              (this._touchStartX = 0),
                (this._touchEndX = 0),
                (this._touchStartY = 0),
                (this._touchEndY = 0);
            },
          },
          {
            key: "open",
            value: function () {
              var e = this;
              return (
                this.mount(),
                this.setAttribute("tabindex", "-1"),
                this.focus(),
                setTimeout(function () {
                  e._setOpenState(!0);
                }, 0),
                V($(this.styles))
              );
            },
          },
          {
            key: "hide",
            value: function (e) {
              var t = this;
              if ((this._setOpenState(!1), !e))
                return V($(this.styles)).then(function () {
                  t.unmount();
                });
              this.unmount();
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.hide() : this.open();
            },
          },
          {
            key: "mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "updateTemplate",
            value: function (e) {
              this.element.remove(),
                (this.element = pe(e)),
                this.appendChild(this.element);
            },
          },
          {
            key: "_setOpenState",
            value: function (e) {
              var t = this,
                n = this.hasAttribute("data-with-overlay"),
                i = document.querySelectorAll(this.buttonSelector);
              if (
                (this._setVisible(e),
                this._setListeners(e ? "add" : "remove"),
                n)
              ) {
                var a = this.hasAttribute("data-overlay-important"),
                  r = this.hasAttribute("data-overlay-with-blur"),
                  o = +(this.getAttribute("data-overlay-opacity") || 50),
                  s = {
                    zIndex: a ? parseFloat(this.styles.zIndex) - 1 : 3,
                    backdropFilter: r ? "blur(16.5px)" : "none",
                    backgroundColor: "var(--gsc-black-color-".concat(o, ")"),
                  };
                e
                  ? Nt.showOverlay(this.id, s)
                  : V($(this.styles)).then(function () {
                      Nt.hideOverlay(t.id);
                    });
              }
              i.forEach(function (t) {
                t.setAttribute("data-aria-expanded", e ? "true" : "false");
              });
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.setAttribute("data-aria-expanded", e ? "true" : "false");
            },
          },
          {
            key: "_setListeners",
            value: function (e) {
              var t = this.hasAttribute("data-with-close-on-outside"),
                n = "".concat(e, "EventListener");
              t && window[n]("click", this._handleOutsideClick),
                window[n]("keydown", this._handleKeydown);
            },
          },
          {
            key: "_isSection",
            get: function () {
              return this.hasAttribute("data-sidebar-section");
            },
          },
          {
            key: "isOpen",
            get: function () {
              return "true" === this.getAttribute("data-aria-expanded");
            },
          },
          {
            key: "isOpenOnInit",
            get: function () {
              return this.hasAttribute("is-open-on-init");
            },
          },
        ]),
        n
      );
    })(ne),
    wn = function () {
      return matchMedia("(max-width: 768px)").matches;
    },
    Sn = function () {
      return matchMedia("(prefers-reduced-motion: reduce)").matches;
    },
    Cn = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleClick", function (t) {
            var n = t.target,
              i = wn(),
              a = n === e._searchInput,
              r = "A" === n.tagName,
              o = n.closest("[data-sidebar-search-query]");
            if (e._searchInput && o) {
              var s = new Event("input", { bubbles: !0 });
              (e._searchInput.value = "".concat(
                o.getAttribute("data-sidebar-search-query")
              )),
                e._searchInput.dispatchEvent(s),
                e._searchInput.focus();
            }
            i && a && (e.isInputFocused = !0),
              !a &&
                e.isInputFocused &&
                (r && t.preventDefault(), (e.isInputFocused = !1));
          }),
          a(p(e), "_handleInputFocus", function () {
            wn() && (e.isInputFocused = !0);
          }),
          a(p(e), "_handleSearchSidebarTouchEnd", function (t) {
            var n = t.target,
              i = Math.abs(e._touchStartX - e._touchEndX),
              a = Math.abs(e._touchStartY - e._touchEndY),
              r = i > 12 || a > 12,
              o = "A" === n.tagName;
            e.isInputFocused &&
              r &&
              e._searchInput &&
              (o && t.preventDefault(),
              e._searchInput.blur(),
              (e.isInputFocused = !1)),
              e.cleanTouchPoints();
          }),
          a(p(e), "_handleContentResultsResize", function () {
            e.updateViewport();
          }),
          a(p(e), "_handleContentScroll", function () {
            if (e.content) {
              var t = e.checkContentOverflow(),
                n = e.content.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t && n);
            }
          }),
          (e.searchInputSelector = "[data-sidebar-search-input]"),
          (e.searchInputComponentSelector =
            "[data-sidebar-search-input-component]"),
          (e.contentSelector = "[data-sidebar-search-content]"),
          (e.contentResultsSelector = "[data-sidebar-search-content-results]"),
          (e.content = e.element.querySelector(e.contentSelector)),
          (e.contentResults = e.element.querySelector(
            e.contentResultsSelector
          )),
          (e._searchInputComponent = e.element.querySelector(
            e.searchInputComponentSelector
          )),
          (e._searchInput = e.element.querySelector(e.searchInputSelector)),
          (e._resizeObserver = new ResizeObserver(
            e._handleContentResultsResize
          )),
          e.contentResults && e._resizeObserver.observe(e.contentResults),
          (e.defaultStateElement = document),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              Jt(A(n.prototype), "connectedCallback", this).call(this),
                this.content &&
                  this.content.addEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                this.addEventListener("click", this._handleClick),
                this.addEventListener(
                  "touchend",
                  this._handleSearchSidebarTouchEnd
                ),
                this._searchInput &&
                  this._searchInput.addEventListener(
                    "focus",
                    this._handleInputFocus
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Jt(A(n.prototype), "disconnectedCallback", this).call(this),
                this.content &&
                  this.content.removeEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                this.removeEventListener("click", this._handleClick),
                this.removeEventListener(
                  "touchend",
                  this._handleSearchSidebarTouchEnd
                ),
                this._searchInput &&
                  this._searchInput.removeEventListener(
                    "focus",
                    this._handleInputFocus
                  ),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "updateViewport",
            value: function () {
              var e = this.checkContentOverflow();
              this.toggleAttribute("footer-shadow-visible", e);
            },
          },
          {
            key: "open",
            value: function () {
              var e = this;
              return Jt(A(n.prototype), "open", this)
                .call(this)
                .then(function () {
                  e._searchInput && !e._isEditorMode && e._searchInput.focus();
                });
            },
          },
          {
            key: "checkContentOverflow",
            value: function () {
              return (
                !(!this.contentResults || !this.content) &&
                this.contentResults.offsetHeight > this.content.offsetHeight
              );
            },
          },
        ]),
        n
      );
    })(kn),
    En = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).containers = L(
            e.querySelectorAll("[recently-viewed-container]")
          )),
          (e.cardLimit = +e.dataset.cardLimit),
          (e.visibleProductCount = 0),
          (e.sectionSettings = JSON.parse(e.dataset.sectionSettings)),
          e
        );
      }
      return (
        g(
          n,
          [
            {
              key: "connectedCallback",
              value: function () {
                this.setItems();
              },
            },
            {
              key: "setItems",
              value: function () {
                var e = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                  t = this.createProducts(JSON.parse(e));
                this.containers.forEach(function (e) {
                  e.innerHTML = t;
                });
              },
            },
            {
              key: "createProducts",
              value: function (e) {
                var t = this,
                  n = "";
                return (
                  Object.keys(e)
                    .reverse()
                    .forEach(function (i) {
                      var a = t.prepareTemplate(e[i]),
                        r = t.createNodeByString(a);
                      "center" === t.sectionSettings.product_card_align &&
                        r.classList.add("product-card--center-alignment");
                      var o = t._visibleProductCount >= t.cardLimit,
                        s = i === t.dataset.productHandle;
                      o ||
                        s ||
                        ((n = "".concat(n, " ").concat(r.outerHTML)),
                        (t._visibleProductCount += 1));
                    }),
                  n
                );
              },
            },
            {
              key: "prepareTemplate",
              value: function (e) {
                return e.replaceAll(
                  /shape--square|shape--landscape|shape--portrait-xl|shape--portrait/gi,
                  "shape--".concat(this.sectionSettings.img_ratio)
                );
              },
            },
            {
              key: "createNodeByString",
              value: function (e) {
                return new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector("[recently-viewed-item]");
              },
            },
            {
              key: "setVisible",
              value: function (e) {
                this.classList.toggle("hidden", !e);
              },
            },
            {
              key: "_visibleProductCount",
              get: function () {
                return this.visibleProductCount;
              },
              set: function (e) {
                var t = e > 0;
                (this.visibleProductCount = e), this.setVisible(t);
              },
            },
          ],
          [
            {
              key: "updateProductsInLocalStorage",
              value: function (e, t) {
                if (e && t) {
                  var n = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                    i = o(r({}, JSON.parse(n)), a({}, t, e));
                  localStorage.setItem(
                    "AuroraTheme-RecentlyProducts",
                    JSON.stringify(i)
                  );
                }
              },
            },
          ]
        ),
        n
      );
    })(ne),
    xn = window.Shopify,
    Ln = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleContentScroll", function () {
            var t = !!e.content && e.content.scrollTop > 0;
            e.toggleAttribute("header-shadow-visible", t);
          }),
          a(p(e), "openAndRenderProductByUrl", function (t) {
            e._cache[t] &&
              e._cache[t].then(function (t) {
                var i;
                e.onThisPageRenderedQuickView &&
                  e.onThisPageRenderedQuickView.replaceChildren(),
                  e.isOpen
                    ? e.hide().then(function () {
                        e._setProductFromHTML(t),
                          Jt((p(e), A(n.prototype)), "open", e).call(e);
                      })
                    : (e._setProductFromHTML(t),
                      Jt((p(e), A(n.prototype)), "open", e).call(e)),
                  null == xn ||
                    null === (i = xn.PaymentButton) ||
                    void 0 === i ||
                    i.init();
              });
          }),
          (e._cache = {}),
          e
        );
      }
      return (
        g(n, [
          {
            key: "requestProductFromUrl",
            value: function (e, t) {
              var n = this;

              // Storyside add
              console.log('Storyside requestProductFromUrl', this, e, t);

              this._cache[e] ||
                ((this.onThisPageRenderedQuickView = document.querySelector(
                  '.shopify-section [data-quick-view-product-id="'.concat(
                    t,
                    '"]'
                  )
                )),
                this.onThisPageRenderedQuickView &&
                this.onThisPageRenderedQuickView.dataset.quickViewProductUrl ===
                  e
                  ? (this._cache[e] = V(0).then(function () {
                      return n.onThisPageRenderedQuickView;
                    }))
                  : (this._cache[e] = fetch(e)
                      .then(function (e) {
                        return e.text();
                      })
                      .then(function (e) {
                        return ge(e);
                      })));
            },
          },
          { key: "open", value: function () {} },
          {
            key: "_setProductFromHTML",
            value: function (e) {

              // Storyside add
              // console.log('Storyside _setProductFromHTML', this.dataset);

              if (this.dataset.targetId) {
                var t = e.getElementById(this.dataset.targetId);
                if (t) {
                  var n;
                  En.updateProductsInLocalStorage(
                    t.dataset.productString,
                    t.dataset.productHandle
                  );
                  var i = t.getAttribute("class") || "",
                    a = t.cloneNode(!0);
                  this.element.setAttribute("class", i),
                    (n = this.element).replaceChildren.apply(
                      n,
                      L(a.childNodes)
                    ),
                    (this.content = this.element.querySelector(
                      "[data-quick-view-content]"
                    )),
                    this.content &&
                      this.content.addEventListener(
                        "scroll",
                        this._handleContentScroll
                      );
                }
              }
            },
          },
          {
            key: "_resetProduct",
            value: function () {
              if (this.content) {
                if (
                  (this.content.removeEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                  this.onThisPageRenderedQuickView)
                ) {
                  var e,
                    t = this.content.cloneNode(!0);
                  (e = this.onThisPageRenderedQuickView).replaceChildren.apply(
                    e,
                    L(t.childNodes)
                  );
                }
                this.content = null;
              }
              this.element.replaceChildren();
            },
          },
        ]),
        n
      );
    })(kn);
  function In() {
    return (
      (In =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n)
              Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
          return e;
        }),
      In.apply(this, arguments)
    );
  }
  function Tn(e, t) {
    if (e.length !== t.length) throw new Error("vectors must be same length");
    return e.map(function (e, n) {
      return e + t[n];
    });
  }
  function An(e) {
    return Math.max.apply(Math, e.map(Math.abs));
  }
  function Dn(e) {
    return (
      Object.freeze(e),
      Object.values(e).forEach(function (e) {
        null === e || "object" != typeof e || Object.isFrozen(e) || Dn(e);
      }),
      e
    );
  }
  var Pn = [1, 18, ("undefined" != typeof window && window.innerHeight) || 800];
  var Mn = [-1, -1, -1];
  var Bn = function (e) {
      return In({}, e, {
        axisDelta: e.axisDelta.map(function (e) {
          return (t = e), (n = -700), (i = 700), Math.min(Math.max(n, t), i);
          var t, n, i;
        }),
      });
    },
    qn = Dn({ preventWheelAction: !0, reverseSign: [!0, !0, !1] }),
    On = 400;
  function Rn() {
    return {
      isStarted: !1,
      isStartPublished: !1,
      isMomentum: !1,
      startTime: 0,
      lastAbsDelta: 1 / 0,
      axisMovement: [0, 0, 0],
      axisVelocity: [0, 0, 0],
      accelerationFactors: [],
      scrollPoints: [],
      scrollPointsToMerge: [],
      willEndTimeout: On,
    };
  }
  var Nn = function (e) {
      void 0 === e && (e = {});
      var t,
        n,
        i,
        a = (function () {
          var e = function (e, n) {
              t[e] = (t[e] || []).filter(function (e) {
                return e !== n;
              });
            },
            t = {};
          return Dn({
            on: function (n, i) {
              return (
                (t[n] = (t[n] || []).concat(i)),
                function () {
                  return e(n, i);
                }
              );
            },
            off: e,
            dispatch: function (e, n) {
              e in t &&
                t[e].forEach(function (e) {
                  return e(n);
                });
            },
          });
        })(),
        r = a.on,
        o = a.off,
        s = a.dispatch,
        c = qn,
        l = Rn(),
        u = !1,
        d = function (e) {
          Array.isArray(e)
            ? e.forEach(function (e) {
                return v(e);
              })
            : v(e);
        },
        h = function (e) {
          return (
            void 0 === e && (e = {}),
            Object.values(e).some(function (e) {
              return null == e;
            })
              ? c
              : (c = Dn(In({}, qn, c, e)))
          );
        },
        f = function (e) {
          var i = In(
            {
              event: t,
              isStart: !1,
              isEnding: !1,
              isMomentumCancel: !1,
              isMomentum: l.isMomentum,
              axisDelta: [0, 0, 0],
              axisVelocity: l.axisVelocity,
              axisMovement: l.axisMovement,
              get axisMovementProjection() {
                return Tn(
                  i.axisMovement,
                  i.axisVelocity.map(function (e) {
                    return void 0 === t && (t = 0.996), (e * t) / (1 - t);
                    var t;
                  })
                );
              },
            },
            e
          );
          s("wheel", In({}, i, { previous: n })), (n = i);
        },
        v = function (e) {
          var n,
            i,
            a,
            r,
            o = Bn(
              (function (e, t) {
                if (!t) return e;
                var n =
                  !0 === t
                    ? Mn
                    : t.map(function (e) {
                        return e ? -1 : 1;
                      });
                return In({}, e, {
                  axisDelta: e.axisDelta.map(function (e, t) {
                    return e * n[t];
                  }),
                });
              })(
                ((i = (n = e).deltaX * Pn[n.deltaMode]),
                (a = n.deltaY * Pn[n.deltaMode]),
                (r = (n.deltaZ || 0) * Pn[n.deltaMode]),
                { timeStamp: n.timeStamp, axisDelta: [i, a, r] }),
                c.reverseSign
              )
            ),
            s = o.axisDelta,
            d = o.timeStamp,
            h = An(s);
          e.preventDefault &&
            (function (e, t) {
              var n = c.preventWheelAction,
                i = t[0],
                a = t[1],
                r = t[2];
              if ("boolean" == typeof n) return n;
              switch (n) {
                case "x":
                  return Math.abs(i) >= e;
                case "y":
                  return Math.abs(a) >= e;
                case "z":
                  return Math.abs(r) >= e;
                default:
                  return !1;
              }
            })(h, s) &&
            e.preventDefault(),
            l.isStarted
              ? l.isMomentum &&
                h > Math.max(2, 2 * l.lastAbsDelta) &&
                (C(!0), w())
              : w(),
            0 === h && Object.is && Object.is(e.deltaX, -0)
              ? (u = !0)
              : ((t = e),
                (l.axisMovement = Tn(l.axisMovement, s)),
                (l.lastAbsDelta = h),
                l.scrollPointsToMerge.push({ axisDelta: s, timeStamp: d }),
                p(),
                f({ axisDelta: s, isStart: !l.isStartPublished }),
                (l.isStartPublished = !0),
                S());
        },
        p = function () {
          var e;
          2 === l.scrollPointsToMerge.length
            ? (l.scrollPoints.unshift({
                axisDeltaSum: l.scrollPointsToMerge
                  .map(function (e) {
                    return e.axisDelta;
                  })
                  .reduce(Tn),
                timeStamp:
                  ((e = l.scrollPointsToMerge.map(function (e) {
                    return e.timeStamp;
                  })),
                  e.reduce(function (e, t) {
                    return e + t;
                  }) / e.length),
              }),
              y(),
              (l.scrollPointsToMerge.length = 0),
              (l.scrollPoints.length = 1),
              l.isMomentum || _())
            : l.isStartPublished || m();
        },
        m = function () {
          var e;
          l.axisVelocity = ((e = l.scrollPointsToMerge),
          e[e.length - 1]).axisDelta.map(function (e) {
            return e / l.willEndTimeout;
          });
        },
        y = function () {
          var e = l.scrollPoints,
            t = e[0],
            n = e[1];
          if (n && t) {
            var i = t.timeStamp - n.timeStamp;
            if (!(i <= 0)) {
              var a = t.axisDeltaSum.map(function (e) {
                  return e / i;
                }),
                r = a.map(function (e, t) {
                  return e / (l.axisVelocity[t] || 1);
                });
              (l.axisVelocity = a), l.accelerationFactors.push(r), g(i);
            }
          }
        },
        g = function (e) {
          var t = 12 * Math.ceil(e / 10);
          l.isMomentum || (t = Math.max(100, 2 * t)),
            (l.willEndTimeout = Math.min(1e3, Math.round(t)));
        },
        b = function (e) {
          return 0 === e || (e <= 0.96 && e >= 0.6);
        },
        _ = function () {
          if (l.accelerationFactors.length >= 5) {
            if (u && ((u = !1), An(l.axisVelocity) >= 0.2)) return void k();
            var e = l.accelerationFactors.slice(-5);
            e.every(function (e) {
              var t = !!e.reduce(function (e, t) {
                  return e && e < 1 && e === t ? 1 : 0;
                }),
                n = e.filter(b).length === e.length;
              return t || n;
            }) && k(),
              (l.accelerationFactors = e);
          }
        },
        k = function () {
          l.isMomentum = !0;
        },
        w = function () {
          ((l = Rn()).isStarted = !0),
            (l.startTime = Date.now()),
            (n = void 0),
            (u = !1);
        },
        S = function () {
          clearTimeout(i), (i = setTimeout(C, l.willEndTimeout));
        },
        C = function (e) {
          void 0 === e && (e = !1),
            l.isStarted &&
              (l.isMomentum && e
                ? f({ isEnding: !0, isMomentumCancel: !0 })
                : f({ isEnding: !0 }),
              (l.isMomentum = !1),
              (l.isStarted = !1));
        },
        E = (function (e) {
          var t = [],
            n = function (n) {
              n.removeEventListener("wheel", e),
                (t = t.filter(function (e) {
                  return e !== n;
                }));
            };
          return Dn({
            observe: function (i) {
              return (
                i.addEventListener("wheel", e, { passive: !1 }),
                t.push(i),
                function () {
                  return n(i);
                }
              );
            },
            unobserve: n,
            disconnect: function () {
              t.forEach(n);
            },
          });
        })(d),
        x = E.observe,
        L = E.unobserve,
        I = E.disconnect;
      return (
        h(e),
        Dn({
          on: r,
          off: o,
          observe: x,
          unobserve: L,
          disconnect: I,
          feedWheel: d,
          updateOptions: h,
        })
      );
    },
    Fn = {
      active: !0,
      breakpoints: {},
      wheelDraggingClass: "is-wheel-dragging",
      forceWheelAxis: void 0,
      target: void 0,
    };
  zn.globalOptions = void 0;
  var Vn = !1;
  function zn(e) {
    var t;
    void 0 === e && (e = {});
    var n = function () {};
    return {
      name: "wheelGestures",
      options: e,
      init: function (i, a) {
        var r,
          o,
          s = a.mergeOptions,
          c = a.optionsAtMedia,
          l = s(Fn, zn.globalOptions),
          u = s(l, e);
        t = c(u);
        var d,
          h = i.internalEngine(),
          f = null != (r = t.target) ? r : i.containerNode().parentNode,
          v = null != (o = t.forceWheelAxis) ? o : h.options.axis,
          p = Nn({ preventWheelAction: v, reverseSign: [!0, !0, !1] }),
          m = p.observe(f),
          y = p.on("wheel", function (e) {
            var i = e.axisDelta,
              a = i[0],
              r = i[1],
              o = "x" === v ? a : r,
              s = "x" === v ? r : a,
              c = e.isMomentum && e.previous && !e.previous.isMomentum,
              l = (e.isEnding && !e.isMomentum) || c;
            Math.abs(o) > Math.abs(s) &&
              !g &&
              !e.isMomentum &&
              (function (e) {
                try {
                  w((d = new MouseEvent("mousedown", e.event)));
                } catch (e) {
                  return (
                    Vn &&
                      console.warn(
                        "Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"
                      ),
                    n()
                  );
                }
                (g = !0),
                  document.documentElement.addEventListener("mousemove", _, !0),
                  document.documentElement.addEventListener("mouseup", _, !0),
                  void document.documentElement.addEventListener(
                    "mousedown",
                    _,
                    !0
                  ),
                  t.wheelDraggingClass && f.classList.add(t.wheelDraggingClass);
              })(e);
            if (!g) return;
            l
              ? (function (e) {
                  (g = !1),
                    w(k("mouseup", e)),
                    b(),
                    t.wheelDraggingClass &&
                      f.classList.remove(t.wheelDraggingClass);
                })(e)
              : w(k("mousemove", e));
          }),
          g = !1;
        function b() {
          document.documentElement.removeEventListener("mousemove", _, !0),
            document.documentElement.removeEventListener("mouseup", _, !0),
            document.documentElement.removeEventListener("mousedown", _, !0);
        }
        function _(e) {
          g && e.isTrusted && e.stopImmediatePropagation();
        }
        function k(e, t) {
          var n, i;
          if (v === h.options.axis) {
            var a = t.axisMovement;
            (n = a[0]), (i = a[1]);
          } else {
            var r = t.axisMovement;
            (i = r[0]), (n = r[1]);
          }
          return new MouseEvent(e, {
            clientX: d.clientX + n,
            clientY: d.clientY + i,
            screenX: d.screenX + n,
            screenY: d.screenY + i,
            movementX: n,
            movementY: i,
            button: 0,
            bubbles: !0,
            cancelable: !0,
            composed: !0,
          });
        }
        function w(e) {
          i.containerNode().dispatchEvent(e);
        }
        n = function () {
          m(), y(), b();
        };
      },
      destroy: function () {
        return n();
      },
    };
  }
  function Hn(e) {
    return "number" == typeof e;
  }
  function Un(e) {
    return "string" == typeof e;
  }
  function Kn(e) {
    return "boolean" == typeof e;
  }
  function Wn(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }
  function jn(e) {
    return Math.abs(e);
  }
  function Yn(e) {
    return Math.sign(e);
  }
  function Xn(e, t) {
    return jn(e - t);
  }
  function Qn(e) {
    return Jn(e).map(Number);
  }
  function Gn(e) {
    return e[Zn(e)];
  }
  function Zn(e) {
    return Math.max(0, e.length - 1);
  }
  function Jn(e) {
    return Object.keys(e);
  }
  function $n(e, t) {
    return [e, t].reduce(function (e, t) {
      return (
        Jn(t).forEach(function (n) {
          var i = e[n],
            a = t[n],
            r = Wn(i) && Wn(a);
          e[n] = r ? $n(i, a) : a;
        }),
        e
      );
    }, {});
  }
  function ei(e, t) {
    return void 0 !== t.MouseEvent && e instanceof t.MouseEvent;
  }
  function ti(e, t) {
    var n = function (e) {
        return t - e;
      },
      i = {
        start: function () {
          return 0;
        },
        center: function (e) {
          return n(e) / 2;
        },
        end: n,
      };
    return {
      measure: function (n) {
        return Hn(e) ? t * Number(e) : i[e](n);
      },
    };
  }
  function ni(e, t) {
    var n = function (t) {
        return t < e;
      },
      i = function (e) {
        return e > t;
      },
      a = function (e) {
        return n(e) || i(e);
      },
      r = jn(e - t);
    return {
      length: r,
      max: t,
      min: e,
      constrain: function (i) {
        return a(i) ? (n(i) ? e : t) : i;
      },
      reachedAny: a,
      reachedMax: i,
      reachedMin: n,
      removeOffset: function (e) {
        return r ? e - r * Math.ceil((e - t) / r) : e;
      },
    };
  }
  function ii(e, t, n) {
    var i = function (e) {
        return n ? jn((s + e) % s) : o(e);
      },
      a = function () {
        return c;
      },
      r = function () {
        return ii(e, a(), n);
      },
      o = ni(0, e).constrain,
      s = e + 1,
      c = i(t),
      l = {
        get: a,
        set: function (e) {
          return (c = i(e)), l;
        },
        add: function (e) {
          return r().set(a() + e);
        },
        clone: r,
      };
    return l;
  }
  function ai() {
    var e = [],
      t = {
        add: function (n, i, a) {
          var r =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : { passive: !0 };
          return (
            n.addEventListener(i, a, r),
            e.push(function () {
              return n.removeEventListener(i, a, r);
            }),
            t
          );
        },
        clear: function () {
          e = e.filter(function (e) {
            return e();
          });
        },
      };
    return t;
  }
  function ri(e, t, n, i, a, r, o, s, c, l, u, d, h, f, v, p, m, y, g) {
    var b = function (e) {
        var t,
          c,
          l = ei(e, a);
        ((N = l), l && 0 !== e.button) ||
          ((t = e.target),
          (c = t.nodeName || ""),
          C.includes(c) ||
            ((R = p && l && !e.buttons && P),
            (P = Xn(r.get(), s.get()) >= 2),
            (q = !0),
            o.pointerDown(e),
            u.useFriction(0).useDuration(0),
            r.set(s),
            (function () {
              var e = N ? i : n;
              L.add(e, "touchmove", _, E)
                .add(e, "touchend", k)
                .add(e, "mousemove", _, E)
                .add(e, "mouseup", k);
            })(),
            (M = o.readPoint(e)),
            (B = o.readPoint(e, S)),
            f.emit("pointerDown")));
      },
      _ = function (e) {
        var n = o.readPoint(e),
          i = o.readPoint(e, S),
          a = Xn(n, M),
          s = Xn(i, B);
        if (!O && !N) {
          if (!e.cancelable) return k(e);
          if (!(O = a > s)) return k(e);
        }
        var l = o.pointerMove(e);
        a > m && (R = !0),
          u.useFriction(0.3).useDuration(1),
          c.start(),
          r.add(t.apply(l)),
          e.preventDefault();
      },
      k = function (e) {
        var n = d.byDistance(0, !1).index !== h.get(),
          i = o.pointerUp(e) * (p ? A : T)[N ? "mouse" : "touch"],
          a = (function (e, t) {
            var n = h.add(-1 * Yn(e)),
              i = d.byDistance(e, !p).distance;
            return p || jn(e) < I
              ? i
              : y && t
              ? 0.5 * i
              : d.byIndex(n.get(), 0).distance;
          })(t.apply(i), n),
          r = (function (e, t) {
            if (0 === e || 0 === t) return 0;
            if (jn(e) <= jn(t)) return 0;
            var n = Xn(jn(e), jn(t));
            return jn(n / e);
          })(i, a),
          s = D - 10 * r,
          c = g + r / 50;
        (O = !1),
          (q = !1),
          L.clear(),
          u.useDuration(s).useFriction(c),
          l.distance(a, !p),
          (N = !1),
          f.emit("pointerUp");
      },
      w = function (e) {
        R && (e.stopPropagation(), e.preventDefault());
      },
      S = e.cross,
      C = ["INPUT", "SELECT", "TEXTAREA"],
      E = { passive: !1 },
      x = ai(),
      L = ai(),
      I = ni(50, 225).constrain(v.measure(20)),
      T = { mouse: 300, touch: 400 },
      A = { mouse: 500, touch: 600 },
      D = p ? 43 : 25,
      P = !1,
      M = 0,
      B = 0,
      q = !1,
      O = !1,
      R = !1,
      N = !1;
    return {
      init: function (e, t) {
        if (t) {
          var i = n;
          x.add(
            i,
            "dragstart",
            function (e) {
              return e.preventDefault();
            },
            E
          )
            .add(i, "touchmove", function () {}, E)
            .add(i, "touchend", function () {})
            .add(i, "touchstart", a)
            .add(i, "mousedown", a)
            .add(i, "touchcancel", k)
            .add(i, "contextmenu", k)
            .add(i, "click", w, !0);
        }
        function a(n) {
          (Kn(t) || t(e, n)) && b(n);
        }
      },
      pointerDown: function () {
        return q;
      },
      destroy: function () {
        x.clear(), L.clear();
      },
    };
  }
  function oi(e, t) {
    var n,
      i,
      a = function (e) {
        return e.timeStamp;
      },
      r = function (n, i) {
        var a = i || e.scroll,
          r = "client".concat("x" === a ? "X" : "Y");
        return (ei(n, t) ? n : n.touches[0])[r];
      },
      o = 170;
    return {
      pointerDown: function (e) {
        return (n = e), (i = e), r(e);
      },
      pointerMove: function (e) {
        var t = r(e) - r(i),
          s = a(e) - a(n) > o;
        return (i = e), s && (n = e), t;
      },
      pointerUp: function (e) {
        if (!n || !i) return 0;
        var t = r(i) - r(n),
          s = a(e) - a(n),
          c = a(e) - a(i) > o,
          l = t / s;
        return s && !c && jn(l) > 0.1 ? l : 0;
      },
      readPoint: r,
    };
  }
  function si(e, t, n, i, a) {
    var r,
      o,
      s = function (e) {
        return a.measureSize(e.getBoundingClientRect());
      },
      c = [],
      l = !1;
    return {
      init: function (a, u) {
        u &&
          ((o = s(e)),
          (c = i.map(s)),
          (r = new ResizeObserver(function (r) {
            l ||
              ((Kn(u) || u(a, r)) &&
                (function (r) {
                  var l = !0,
                    u = !1,
                    d = void 0;
                  try {
                    for (
                      var h, f = r[Symbol.iterator]();
                      !(l = (h = f.next()).done);
                      l = !0
                    ) {
                      var v = h.value,
                        p = v.target === e,
                        m = i.indexOf(v.target);
                      if ((p ? o : c[m]) !== s(p ? e : i[m])) {
                        n.requestAnimationFrame(function () {
                          a.reInit(), t.emit("resize");
                        });
                        break;
                      }
                    }
                  } catch (e) {
                    (u = !0), (d = e);
                  } finally {
                    try {
                      l || null == f.return || f.return();
                    } finally {
                      if (u) throw d;
                    }
                  }
                })(r));
          })),
          [e].concat(i).forEach(function (e) {
            return r.observe(e);
          }));
      },
      destroy: function () {
        r && r.disconnect(), (l = !0);
      },
    };
  }
  function ci(e, t, n, i, a) {
    var r = a.measure(10),
      o = a.measure(50),
      s = ni(0.1, 0.99),
      c = !1;
    return {
      constrain: function (a) {
        if (!c && e.reachedAny(n.get()) && e.reachedAny(t.get())) {
          var l = e.reachedMin(t.get()) ? "min" : "max",
            u = jn(e[l] - t.get()),
            d = n.get() - t.get(),
            h = s.constrain(u / o);
          n.subtract(d * h),
            !a &&
              jn(d) < r &&
              (n.set(e.constrain(n.get())),
              i.useDuration(25).useBaseFriction());
        }
      },
      toggleActive: function (e) {
        c = !e;
      },
    };
  }
  function li(e, t, n, i) {
    var a = ni(-t + e, n[0]),
      r = n.map(a.constrain).map(function (e) {
        return parseFloat(e.toFixed(3));
      });
    return {
      snapsContained: (function () {
        if (t <= e) return [a.max];
        if ("keepSnaps" === i) return r;
        var n,
          o,
          s = ((n = r[0]), (o = Gn(r)), ni(r.lastIndexOf(n), r.indexOf(o) + 1)),
          c = s.min,
          l = s.max;
        return r.slice(c, l);
      })(),
    };
  }
  function ui(e, t, n, i) {
    var a = ni(t.min + 0.1, t.max + 0.1),
      r = a.reachedMin,
      o = a.reachedMax;
    return {
      loop: function (t) {
        if (
          (function (e) {
            return 1 === e ? o(n.get()) : -1 === e && r(n.get());
          })(t)
        ) {
          var a = e * (-1 * t);
          i.forEach(function (e) {
            return e.add(a);
          });
        }
      },
    };
  }
  function di(e) {
    var t = e.max,
      n = e.length;
    return {
      get: function (e) {
        return (e - t) / -n;
      },
    };
  }
  function hi(e, t, n, i, a) {
    var r = function (e) {
        return e.concat().sort(function (e, t) {
          return jn(e) - jn(t);
        })[0];
      },
      o = function (t, i) {
        var a = [t, t + n, t - n];
        if (!e) return a[0];
        if (!i) return r(a);
        var o = a.filter(function (e) {
          return Yn(e) === i;
        });
        return r(o);
      },
      s = i.reachedAny,
      c = i.removeOffset,
      l = i.constrain;
    return {
      byDistance: function (n, i) {
        var r = a.get() + n,
          u = (function (n) {
            var i = e ? c(n) : l(n);
            return {
              index: t
                .map(function (e) {
                  return e - i;
                })
                .map(function (e) {
                  return o(e, 0);
                })
                .map(function (e, t) {
                  return { diff: e, index: t };
                })
                .sort(function (e, t) {
                  return jn(e.diff) - jn(t.diff);
                })[0].index,
              distance: i,
            };
          })(r),
          d = u.index,
          h = u.distance,
          f = !e && s(r);
        if (!i || f) return { index: d, distance: n };
        var v = t[d] - h;
        return { index: d, distance: n + o(v, 0) };
      },
      byIndex: function (e, n) {
        var i = t[e] - a.get();
        return { index: e, distance: o(i, n) };
      },
      shortcut: o,
    };
  }
  function fi(e) {
    var t = function (e) {
        return Hn(e) ? e : e.get();
      },
      n = e;
    return {
      get: function () {
        return n;
      },
      set: function (e) {
        n = t(e);
      },
      add: function (e) {
        n += t(e);
      },
      subtract: function (e) {
        n -= t(e);
      },
    };
  }
  function vi(e, t, n) {
    var i =
        "x" === e.scroll
          ? function (e) {
              return "translate3d(".concat(e, "px,0px,0px)");
            }
          : function (e) {
              return "translate3d(0px,".concat(e, "px,0px)");
            },
      a = n.style,
      r = !1;
    return {
      clear: function () {
        r ||
          ((a.transform = ""),
          n.getAttribute("style") || n.removeAttribute("style"));
      },
      to: function (e) {
        r || (a.transform = i(t.apply(e)));
      },
      toggleActive: function (e) {
        r = !e;
      },
    };
  }
  function pi(e, t, n, i, a, r, o, s, c) {
    var l,
      u,
      d = function (e, t) {
        return e.reduce(function (e, t) {
          return e - a[t];
        }, t);
      },
      h = function (e, t) {
        return e.reduce(function (e, n) {
          return d(e, t) > 0 ? e.concat([n]) : e;
        }, []);
      },
      f = function (n, a) {
        var r = "start" === a,
          l = r ? -i : i,
          u = o.findSlideBounds([l]);
        return n.map(function (n) {
          var a = r ? 0 : -i,
            o = r ? i : 0,
            l = u.filter(function (e) {
              return e.index === n;
            })[0][r ? "end" : "start"];
          return {
            index: n,
            slideLocation: fi(-1),
            translate: vi(e, t, c[n]),
            target: function () {
              return s.get() > l ? a : o;
            },
          };
        });
      },
      v = Qn(a),
      p = Qn(a).reverse(),
      m = ((l = r[0] - 1), (u = h(p, l)), f(u, "end")).concat(
        (function () {
          var e = n - r[0] - 1,
            t = h(v, e);
          return f(t, "start");
        })()
      );
    return {
      canLoop: function () {
        return m.every(function (e) {
          var t = e.index,
            i = v.filter(function (e) {
              return e !== t;
            });
          return d(i, n) <= 0.1;
        });
      },
      clear: function () {
        m.forEach(function (e) {
          return e.translate.clear();
        });
      },
      loop: function () {
        m.forEach(function (e) {
          var t = e.target,
            n = e.translate,
            i = e.slideLocation,
            a = t();
          a !== i.get() && (n.to(a), i.set(a));
        });
      },
      loopPoints: m,
    };
  }
  function mi(e, t) {
    var n,
      i = !1;
    return {
      init: function (a, r) {
        r &&
          (n = new MutationObserver(function (e) {
            i ||
              ((Kn(r) || r(a, e)) &&
                (function (e) {
                  var n = !0,
                    i = !1,
                    r = void 0;
                  try {
                    for (
                      var o, s = e[Symbol.iterator]();
                      !(n = (o = s.next()).done);
                      n = !0
                    )
                      if ("childList" === o.value.type) {
                        a.reInit(), t.emit("slidesChanged");
                        break;
                      }
                  } catch (e) {
                    (i = !0), (r = e);
                  } finally {
                    try {
                      n || null == s.return || s.return();
                    } finally {
                      if (i) throw r;
                    }
                  }
                })(e));
          })).observe(e, { childList: !0 });
      },
      destroy: function () {
        n && n.disconnect(), (i = !0);
      },
    };
  }
  function yi(e, t, n, i, a, r, o) {
    var s = function (t, a) {
        var r = t || d,
          o = (function (e) {
            var t = e || 0;
            return n.map(function (e) {
              return ni(u, e - u).constrain(e * t);
            });
          })(a);
        return r.reduce(function (t, a) {
          var r = i.map(function (t, i) {
            return {
              start: t - n[i] + o[i] + a,
              end: t + e - o[i] + a,
              index: i,
            };
          });
          return t.concat(r);
        }, []);
      },
      c = a.removeOffset,
      l = a.constrain,
      u = 0.5,
      d = r ? [0, t, -t] : [0],
      h = s(d, o);
    return {
      check: function (e, t) {
        var n = r ? c(e) : l(e);
        return (t || h).reduce(function (e, t) {
          var i = t.index,
            a = t.start,
            r = t.end;
          return !e.includes(i) && a < n && r > n ? e.concat([i]) : e;
        }, []);
      },
      findSlideBounds: s,
    };
  }
  function gi(e, t, n) {
    var i = Hn(n);
    return {
      groupSlides: function (a) {
        return i
          ? (function (e, t) {
              return Qn(e)
                .filter(function (e) {
                  return e % t == 0;
                })
                .map(function (n) {
                  return e.slice(n, n + t);
                });
            })(a, n)
          : (function (n) {
              return Qn(n)
                .reduce(function (n, i) {
                  var a = t.slice(Gn(n), i + 1).reduce(function (e, t) {
                    return e + t;
                  }, 0);
                  return !i || a > e ? n.concat(i) : n;
                }, [])
                .map(function (e, t, i) {
                  return n.slice(e, i[t + 1]);
                });
            })(a);
      },
    };
  }
  function bi(e, t, n, i, a, r, o, s) {
    var c = r.align,
      l = r.axis,
      u = r.direction,
      d = r.startIndex,
      h = r.inViewThreshold,
      f = r.loop,
      v = r.duration,
      p = r.dragFree,
      m = r.dragThreshold,
      y = r.slidesToScroll,
      g = r.skipSnaps,
      b = r.containScroll,
      _ = t.getBoundingClientRect(),
      k = n.map(function (e) {
        return e.getBoundingClientRect();
      }),
      w = (function (e) {
        var t = "rtl" === e ? -1 : 1;
        return {
          apply: function (e) {
            return e * t;
          },
        };
      })(u),
      S = (function (e, t) {
        var n = "y" === e ? "y" : "x";
        return {
          scroll: n,
          cross: "y" === e ? "x" : "y",
          startEdge: "y" === n ? "top" : "rtl" === t ? "right" : "left",
          endEdge: "y" === n ? "bottom" : "rtl" === t ? "left" : "right",
          measureSize: function (e) {
            var t = e.width,
              i = e.height;
            return "x" === n ? t : i;
          },
        };
      })(l, u),
      C = S.measureSize(_),
      E = (function (e) {
        return {
          measure: function (t) {
            return e * (t / 100);
          },
        };
      })(C),
      x = ti(c, C),
      L = !f && !!b,
      I = (function (e, t, n, i, a, r) {
        var o = e.measureSize,
          s = e.startEdge,
          c = e.endEdge,
          l = n[0] && a,
          u = (function () {
            if (!l) return 0;
            var e = n[0];
            return jn(t[s] - e[s]);
          })(),
          d = (function () {
            if (!l) return 0;
            var e = r.getComputedStyle(Gn(i));
            return parseFloat(e.getPropertyValue("margin-".concat(c)));
          })(),
          h = n.map(o),
          f = n
            .map(function (e, t, n) {
              var i = !t,
                a = t === Zn(n);
              return i ? h[t] + u : a ? h[t] + d : n[t + 1][s] - e[s];
            })
            .map(jn);
        return { slideSizes: h, slideSizesWithGaps: f };
      })(S, _, k, n, f || !!b, a),
      T = I.slideSizes,
      A = I.slideSizesWithGaps,
      D = gi(C, A, y),
      P = (function (e, t, n, i, a, r, o) {
        var s,
          c = e.startEdge,
          l = e.endEdge,
          u = r.groupSlides,
          d = u(i)
            .map(function (e) {
              return Gn(e)[l] - e[0][c];
            })
            .map(jn)
            .map(t.measure),
          h = i
            .map(function (e) {
              return n[c] - e[c];
            })
            .map(function (e) {
              return -jn(e);
            }),
          f =
            ((s = Gn(h) - Gn(a)),
            u(h)
              .map(function (e) {
                return e[0];
              })
              .map(function (e, t, n) {
                var i = !t,
                  a = t === Zn(n);
                return o && i ? 0 : o && a ? s : e + d[t];
              }));
        return { snaps: h, snapsAligned: f };
      })(S, x, _, k, A, D, L),
      M = P.snaps,
      B = P.snapsAligned,
      q = -Gn(M) + Gn(A),
      O = li(C, q, B, b).snapsContained,
      R = L ? O : B,
      N = (function (e, t, n) {
        var i = t[0];
        return { limit: ni(n ? i - e : Gn(t), i) };
      })(q, R, f).limit,
      F = ii(Zn(R), d, f),
      V = F.clone(),
      z = Qn(n),
      H = {
        start: function () {
          return s.start(Z);
        },
        stop: function () {
          return s.stop(Z);
        },
        update: function () {
          return (function (e) {
            var t = e.dragHandler,
              n = e.scrollBody,
              i = e.scrollBounds,
              a = e.eventHandler,
              r = e.animation,
              o = e.options.loop,
              s = t.pointerDown();
            o || i.constrain(s);
            var c = n.seek().settled();
            c && !s && (r.stop(), a.emit("settle")), c || a.emit("scroll");
          })(Z);
        },
        render: function (e) {
          return (function (e, t) {
            var n = e.scrollBody,
              i = e.translate,
              a = e.location,
              r = e.offsetLocation,
              o = e.scrollLooper,
              s = e.slideLooper,
              c = e.options.loop,
              l = n.velocity();
            r.set(a.get() - l + l * t),
              c && (o.loop(n.direction()), s.loop()),
              i.to(r.get());
          })(Z, e);
        },
      },
      U = R[F.get()],
      K = fi(U),
      W = fi(U),
      j = fi(U),
      Y = (function (e, t, n, i) {
        var a = function (e) {
            return (l = e), f;
          },
          r = function (e) {
            return (u = e), f;
          },
          o = !0,
          s = 0,
          c = 0,
          l = n,
          u = i,
          d = e.get(),
          h = 0,
          f = {
            direction: function () {
              return c;
            },
            duration: function () {
              return l;
            },
            velocity: function () {
              return s;
            },
            seek: function () {
              var n = t.get() - e.get(),
                i = 0;
              return (
                l
                  ? ((s += n / l), (d += s *= u), e.add(s), (i = d - h))
                  : ((s = 0), e.set(t), (i = n)),
                (c = Yn(i)),
                (h = d),
                (o = jn(n) < 0.001),
                f
              );
            },
            settled: function () {
              return o;
            },
            useBaseFriction: function () {
              return r(i);
            },
            useBaseDuration: function () {
              return a(n);
            },
            useFriction: r,
            useDuration: a,
          };
        return f;
      })(K, j, v, 0.68),
      X = hi(f, R, q, N, j),
      Q = (function (e, t, n, i, a, r, o) {
        var s = function (i) {
          var s = i.distance,
            c = i.index !== t.get();
          r.add(s),
            s &&
              (a.duration()
                ? e.start()
                : (e.update(), e.render(1), e.update())),
            c && (n.set(t.get()), t.set(i.index), o.emit("select"));
        };
        return {
          distance: function (e, t) {
            var n = i.byDistance(e, t);
            s(n);
          },
          index: function (e, n) {
            var a = t.clone().set(e),
              r = i.byIndex(a.get(), n);
            s(r);
          },
        };
      })(H, F, V, X, Y, j, o),
      G = yi(C, q, T, M, N, f, h),
      Z = {
        ownerDocument: i,
        ownerWindow: a,
        eventHandler: o,
        containerRect: _,
        slideRects: k,
        animation: H,
        axis: S,
        direction: w,
        dragHandler: ri(
          S,
          w,
          e,
          i,
          a,
          j,
          oi(S, a),
          K,
          H,
          Q,
          Y,
          X,
          F,
          o,
          E,
          p,
          m,
          g,
          0.68
        ),
        eventStore: ai(),
        percentOfView: E,
        index: F,
        indexPrevious: V,
        limit: N,
        location: K,
        offsetLocation: W,
        options: r,
        resizeHandler: si(t, o, a, n, S),
        scrollBody: Y,
        scrollBounds: ci(N, K, j, Y, E),
        scrollLooper: ui(q, N, W, [K, W, j]),
        scrollProgress: di(N),
        scrollSnaps: R,
        scrollTarget: X,
        scrollTo: Q,
        slideLooper: pi(S, w, C, q, A, R, G, W, n),
        slidesHandler: mi(t, o),
        slidesInView: G,
        slideIndexes: z,
        slidesToScroll: D,
        target: j,
        translate: vi(S, w, t),
      };
    return Z;
  }
  var _i = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    breakpoints: {},
    dragFree: !1,
    dragThreshold: 10,
    inViewThreshold: 0,
    loop: !1,
    skipSnaps: !1,
    duration: 25,
    startIndex: 0,
    active: !0,
    watchDrag: !0,
    watchResize: !0,
    watchSlides: !0,
  };
  function ki(e) {
    var t = function (e, t) {
        return $n(e, t || {});
      },
      n = {
        mergeOptions: t,
        optionsAtMedia: function (n) {
          var i = n.breakpoints || {},
            a = Jn(i)
              .filter(function (t) {
                return e.matchMedia(t).matches;
              })
              .map(function (e) {
                return i[e];
              })
              .reduce(function (e, n) {
                return t(e, n);
              }, {});
          return t(n, a);
        },
        optionsMediaQueries: function (t) {
          return t
            .map(function (e) {
              return Jn(e.breakpoints || {});
            })
            .reduce(function (e, t) {
              return e.concat(t);
            }, [])
            .map(e.matchMedia);
        },
      };
    return n;
  }
  function wi(e, t, n) {
    var i,
      r,
      o,
      s,
      c = function (t, n) {
        if (!A) {
          var a = k.find(function (e) {
              return e.window === p;
            }),
            c =
              a ||
              (function (e) {
                var t = 1e3 / 60,
                  n = [],
                  i = null,
                  a = 0,
                  r = 0;
                function o(s) {
                  i || (i = s);
                  var c = s - i;
                  for (i = s, a += c; a >= t; )
                    n.forEach(function (e) {
                      return e.animation.update();
                    }),
                      (a -= t);
                  var l = jn(a / t);
                  n.forEach(function (e) {
                    return e.animation.render(l);
                  }),
                    r && e.requestAnimationFrame(o);
                }
                return {
                  start: function (t) {
                    n.includes(t) || n.push(t),
                      r || (r = e.requestAnimationFrame(o));
                  },
                  stop: function (t) {
                    (n = n.filter(function (e) {
                      return e !== t;
                    })).length ||
                      (e.cancelAnimationFrame(r), (i = null), (a = 0), (r = 0));
                  },
                  reset: function () {
                    (i = null), (a = 0);
                  },
                  window: e,
                };
              })(p);
          a || k.push(c),
            (D = w(D, t)),
            (P = S(D)),
            (M = n || M),
            (function () {
              var t = P.container,
                n = P.slides,
                i = Un(t) ? e.querySelector(t) : t;
              o = i || e.children[0];
              var a = Un(n) ? o.querySelectorAll(n) : n;
              s = [].slice.call(a || o.children);
            })(),
            (i = B(P, c)),
            C(
              [D].concat(
                L(
                  M.map(function (e) {
                    return e.options;
                  })
                )
              )
            ).forEach(function (e) {
              return g.add(e, "change", l);
            }),
            P.active &&
              (i.translate.to(i.location.get()),
              i.eventHandler.init(q),
              i.resizeHandler.init(q, P.watchResize),
              i.slidesHandler.init(q, P.watchSlides),
              b.add(v, "visibilitychange", function () {
                v.hidden && c.reset();
              }),
              i.options.loop && i.slideLooper.loop(),
              o.offsetParent && s.length && i.dragHandler.init(q, P.watchDrag),
              (r = y.init(M, q)));
        }
      },
      l = function (e, t) {
        var n = f();
        u(), c(w({ startIndex: n }, e), t), _.emit("reInit");
      },
      u = function () {
        i.dragHandler.destroy(),
          i.animation.stop(),
          i.eventStore.clear(),
          i.translate.clear(),
          i.slideLooper.clear(),
          i.resizeHandler.destroy(),
          i.slidesHandler.destroy(),
          y.destroy(),
          g.clear(),
          b.clear();
      },
      d = function (e) {
        var t = i[e ? "target" : "location"].get(),
          n = P.loop ? "removeOffset" : "constrain";
        return i.slidesInView.check(i.limit[n](t));
      },
      h = function (e, t, n) {
        P.active &&
          !A &&
          (i.scrollBody.useBaseFriction().useDuration(t ? 0 : P.duration),
          i.scrollTo.index(e, n || 0));
      },
      f = function () {
        return i.index.get();
      },
      v = e.ownerDocument,
      p = v.defaultView,
      m = ki(p),
      y = (function (e) {
        var t = [];
        return {
          init: function (n, i) {
            return (
              (t = n.filter(function (t) {
                var n = t.options;
                return !1 !== e.optionsAtMedia(n).active;
              })).forEach(function (t) {
                return t.init(i, e);
              }),
              n.reduce(function (e, t) {
                return Object.assign(e, a({}, t.name, t));
              }, {})
            );
          },
          destroy: function () {
            t = t.filter(function (e) {
              return e.destroy();
            });
          },
        };
      })(m),
      g = ai(),
      b = ai(),
      _ = (function () {
        var e,
          t = function (e) {
            return n[e] || [];
          },
          n = {},
          i = {
            init: function (t) {
              e = t;
            },
            emit: function (n) {
              return (
                t(n).forEach(function (t) {
                  return t(e, n);
                }),
                i
              );
            },
            off: function (e, a) {
              return (
                (n[e] = t(e).filter(function (e) {
                  return e !== a;
                })),
                i
              );
            },
            on: function (e, a) {
              return (n[e] = t(e).concat([a])), i;
            },
          };
        return i;
      })(),
      k = wi.animationRealms,
      w = m.mergeOptions,
      S = m.optionsAtMedia,
      C = m.optionsMediaQueries,
      E = _.on,
      x = _.off,
      I = _.emit,
      T = l,
      A = !1,
      D = w(_i, wi.globalOptions),
      P = w(D),
      M = [];
    function B(t, n) {
      var i = bi(e, o, s, v, p, t, _, n);
      return t.loop && !i.slideLooper.canLoop()
        ? B(Object.assign({}, t, { loop: !1 }), n)
        : i;
    }
    var q = {
      canScrollNext: function () {
        return i.index.add(1).get() !== f();
      },
      canScrollPrev: function () {
        return i.index.add(-1).get() !== f();
      },
      containerNode: function () {
        return o;
      },
      internalEngine: function () {
        return i;
      },
      destroy: function () {
        A || ((A = !0), g.clear(), u(), _.emit("destroy"));
      },
      off: x,
      on: E,
      emit: I,
      plugins: function () {
        return r;
      },
      previousScrollSnap: function () {
        return i.indexPrevious.get();
      },
      reInit: T,
      rootNode: function () {
        return e;
      },
      scrollNext: function (e) {
        var t = i.index.add(1).get();
        h(t, !0 === e, -1);
      },
      scrollPrev: function (e) {
        var t = i.index.add(-1).get();
        h(t, !0 === e, 1);
      },
      scrollProgress: function () {
        return i.scrollProgress.get(i.location.get());
      },
      scrollSnapList: function () {
        return i.scrollSnaps.map(i.scrollProgress.get);
      },
      scrollTo: h,
      selectedScrollSnap: f,
      slideNodes: function () {
        return s;
      },
      slidesInView: d,
      slidesNotInView: function (e) {
        var t = d(e);
        return i.slideIndexes.filter(function (e) {
          return !t.includes(e);
        });
      },
    };
    return (
      c(t, n),
      setTimeout(function () {
        return _.emit("init");
      }, 0),
      q
    );
  }
  (wi.animationRealms = []), (wi.globalOptions = void 0);
  var Si = {
    active: !0,
    breakpoints: {},
    selected: "is-selected",
    draggable: "is-draggable",
    dragging: "is-dragging",
  };
  function Ci(e, t) {
    var n = e.classList;
    t && n.contains(t) && n.remove(t);
  }
  function Ei(e, t) {
    var n = e.classList;
    t && !n.contains(t) && n.add(t);
  }
  function xi() {
    var e,
      t,
      n,
      i,
      a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      r = function (t, i) {
        "pointerDown" === i ? Ei(n, e.dragging) : Ci(n, e.dragging);
      },
      o = function () {
        var n = t.slidesInView(!0);
        t.slidesNotInView(!0).forEach(function (t) {
          return Ci(i[t], e.selected);
        }),
          n.forEach(function (t) {
            return Ei(i[t], e.selected);
          });
      },
      s = ["select", "pointerUp"],
      c = ["pointerDown", "pointerUp"];
    return {
      name: "classNames",
      options: a,
      init: function (l, u) {
        t = l;
        var d = u.mergeOptions,
          h = u.optionsAtMedia,
          f = d(Si, xi.globalOptions),
          v = d(f, a);
        (e = h(v)),
          (n = t.rootNode()),
          (i = t.slideNodes()),
          !!t.internalEngine().options.watchDrag && Ei(n, e.draggable),
          e.dragging &&
            c.forEach(function (e) {
              return t.on(e, r);
            }),
          e.selected &&
            (s.forEach(function (e) {
              return t.on(e, o);
            }),
            o());
      },
      destroy: function () {
        Ci(n, e.draggable),
          c.forEach(function (e) {
            return t.off(e, r);
          }),
          s.forEach(function (e) {
            return t.off(e, o);
          }),
          i.forEach(function (t) {
            return Ci(t, e.selected);
          });
      },
    };
  }
  xi.globalOptions = void 0;
  var Li,
    Ii,
    Ti,
    Ai,
    Di = "idle",
    Pi = "running",
    Mi = "paused",
    Bi = "resumed",
    qi = (function () {
      "use strict";
      function e(t, n) {
        m(this, e),
          (this.interval = n),
          (this.callback = t),
          (this.state = Di),
          (this.pausedTime = 0),
          (this.remainingTime = 0);
      }
      return (
        g(e, [
          {
            key: "proxyCallback",
            value: function () {
              (this.lastFireTime = new Date()), this.callback();
            },
          },
          {
            key: "start",
            value: function () {
              var e = this;
              (this.timerId = setInterval(function () {
                return e.proxyCallback();
              }, this.interval)),
                (this.lastFireTime = new Date()),
                (this.state = Pi);
            },
          },
          {
            key: "pause",
            value: function () {
              (this.state !== Pi && this.state !== Bi) ||
                ((this.remainingTime =
                  this.interval -
                  (new Date() - this.lastFireTime) +
                  this.pausedTime),
                (this.lastPauseTime = new Date()),
                clearInterval(this.timerId),
                clearTimeout(this.resumeId),
                (this.state = Mi));
            },
          },
          {
            key: "resume",
            value: function () {
              var e = this;
              this.state === Mi &&
                ((this.pausedTime += new Date() - this.lastPauseTime),
                (this.state = Bi),
                (this.resumeId = setTimeout(function () {
                  return e.timeoutCallback();
                }, this.remainingTime)));
            },
          },
          {
            key: "timeoutCallback",
            value: function () {
              this.state === Bi &&
                ((this.pausedTime = 0), this.proxyCallback(), this.start());
            },
          },
          {
            key: "stop",
            value: function () {
              this.state !== Di &&
                (clearInterval(this.timerId),
                clearTimeout(this.resumeId),
                (this.state = Di));
            },
          },
          {
            key: "setInterval",
            value: function (e) {
              this.state === Pi
                ? (this.pause(), (this.interval = e), this.resume())
                : (this.interval = e);
            },
          },
        ]),
        e
      );
    })(),
    Oi = {};
  (Li = Oi),
    (Ii = "debounce"),
    (Ti = function () {
      return Ri;
    }),
    (Ai = function (e) {
      return (Ri = e);
    }),
    Object.defineProperty(Li, Ii, {
      get: Ti,
      set: Ai,
      enumerable: !0,
      configurable: !0,
    });
  var Ri = function (e, t) {
      var n;
      return function () {
        for (var i = arguments.length, a = new Array(i), r = 0; r < i; r++)
          a[r] = arguments[r];
        clearTimeout(n),
          (n = setTimeout(function () {
            return e.apply(undefined, a);
          }, t));
      };
    },
    Ni = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        m(this, n),
          a(
            p((e = t.call(this))),
            "attributeChangedCallback",
            function (t, n, i) {
              n !== i && e.reInit();
            }
          ),
          a(p(e), "_handleCarouselTargetKeyDown", function (t) {
            t.preventDefault();
            var n = e.focusableTargets.findIndex(function (e) {
                return e === t.target;
              }),
              i = e.focusableTargets[n],
              a = e.focusableTargets[n + 1],
              r = e.focusableTargets[n - 1];
            9 === t.keyCode &&
              (t.preventDefault(),
              document.activeElement === i && e.focusScroll(i),
              t.shiftKey ||
                (a ? e.focusScroll(a) : document.activeElement.blur()),
              t.shiftKey &&
                (r ? e.focusScroll(r) : document.activeElement.blur()));
          }),
          a(
            p(e),
            "_handleCarouselResize",
            (0, Oi.debounce)(function () {
              if (e._isEditorMode) {
                var t = wn() ? "mobile" : "desktop";
                e.lastViewModeIsMobile !== t &&
                  e.forceStopped &&
                  (e.forcePlay(), e.changePlayState(!0)),
                  (e.lastViewModeIsMobile = t);
              }
              e.reInit();
            }, 250)
          ),
          a(p(e), "focusScroll", function (t) {
            var n = e.slides.findIndex(function (e) {
              return e.contains(t);
            });
            -1 !== n && (e.embla.scrollTo(n, !0), e.forceStop()), t.focus();
          }),
          a(p(e), "_handleCarouselEnter", function () {
            wn() || e.changePlayState(!1);
          }),
          a(p(e), "_handleCarouselSelect", function () {
            e.isTouchOnCarousel && e.forceStop();
          }),
          a(p(e), "_handleCarouselPointerUp", function () {
            e.isTouchOnCarousel = !1;
          }),
          a(p(e), "_handleCarouselPointerDown", function () {
            e.isTouchOnCarousel = !0;
          }),
          a(p(e), "_handleCarouselLeave", function () {
            wn() || e.changePlayState(!0);
          }),
          a(p(e), "_handleKeydown", function (t) {
            var n = t.key || t.keyCode,
              i = Z(n),
              a = G(n);
            i && e.embla.scrollPrev(), a && e.embla.scrollNext();
          }),
          a(p(e), "_handleBlockSelect", function (t) {
            var n = t.detail,
              i = n.sectionId,
              a = n.blockId,
              r = n.load;
            if (e.dataset.sectionId === i) {
              var o = e.embla.slideNodes().findIndex(function (e) {
                var t;
                return (
                  (null === (t = e.attributes["block-id"]) || void 0 === t
                    ? void 0
                    : t.value) === a
                );
              });
              -1 !== o && (e.embla.scrollTo(o, r), e.forceStop());
            }
          }),
          a(p(e), "_handleSectionLoad", function (t) {
            var n = t.detail.sectionId;
            e.dataset.sectionId === n && e.reInit();
          }),
          a(p(e), "_getOptions", function () {
            return {
              loop: "infinite" === e.dataset.loop,
              dragFree: e.dataset.dragFree,
              draggable:
                !e.hasAttribute("data-draggable") ||
                "true" === e.dataset.draggable,
              skipSnaps: e.hasAttribute("data-skip-snaps"),
              align: e.dataset.align || "start",
              inViewThreshold: +(e.dataset.inViewThreshhold || 0) || 0.75,
              containScroll: e.hasAttribute("data-contain-scroll")
                ? e.dataset.containScroll
                : "trimSnaps",
              axis: e._axis,
              speed: e._getSpeed(),
            };
          }),
          a(p(e), "_getPlugins", function () {
            var t = [],
              n = xi();
            if ((t.push(n), e.hasAttribute("data-with-wheel-gestures"))) {
              var i = zn({ forceWheelAxis: e._axis });
              t.push(i);
            }
            return t;
          }),
          a(p(e), "changePlayState", function (t) {
            e.withAutoplay &&
              (e.forceStopped ||
                ((e.isPlay = t),
                t ? e.autoplay.play() : e.autoplay.pause(),
                e.emit("changePlayState", {})));
          }),
          a(p(e), "reInit", function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : {},
              n = r({}, e._getOptions(), t),
              i = e._getPlugins();
            e.embla.reInit(n, i);
          }),
          a(p(e), "scrollNext", function () {

            // Storyside trying to fix scroll issue on rebuild of mobile pdp carousel
            // NOT WORKING TO LOG ANYTHING ON PDP
            // console.log('Storyside scrollNext for embla');

            e.embla.scrollNext();
          }),
          a(p(e), "scrollPrev", function () {
            e.embla.scrollPrev();
          }),
          a(p(e), "canScrollNext", function () {
            return e.embla.canScrollNext();
          }),
          a(p(e), "canScrollPrev", function () {
            return e.embla.canScrollPrev();
          });
        var i = +(e.dataset.autoplayInterval || 0);
        return (
          (e.withAutoplay = i > 0),
          (e.isPlay = i > 0),
          (e.forceStopped = !1),
          (e.resizeObserver = new ResizeObserver(e._handleCarouselResize)),
          e.resizeObserver.observe(p(e)),
          (e.focusableTargets = L(e.querySelectorAll(W()))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._setCarousel(),
                this.focusableTargets.forEach(function (t) {
                  t.addEventListener("keydown", e._handleCarouselTargetKeyDown);
                }),
                this.withStopOnHover &&
                  (H(this, "mouseenter", this._handleCarouselEnter),
                  H(this, "mouseleave", this._handleCarouselLeave)),
                H(this, "keydown", this._handleKeydown),
                this.embla.on("select", this._handleCarouselSelect),
                this.embla.on("pointerUp", this._handleCarouselPointerUp),
                this.embla.on("pointerDown", this._handleCarouselPointerDown),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.focusableTargets.forEach(function (t) {
                t.removeEventListener(
                  "keydown",
                  e._handleCarouselTargetKeyDown
                );
              }),
                this.resizeObserver.disconnect(),
                this.withStopOnHover &&
                  (U(this, "mouseenter", this._handleCarouselEnter),
                  U(this, "mouseleave", this._handleCarouselLeave)),
                U(this, "keydown", this._handleKeydown),
                this.embla.off("select", this._handleCarouselSelect),
                this.embla.off("pointerUp", this._handleCarouselPointerUp),
                this.embla.off("pointerDown", this._handleCarouselPointerDown),
                this._isEditorMode && this._editor.destroy(),
                this.embla.destroy();
            },
          },
          {
            key: "_setCarousel",
            value: function () {
              var e,
                t,
                n,
                i = this.querySelector("[data-carousel-viewport]");
              i &&
                ((this.embla = wi(i, this._getOptions(), this._getPlugins())),
                this.withAutoplay &&
                  ((this.autoplay =
                    ((e = this.embla),
                    (t = 1e3 * this.autoplayInterval),
                    (n = new qi(function () {
                      var t = e.scrollSnapList().length - 1;
                      e.selectedScrollSnap() === t
                        ? e.scrollTo(0)
                        : e.scrollNext();
                    }, t)),
                    {
                      play: function () {
                        n.resume();
                      },
                      stop: function () {
                        n.stop();
                      },
                      start: function () {
                        n.start();
                      },
                      pause: function () {
                        n.pause();
                      },
                    })),
                  this.autoplay.start()));
            },
          },
          {
            key: "_getClassNamesPlugin",
            value: function () {
              return xi();
            },
          },
          {
            key: "_getSpeed",
            value: function () {
              return Sn() || "fade" === this.dataset.animation ? 100 : 10;
            },
          },
          {
            key: "forceStop",
            value: function () {
              this.withAutoplay &&
                (this.autoplay.stop(),
                (this.isPlay = !1),
                (this.forceStopped = !0),
                this.emit("forceChangePlayState", {}));
            },
          },
          {
            key: "forcePlay",
            value: function () {
              this.withAutoplay &&
                ((this.forceStopped = !1),
                (this.isPlay = !0),
                this.autoplay.start(),
                this.changePlayState(!0),
                this.emit("forceChangePlayState", {}));
            },
          },
          {
            key: "withStopOnHover",
            get: function () {
              return this.hasAttribute("with-stop-on-hover");
            },
          },
          {
            key: "autoplayInterval",
            get: function () {
              return +(this.dataset.autoplayInterval || 0);
            },
          },
          {
            key: "slides",
            get: function () {
              return L(this.embla.slideNodes());
            },
          },
          {
            key: "_axis",
            get: function () {
              return "vertical" === this.dataset.axis ? "y" : "x";
            },
          },
        ]),
        n
      );
    })(ne),
    Fi = Ni,
    Vi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleCarouselChangePlayState",
            function () {
              e.updatePlayState();
            }
          ),
          a(p(e), "_handleButtonClick", function (t) {
            (t.stopPropagation(), e._carousel) &&
              (e._carousel.forceStopped
                ? e._carousel.forcePlay()
                : e._carousel.forceStop());
          }),
          (e.button = e.querySelector("[data-carousel-play-button]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.updatePlayState(),
                this.button &&
                  this.button.addEventListener(
                    "click",
                    this._handleButtonClick
                  ),
                this._carousel &&
                  (customElements.upgrade(this._carousel),
                  this._carousel.subscribe(
                    "forceChangePlayState",
                    this._handleCarouselChangePlayState
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                this._carousel &&
                  this._carousel.unsubscribe(
                    "forceChangePlayState",
                    this._handleCarouselChangePlayState
                  );
            },
          },
          {
            key: "updatePlayState",
            value: function () {
              if (this._carousel && this.button) {
                var e = this._carousel.forceStopped;
                this.button.setAttribute(
                  "data-autoplay-stopped",
                  e ? "true" : "false"
                );
              }
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        n
      );
    })(ne),
    zi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleDotCarouselSettle", function () {
            e.updateDots();
          }),
          a(p(e), "_handleCarouselReInit", function () {
            e.embla.reInit(e._getOptions(), e._getPlugins());
          }),
          a(
            p(e),
            "_handleCarouselResize",
            (0, Oi.debounce)(function () {
              e.embla.reInit(e._getOptions(), e._getPlugins()), e.updateDots();
            }, 100)
          ),
          a(p(e), "_handleCarouselSelect", function () {
            if (e._carousel) {
              var t = L(e.embla.slideNodes()),
                n = e._carousel.embla.selectedScrollSnap();
              t.forEach(function (e) {
                var t = +e.dataset.dotIndex === n;
                e.classList.toggle("is-primary", t);
              }),
                e.embla.scrollTo(n);
            }
          }),
          a(p(e), "_getOptions", function () {
            return {
              inViewThreshold: +(e.dataset.inViewThreshhold || 0) || 0.5,
              containScroll: e.hasAttribute("data-contain-scroll")
                ? e.dataset.containScroll
                : "keepSnaps",
              align: e.dataset.align || "center",
              speed: e._getSpeed(),
              skipSnaps: e.hasAttribute("data-skip-snaps"),
              draggable: e.hasAttribute("is-draggable"),
              axis: e._axis,
            };
          }),
          a(p(e), "_getPlugins", function () {
            var t = [],
              n = xi();
            if ((t.push(n), e.hasAttribute("data-with-wheel-gestures"))) {
              var i = zn({ forceWheelAxis: e._axis });
              t.push(i);
            }
            return t;
          }),
          a(p(e), "scrollNext", function () {
            e._carousel && e._carousel.embla.scrollNext();
          }),
          a(p(e), "scrollPrev", function () {
            e._carousel && e._carousel.embla.scrollPrev();
          }),
          a(p(e), "canScrollNext", function () {
            return !!e._carousel && e._carousel.embla.canScrollNext();
          }),
          a(p(e), "canScrollPrev", function () {
            return !!e._carousel && e._carousel.embla.canScrollPrev();
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._init(),
                this.updateDots(),
                this._carousel &&
                  (this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ),
                  this._carousel.embla.on(
                    "select",
                    this._handleCarouselSelect
                  )),
                this.embla.on("resize", this._handleCarouselResize),
                this.embla.on("settle", this._handleDotCarouselSettle);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off("reInit", this._handleCarouselReInit),
                this._carousel.embla.off("select", this._handleCarouselSelect)),
                this.embla.off("settle", this._handleDotCarouselSettle),
                this.embla.off("resize", this._handleCarouselResize),
                this.embla.destroy();
            },
          },
          {
            key: "_getSpeed",
            value: function () {
              return Sn() ? 100 : 80;
            },
          },
          {
            key: "_init",
            value: function () {
              var e = this.querySelector("[data-carousel-viewport]");
              e && (this.embla = wi(e, this._getOptions(), this._getPlugins()));
            },
          },
          {
            key: "updateDots",
            value: function () {
              var e = L(this.embla.slideNodes()),
                t = e.map(function (e, t) {
                  return t;
                }),
                n = this.embla.slidesInView();
              e.forEach(function (e, i) {
                e.classList.remove("is-prev-prev");
                var a = n[0],
                  r = n[n.length - 1],
                  o = t[0],
                  s = t[t.length - 1];
                (!(i === a) && !(i === r)) ||
                  i === s ||
                  i === o ||
                  e.classList.add("is-prev-prev");
              });
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
          {
            key: "_axis",
            get: function () {
              return "vertical" === this.dataset.axis ? "y" : "x";
            },
          },
        ]),
        n
      );
    })(ne),
    Hi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleCarouselForceChangePlayState",
            function () {
              if (e._autoplayLoader && e._carousel) {
                var t = e._carousel.forceStopped;
                e._autoplayLoader.setAttribute(
                  "data-autoplay-stopped",
                  t ? "true" : "false"
                );
              }
            }
          ),
          a(p(e), "_handleCarouselChangePlayState", function () {
            e._updateAutoplayIndicator();
          }),
          a(p(e), "_handleDotClick", function () {
            e.scroll();
          }),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.scroll());
          }),
          (e._autoplayLoader = e.querySelector("[data-autoplay-indicator]")),
          (e._dotsCarousel = e.closest("carousel-dots")),
          (e.dotIndex = +e.dataset.dotIndex),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._updateAutoplayIndicator(),
                this._carousel &&
                  (customElements.upgrade(this._carousel),
                  this._carousel.subscribe(
                    "changePlayState",
                    this._handleCarouselChangePlayState
                  ),
                  this._carousel.subscribe(
                    "forceChangePlayState",
                    this._handleCarouselForceChangePlayState
                  )),
                this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleDotClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.unsubscribe(
                  "changePlayState",
                  this._handleCarouselChangePlayState
                ),
                this._carousel.unsubscribe(
                  "forceChangePlayState",
                  this._handleCarouselForceChangePlayState
                )),
                this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleDotClick);
            },
          },
          {
            key: "_updateAutoplayIndicator",
            value: function () {
              if (this._carousel) {
                var e = this._carousel.isPlay;
                this._autoplayLoader &&
                  this._autoplayLoader.setAttribute(
                    "data-play-state",
                    e ? "true" : "false"
                  );
              }
            },
          },
          {
            key: "scroll",
            value: function () {
              this._carousel &&
                (this._carousel.embla.scrollTo(this.dotIndex),
                this._carousel.forceStop());
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        n
      );
    })(ne),
    Ui = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.trigger();
            }
          ),
          a(p(e), "_handleCarouselReInit", function () {
            e._update();
          }),
          a(p(e), "_handleCarouselSelect", function () {
            e._update();
          }),
          a(
            p(e),
            "_handleCarouselScroll",
            (0, Oi.debounce)(function () {
              e._update();
            }, 100)
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.trigger());
          }),
          a(p(e), "_updateDisabled", function () {
            e.toggleAttribute("disabled", !e._canScroll());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._update(),
                this._carousel &&
                  (this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ),
                  this._carousel.embla.on("select", this._handleCarouselSelect),
                  this._carousel.embla.on(
                    "scroll",
                    this._handleCarouselScroll
                  )),
                this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off("reInit", this._handleCarouselReInit),
                this._carousel.embla.off("select", this._handleCarouselSelect),
                this._carousel.embla.off("scroll", this._handleCarouselScroll)),
                this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "_update",
            value: function () {
              this._updateDisabled(), this._updateVisible();
            },
          },
          {
            key: "_updateVisible",
            value: function () {
              if (this._carousel) {
                var e =
                    L(Array(this._carousel.embla.slideNodes().length).keys())
                      .length - 1,
                  t = this._carousel.embla.slidesInView(),
                  n =
                    "next" === this.dataset.scrollDirection
                      ? t.includes(e)
                      : t.includes(0);
                this.toggleAttribute("has-not-slides-not-in-view", n);
              }
            },
          },
          {
            key: "_canScroll",
            value: function () {
              return (
                !!this._carousel &&
                ("next" === this.dataset.scrollDirection
                  ? this._carousel.canScrollNext()
                  : this._carousel.canScrollPrev())
              );
            },
          },
          {
            key: "trigger",
            value: function () {
              if (this._carousel) {
                var e = this._carousel,
                  t = e.scrollNext,
                  n = e.scrollPrev;
                "next" === this.dataset.scrollDirection ? t() : n();
              }
            },
          },
          {
            key: "_carousel",
            get: function () {
              var e = this.closest("carousel-dots"),
                t = this.closest("carousel-component");
              return e || t;
            },
          },
        ]),
        n
      );
    })(ne),
    Ki = Ui,
    Wi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleProgress", function () {
            e.updateProgressBar();
          }),
          a(p(e), "_handleCarouselReInit", function () {
            e.updateProgressBar();
          }),
          (e._eventSetProgress =
            "scroll" === e.dataset.target ? "scroll" : "settle"),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateProgressBar(),
                this._carousel &&
                  (this._carousel.embla.on(
                    this._eventSetProgress,
                    this._handleProgress
                  ),
                  this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off(
                  this._eventSetProgress,
                  this._handleProgress
                ),
                this._carousel.embla.off("reInit", this._handleCarouselReInit));
            },
          },
          {
            key: "updateProgressBar",
            value: function () {
              var e = this.querySelector("[data-carousel-progress-indicator]");
              if (e) {
                var t = this.getProgress(),
                  n = "vertical" === this.dataset.axis;
                e.style.transform = n
                  ? "translate3d(0, ".concat(t, "%, 0)")
                  : "translate3d(".concat(t, "%, 0, 0)");
              }
            },
          },
          {
            key: "getProgress",
            value: function () {
              return "scroll" === this.dataset.target
                ? this.getProgressByScroll()
                : this.getProgressBySlideInView();
            },
          },
          {
            key: "getProgressBySlideInView",
            value: function () {
              if (!this._carousel) return 0;
              var e = this._carousel.embla.slideNodes().length,
                t = this._carousel.embla.slidesInView(),
                n = t[t.length - 1] + 1,
                i = 100 / e;
              return Math.ceil(i * n);
            },
          },
          {
            key: "getProgressByScroll",
            value: function () {
              if (!this._carousel) return 0;
              var e = this._carousel.embla.scrollProgress();
              return 100 * Math.max(0, Math.min(1, e));
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        n
      );
    })(ne),
    ji = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleResize",
            (0, Oi.debounce)(function () {
              e._setHidden(!1), e.updatePosition();
              var t = e._headerSection.getBoundingClientRect();
              e.headerSectionBottom = t.bottom;
            }, 100)
          ),
          a(p(e), "_handleScroll", function () {
            wn() && e._updateVisibleAfterScroll(), e._setScrollStatus();
          }),
          a(p(e), "_handleDrodpownHide", function () {

            // Storyside just testing what happens if we never remove this class from nav header
            // All other test weren't working
            // NOPE
            // console.log("Storyside _handleDropdownHide");
            e.classList.remove("header--light-bordered");
          }),
          a(p(e), "_handleDropdownShow", function () {

            // Storyside also testing what happens if we never add this class
            // NOPE
            // console.log("Storyside _handleDropdownShow test what happens if never add header--light-bordered class");
            e.classList.add("header--light-bordered");

          }),
          (e._lastScrollPosition = 0),
          (e._dropdowns = L(e.querySelectorAll("[data-header-dropdown]"))),
          (e._resizeObserver = new ResizeObserver(e._handleResize)),
          e._resizeObserver.observe(p(e)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._setSticky(),
                this.updatePosition(),
                H(window, "scroll", this._handleScroll),
                this._dropdowns.forEach(function (t) {
                  customElements.upgrade(t),
                    customElements
                      .whenDefined("float-element")
                      .then(function () {

                        // Storyside reversing order of these so the .theme--light-bordered class is added after removed
                        // console.log('Storyside call _handleDropdownShow and ...hide ');
                        t.subscribe("hide", e._handleDrodpownHide),
                          t.subscribe("show", e._handleDropdownShow);
                      });
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              U(window, "scroll", this._handleScroll),
                this._dropdowns.forEach(function (t) {
                  customElements.upgrade(t),
                    customElements
                      .whenDefined("float-element")
                      .then(function () {

                        // Storyside same as above 
                        t.unsubscribe("hide", e._handleDrodpownHide),
                          t.unsubscribe("show", e._handleDropdownShow);
                      });
                }),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "_setScrollStatus",
            value: function () {
              if (this._headerSection) {
                var e = Math.abs(parseInt(document.body.style.top || "0")),
                  t = (window.scrollY || e) > this.headerSectionBottom;
                this._headerSection.toggleAttribute("scrolled", t);
              }
            },
          },
          {
            key: "_updateVisibleAfterScroll",
            value: function () {
              if (this._headerSection && !Nt.isFixed) {
                var e = window.scrollY,
                  t = this._lastScrollPosition < e,
                  n = e > this.headerSectionBottom,
                  i = t && n;
                this._setHidden(i), 0 !== e && (this._lastScrollPosition = e);
              }
            },
          },
          {
            key: "_setHidden",
            value: function (e) {
              this._headerSection &&
                this._headerSection.setAttribute(
                  "aria-hidden",
                  e ? "true" : "false"
                );

              // console.log("Storyside header _setHidden", e);
              document.body.classList.toggle('header-is-visible', !e);
              
              
            },
          },
          {
            key: "_setSticky",
            value: function () {
              this._headerSection &&
                (this._headerSection.setAttribute("mobile-sticky", ""),
                this._headerSection.toggleAttribute(
                  "desktop-sticky",
                  this._isSticky
                ),
                document.body.toggleAttribute(
                  "header-desktop-sticky",
                  this._isSticky
                ));
            },
          },
          {
            key: "updatePosition",
            value: function () {
              if (this._headerSection) {
                var e = this.getBoundingClientRect();
                me("header-height", "".concat(e.height, "px")),
                  me("header-bottom-side", "".concat(e.bottom, "px"));
              }
            },
          },
          {
            key: "_isSticky",
            get: function () {
              return this.hasAttribute("is-sticky");
            },
          },
          {
            key: "_headerSection",
            get: function () {
              return document.querySelector(".shopify-section-header");
            },
          },
        ]),
        n
      );
    })(ne),
    Yi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleSectionLoad", function () {}),
          a(p(e), "_handleSectionSelect", function (t) {
            var n = t.detail.sectionId;
            e.isVisible && e.dataset.sectionId === n && (e.mount(), e.reset());
          }),
          a(p(e), "_handleSectionDeselect", function (t) {
            var n = t.detail.sectionId;
            e.isVisible && e.dataset.sectionId === n && (e.reset(), e.hide(!0));
          }),
          a(p(e), "_handleBlockSelect", function (t) {
            var n = t.detail,
              i = n.blockId,
              a = n.sectionId;
            if (e.dataset.sectionId === a) {
              var r = e.pages.find(function (e) {
                return e.getAttribute("block-id") === i;
              });
              if (!r) return;
              e.open(), e.setPage(r);
            }
          }),
          a(p(e), "_handleBlockDeselect", function (t) {
            var n = t.detail,
              i = n.blockId,
              a = n.sectionId;
            if (e.dataset.sectionId === a) {
              if (
                !e.pages.find(function (e) {
                  return e.getAttribute("block-id") === i;
                })
              )
                return;
              e.hide(!0);
            }
          }),
          a(p(e), "handlePageKeydown", function (t) {
            var n = t.target,
              i = n.closest("drawer-menu-page");
            if (i) {
              var a = i.querySelectorAll(W()),
                r = n === a[a.length - 1],
                o = n === a[0],
                s = t.shiftKey;
              9 === t.keyCode &&
                ((s && o) || (!s && r)) &&
                (t.preventDefault(), e.focusOnToggler());
            }
          }),
          (e.header = document.querySelector("header-component")),
          (e.pages = L(e.element.querySelectorAll("drawer-menu-page"))),
          (e.pageMap = e.generatePageMap()),
          (e.homePage = e.pageMap.Menu),
          (e.toggler = document.getElementById("DrawerMenuToggler")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              Jt(A(n.prototype), "connectedCallback", this).call(this),
                this.pages.forEach(function (t) {
                  t.addEventListener("keydown", e.handlePageKeydown);
                }),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ),
                  this._editor.subscribe(
                    "SECTION_SELECT",
                    this._handleSectionSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_DESELECT",
                    this._handleSectionDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              Jt(A(n.prototype), "disconnectedCallback", this).call(this),
                this.pages.forEach(function (t) {
                  t.removeEventListener("keydown", e.handlePageKeydown);
                }),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "focusOnToggler",
            value: function () {
              this.toggler && (this.toggler.focus(), this.hide());
            },
          },
          {
            key: "generatePageMap",
            value: function () {
              return this.pages.reduce(function (e, t) {
                var n = t.dataset.pageId;
                return n ? o(r({}, e), a({}, n, t)) : e;
              }, {});
            },
          },
          {
            key: "setPage",
            value: function (e) {
              var t,
                n =
                  e.dataset.pageId ===
                  (null === (t = this.openedPage) || void 0 === t
                    ? void 0
                    : t.dataset.prevPageId),
                i = e.hasAttribute("data-empty-menu");
              this.openedPage &&
                (n || i) &&
                this.setPageVisible(this.openedPage, !1);
              var a = e.querySelector(W());
              a && a.focus(), this.setPageVisible(e, !0), (this.openedPage = e);

              // Storyside setPage when drawer opens I think - not working
              // console.log('Storyside setPage', e.dataset);


            },
          },
          {
            key: "reset",
            value: function () {
              var e = this;
              this.pages.forEach(function (t) {
                e.setPageVisible(t, !1);
              }),
                this.setPageVisible(this.homePage, !0),
                (this.openedPage = this.homePage);
            },
          },
          {
            key: "setPageVisible",
            value: function (e, t) {
              e.setAttribute("aria-hidden", t ? "false" : "true");
            },
          },
          {
            key: "open",
            value: function () {

              // Storyside fine opening of nav menu, call global function defined in custom-head
              // Added the "," after call(this) and the createMobileNavAccordion line below
              // console.log('Storyside - open nav?');
              // $('body').addClass('mobile-nav-open');
              document.body.setAttribute("mobile-nav-open", "");

              return (
                this.header && this.header.updatePosition(),
                Jt(A(n.prototype), "open", this).call(this),
                createMobileNavAccordion()
              );
            },
          },
          {
            key: "hide",
            value: function (e) {

              // Storyside fine closing of nav menu
              // console.log('Storyside - close nav?');
              // $('body').removeClass('mobile-nav-open');
              document.body.removeAttribute("mobile-nav-open", "");

              return (
                this.reset(), Jt(A(n.prototype), "hide", this).call(this, e)
              );
            },
          },
          {
            key: "getPage",
            value: function (e) {
              return this.pageMap[e];
            },
          },
          {
            key: "isVisible",
            get: function () {
              var e = matchMedia("(max-width: 1016px)").matches;
              return this.hasAttribute("data-drawer-menu-is-section") || e;
            },
          },
        ]),
        n
      );
    })(kn),
    Xi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleBlockScroll", function () {
            if (e.block) {
              var t = e.block.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t);
            }
          }),
          (e.block = e.querySelector("[data-drawer-menu-content]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.block &&
                this.block.addEventListener("scroll", this._handleBlockScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.block &&
                this.block.removeEventListener(
                  "scroll",
                  this._handleBlockScroll
                );
            },
          },
        ]),
        n
      );
    })(ne),
    Qi = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handlePageLinkClick",
            function (t) {
              t.preventDefault(), e.setPage();
            }
          ),
          a(p(e), "_handleKeyUp", function (t) {
            t.preventDefault();
            var n = t.key || t.keyCode;
            X(n) && e.setPage();
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this, "click", this._handlePageLinkClick),
                H(this, "keyup", this._handleKeyUp);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this, "click", this._handlePageLinkClick),
                U(this, "keyup", this._handleKeyUp);
            },
          },
          {
            key: "setPage",
            value: function () {
              var e = this.closest("drawer-menu"),
                t = this.dataset.pageId;
              if (t && e) {
                var n = e.getPage(t);
                n && e.setPage(n);
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Gi = Qi,
    Zi = (function () {
      "use strict";
      function e(t) {
        m(this, e), (this._element = t);
      }
      return (
        g(e, [
          {
            key: "show",
            value: function () {
              this._element.classList.remove("hidden");
            },
          },
          {
            key: "hide",
            value: function () {
              this._element.classList.add("hidden");
            },
          },
        ]),
        e
      );
    })(),
    Ji = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return m(this, n), ((e = t.call(this)).cache = {}), e;
      }
      return (
        g(n, [
          {
            key: "updateTargetsFromHTML",
            value: function (e) {
              if (this.dataset.containerId) {
                var t = e.getElementById(this.dataset.containerId),
                  n = document.getElementById(this.dataset.containerId);
                if (t && n) {
                  var i = t.querySelectorAll(".".concat(this.dataset.target)),
                    a = document.createDocumentFragment();
                  i.forEach(function (e) {
                    a.appendChild(e);
                  }),
                    n.appendChild(a);
                }
              }
            },
          },
          {
            key: "updateResultsFromHTML",
            value: function (e) {
              if (this.dataset.containerId) {
                var t = e.getElementById(this.dataset.containerId),
                  n = document.getElementById(this.dataset.containerId);
                if (t && n)
                  n.parentNode.replaceChild(t, n),
                    t.scrollIntoView({ behavior: "smooth" });
              }
            },
          },
          {
            key: "updateFromHTML",
            value: function (e) {
              var t = e.querySelector("pagination-component");
              if (t) {
                var n = t.cloneNode(!0);
                this.replaceChildren.apply(this, L(n.childNodes));
              }
            },
          },
          {
            key: "loadingOverlay",
            get: function () {
              var e = document.getElementById(this.dataset.overlayId || "");
              return new Zi(e);
            },
          },
        ]),
        n
      );
    })(ne),
    $i = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e._fetchResults();
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e._fetchResults());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "_fetchResults",
            value: function () {
              var e = this,
                t = this.dataset.url;
              t &&
                (this._setLoadingStatus(!0),
                fetch(t)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var n = ge(t);
                    e._setLoadingStatus(!1),
                      e._updateFromHTML(n),
                      e._updatePaginationFromHTML(n);
                  })
                  .catch(function () {
                    Nt.notification &&
                      Nt.notification.show(
                        "Error in pagination load button component",
                        "warning"
                      );
                  }));
            },
          },
          {
            key: "_updatePaginationFromHTML",
            value: function (e) {
              var t = this.closest("pagination-component");
              t && (t.updateTargetsFromHTML(e), t.updateFromHTML(e));
            },
          },
          {
            key: "_setPaginationUrl",
            value: function (e) {
              this.dataset.url = e.dataset.url;
            },
          },
          {
            key: "_removePagination",
            value: function () {
              var e = this.closest("pagination-component");
              e && e.remove();
            },
          },
          {
            key: "_updateFromHTML",
            value: function (e) {
              var t = e.querySelector("pagination-load-button");
              t ? this._setPaginationUrl(t) : this._removePagination();
            },
          },
          {
            key: "_setLoadingStatus",
            value: function (e) {
              this.toggleAttribute("disabled", e),
                this.classList.toggle("loading", e);
            },
          },
        ]),
        n
      );
    })(ne),
    ea = $i,
    ta = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.apply(this, arguments))), "_handleLinkClick", function () {
            e._fetchResults();
          }),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e._fetchResults());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleLinkClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleLinkClick);
            },
          },
          {
            key: "_fetchResults",
            value: function () {
              var e = this.closest("pagination-component"),
                t = this.dataset.url;
              e &&
                t &&
                (e.cache[t]
                  ? this._updatePaginationFromHTML(e.cache[t])
                  : this._getFromUrl(t));
            },
          },
          {
            key: "_getFromUrl",
            value: function (e) {
              var t = this,
                n = this.closest("pagination-component");
              n &&
                (n.loadingOverlay.show(),
                fetch(e)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (i) {
                    var a = ge(i);
                    n.loadingOverlay.hide(),
                      (n.cache[e] = a),
                      t._updatePaginationFromHTML(a);
                  })
                  .catch(function () {
                    Nt.notification &&
                      Nt.notification.show(
                        "Error in pagination link component",
                        "warning"
                      );
                  }));
            },
          },
          {
            key: "_updatePaginationFromHTML",
            value: function (e) {
              var t = this.closest("pagination-component");
              t && (t.updateResultsFromHTML(e), t.updateFromHTML(e));
            },
          },
        ]),
        n
      );
    })(ne),
    na = ta,
    ia = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleIntersectionObserve", function (t) {
            var n = e.dataset.url;
            if (n) {
              if (!t[0].isIntersecting) return;
              e._intersectionObserver.unobserve(p(e)),
                e._preloaderComponent.show(),
                fetch(n)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var n = ge(t),
                      i = e.closest("pagination-component");
                    e._preloaderComponent.hide(),
                      e._updateFromHTML(n),
                      i && i.updateTargetsFromHTML(n);
                  })
                  .catch(function () {
                    Nt.notification &&
                      Nt.notification.show(
                        "Error in infinite scroll component",
                        "warning"
                      );
                  });
            }
          }),
          (e._observerOptions = {
            root: null,
            rootMargin: "0px 0px 200px 0px",
          }),
          (e._preloaderSelector = ".loading-spinner"),
          (e._preloader = e.querySelector(e._preloaderSelector)),
          (e._preloaderComponent = new Zi(e._preloader)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              (this._intersectionObserver = new IntersectionObserver(
                this._handleIntersectionObserve,
                this._observerOptions
              )),
                this._intersectionObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._intersectionObserver.disconnect();
            },
          },
          {
            key: "_updateFromHTML",
            value: function (e) {
              var t = e.querySelector("pagination-infinite-scroll"),
                n = null == t ? void 0 : t.dataset.url;
              t && n
                ? (this._setPaginationUrl(n),
                  this._intersectionObserver.observe(this))
                : this.removeAttribute("data-url");
            },
          },
          {
            key: "_setPaginationUrl",
            value: function (e) {
              this.dataset.url = e;
            },
          },
        ]),
        n
      );
    })(ne),
    aa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleCarouselSelect", function () {
            e._removeVideo();
          }),
          a(p(e), "_handlePosterClick", function () {
            e.loadContent();
          }),
          (e._poster = e.querySelector('[id^="Deferred-Poster-"]')),
          (e._carousel = e.closest("carousel-component")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.hasAttribute("data-autoplay") && this.loadContent(),
                H(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.off(
                    "select",
                    this._handleCarouselSelect
                  );
            },
          },
          {
            key: "loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this._addVideo(), this.setAttribute("loaded", "true"));
            },
          },
          {
            key: "_removeVideo",
            value: function () {
              var e = this.querySelector("video,  iframe");
              e && (e.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "_addVideo",
            value: function () {
              var e = document.createElement("div"),
                t = this.querySelector("template"),
                n = null == t ? void 0 : t.content;
              if (n && n.firstElementChild) {
                var i = n.firstElementChild.cloneNode(!0);
                e.appendChild(i);
                var a = e.querySelector("video, model-viewer, iframe");
                a && (this.appendChild(a), "VIDEO" === a.tagName && a.play());
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ra = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.fetchAvailability();
            },
          },
          {
            key: "fetchAvailability",
            value: function () {
              var e = this,
                t = ""
                  .concat(this.dataset.baseUrl, "variants/")
                  .concat(
                    this.dataset.variantId,
                    "/?section_id=pickup-availability"
                  );
              fetch(t)
                .then(function (e) {
                  return e.text();
                })
                .then(function (t) {
                  var n = ge(t).querySelector(".shopify-section");
                  e.updateSidebarFromHTML(n), e.updateContentFromHTML(n);
                })
                .catch(function () {
                  Nt.notification &&
                    Nt.notification.show(
                      "Error in pickup availability component",
                      "warning"
                    );
                });
            },
          },
          {
            key: "updateVariantId",
            value: function (e) {
              this.dataset.variantId = e;
            },
          },
          {
            key: "updateContentFromHTML",
            value: function (e) {
              var t = this.querySelector("pickup-availability-content"),
                n = e.querySelector("pickup-availability-content");
              if (t && n) {
                var i,
                  a = n.cloneNode(!0);
                (i = t).replaceChildren.apply(i, L(a.childNodes));
              }
            },
          },
          {
            key: "updateSidebarFromHTML",
            value: function (e) {
              var t = document.querySelector("#pickup-availability-sidebar"),
                n = e.querySelector("#pickup-availability-sidebar template");
              t && n && t.updateTemplate(n);
            },
          },
        ]),
        n
      );
    })(ne),
    oa = ra,
    sa = (function () {
      "use strict";
      function e(t) {
        m(this, e),
          (this._element = t),
          (this._text = this._element.querySelector("[data-button-text]"));
      }
      return (
        g(e, [
          {
            key: "setDisable",
            value: function (e) {

              // Storyside seeing if this is what changes pdp form button on variant select of sold out
              // console.log("Storyside data-button-text setDisable", e);

              this._element.toggleAttribute("disabled", e);
            },
          },
          {
            key: "setLoading",
            value: function (e) {
              this._element.classList.toggle("loading", e);
            },
          },
          {
            key: "setText",
            value: function (e) {
              this._text && (this._text.textContent = e);
            },
          },
        ]),
        e
      );
    })(),
    ca = window.routes,
    la = (function () {
      "use strict";

      // Storyside trying to set this as cartApi within the window so we can call it elsewhere
      // didn't work here...
      // window.storysideCartApi = this;

      function e() {
        m(this, e);
      }
      return (
        g(e, [
          {
            key: "change",
            value: function (e) {
              return fetch(ca.cart_change_url, e).then(function (e) {
                return e.text();
              });
            },
          },
          {
            key: "add",
            value: function (e) {

              // Storyside this should be the _cartApi that is running on every add to cart
              // console.log('Storyside add function within la component in js', e);

              return fetch(ca.cart_add_url, e).then(function (e) {

                // console.log('Storyside this is what the add action returns, but it sends e.text() to the next step', e);

                return e.text();
              });
            },
          },
          {
            key: "update",
            value: function (e) {
              return fetch("".concat(ca.cart_update_url), e);
            },
          },
          {
            key: "get",
            value: function () {
              return fetch(ca.cart_url).then(function (e) {

                // Storyside _cartApi (la) get was called
                // console.log("Storyside _cartApi get()", e, e.text());

                return e.text();
              });
            },
          },
        ]),
        e
      );
    })(),
    ua = function () {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/".concat(
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "json"
          ),
        },
      };
    },
    da = function (e) {
      var t = {},
        n = new FormData(e),
        i = !0,
        a = !1,
        r = void 0;
      try {
        for (
          var o, s = n.keys()[Symbol.iterator]();
          !(i = (o = s.next()).done);
          i = !0
        ) {
          var c = o.value,
            l = /(?:^(properties\[))(.*?)(?:\]$)/;
          l.test(c)
            ? ((t.properties = t.properties || {}),
              (t.properties[l.exec(c)[2]] = n.get(c)))
            : (t[c] = n.get(c));
        }
      } catch (e) {
        (a = !0), (r = e);
      } finally {
        try {
          i || null == s.return || s.return();
        } finally {
          if (a) throw r;
        }
      }
      return JSON.stringify(t);
    },
    ha = new ((function () {
      "use strict";
      function e(t) {
        var n = this;
        m(this, e),
          a(this, "requestProductFromUrl", function (e, t) {
            n._element && n._element.requestProductFromUrl(e, t);
          }),
          a(this, "openAndRenderProductByUrl", function (e) {
            n._element && n._element.openAndRenderProductByUrl(e);
          }),
          (this._element = document.querySelector("#".concat(t)));
      }
      return (
        g(e, [
          {
            key: "hide",
            value: function () {
              return this._element ? this._element.hide() : V();
            },
          },
          {
            key: "isOpen",
            get: function () {
              return !!this._element && this._element.isOpen;
            },
          },
        ]),
        e
      );
    })())("Quick-view"),
    fa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleFormSubmit", function (t) {

            // Storyside product form submit?
            // console.log('Storyside handleFormSubmit from product card?');


            t.preventDefault();
            var n = e._getQueryConfig();
            e.setDisable(!0),
              e.setLoading(!0),

              // Storyside testing injection of new function logging form data to try adding upsell here, note comma operator
              // addAddonsToCart needs to be defined in custom-head
              // console.log('Storyside form add injection', n),
              addAddonsToCart(n),



              e._cartApi
                .add(n)
                .then(function (t) {

                  // Storyside testing if this happens after every add to cart, what about change of cart?
                  // console.log('Storyside handle form submit??', JSON.parse(t), e);
                  window.storyside.cart = e;
                  window.storyside.passToUpdate = JSON.parse(t);

                  var n = JSON.parse(t);
                  if ((e.setDisable(!1), e.setLoading(!1), n.description)) {
                    if (!Nt.notification) return;
                    var i =
                      "object" == typeof n.description
                        ? e.getErrorMessageFromObject(n.description)
                        : n.description;
                    Nt.notification.show(i, "warning");
                  } else e.cart ? e.updateCart(n) : e.cartDrawer ? e.updateCartDrawerByParsedState(n) : e.updatePopupByParsedState(n);
                })
                .catch(function () {
                  Nt.notification &&
                    Nt.notification.show(
                      "Error in product form component",
                      "warning"
                    );
                });
          }),
          (e.cartDrawer = document.querySelector("#CartDrawer")),
          (e.cart = document.querySelector("cart-page")),
          (e.cartNotificationPopup = document.querySelector(
            "#CartNotificationPopup"
          )),
          (e.formSelector = "form"),
          (e.variantInputSelector = "[data-product-form-variant]"),
          (e.form = e.querySelector(e.formSelector)),
          e.form &&
            (e.variantInput = e.form.querySelector(e.variantInputSelector)),
          (e._cartApi = new la()),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this.form, "submit", this._handleFormSubmit);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this.form, "submit", this._handleFormSubmit);
            },
          },
          {
            key: "getErrorMessageFromObject",
            value: function (e) {
              return Object.keys(e)
                .map(function (t) {
                  return "".concat(t, ": ").concat(e[t]);
                })
                .join(" , ");
            },
          },
          {
            key: "updateCart",
            value: function (e) {
              var t = this;
              this.cart &&
                (this.cart.updateEmptyStatus(!1),
                this.showCallbackAfterCloseDialogWindow(function () {
                  t.cart.purchaseHandler(e);
                }));
            },
          },
          {
            key: "updateCartDrawerByParsedState",
            value: function (e) {

              // Storyside cart drawer update ??
              // console.log("Storyside updateCartDrawerByParsedState", e, this);
              window.storyside.productFormComponent = this;

              var t = this;
              if (this.cartDrawer) {
                this.cartDrawer.updateEmptyStatus(!1);
                this.showCallbackAfterCloseDialogWindow(function () {
                  t.cartDrawer && t.cartDrawer.purchaseHandler(e);
                });
              }
            },
          },
          {
            key: "updatePopupByParsedState",
            value: function (e) {
              var t = this;
              this.showCallbackAfterCloseDialogWindow(function () {
                t.cartNotificationPopup &&
                  t.cartNotificationPopup.showProductFromParsedState(e, e.id);
              });
            },
          },
          {
            key: "showCallbackAfterCloseDialogWindow",
            value: function (e) {
              return V(0).then(function () {
                ha.isOpen ? ha.hide().then(e) : e();
              });
            },
          },
          {
            key: "_getFormData",
            value: function () {

              // Storyside log form data - is this add to cart? YES
              // console.log("Storyside _getFormData", JSON.parse(da(this.form)));

              return JSON.parse(da(this.form));
            },
          },
          {
            key: "_getQueryConfig",
            value: function () {
              var e,
                t,
                n = ua("javascript"),
                i = [
                  (null === (e = this.cartDrawer) || void 0 === e
                    ? void 0
                    : e.dataset.sectionId) || "cart-drawer",
                  (null === (t = this.cart) || void 0 === t
                    ? void 0
                    : t.dataset.sectionId) || "cart",
                  "cart-notification-popup-content",
                ];
              return (
                (n.headers["X-Requested-With"] = "XMLHttpRequest"),
                (n.body = JSON.stringify(
                  o(r({}, this._getFormData()), {
                    sections: i,
                    sections_url: window.location.pathname,
                  })
                )),
                n
              );
            },
          },
          {
            key: "setLoading",
            value: function (e) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t
              ) {
                new sa(t).setLoading(e);
              });
            },
          },
          {
            key: "setDisable",
            value: function (e) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t
              ) {
                new sa(t).setDisable(e);
              });
            },
          },
          {
            key: "setButtonText",
            value: function (e) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t
              ) {
                new sa(t).setText(e);
              });
            },
          },
        ]),
        n
      );
    })(ne),
    va = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleWindowScroll", function () {
            if (e.button && e.form) {
              var t = window.scrollY,
                n = e.form.offsetTop + e.form.offsetHeight,
                i = e.footer ? e.footer.offsetTop : 0,
                a = window.innerHeight + t < i && t > n;
              e.toggleAttribute("visible", a),
                document.body.toggleAttribute(
                  "is-product-form-button-fixed",
                  a
                );
            }
          }),
          (e.button = e.querySelector("[data-product-form-button]")),
          (e.footer = document.querySelector(
            ".shopify-section.shopify-section-footer"
          )),
          (e.form = e.closest("product-form")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
        ]),
        n
      );
    })(ne),
    pa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).blockSelector = "[data-product-block-item]"),
          (e.containerSelector = "[data-product-block-container]"),
          (e.activeTemplate = e.querySelector(e.blockSelector)),
          (e.activeTemplateContainer = e.querySelector(e.containerSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "updateByVariantId",
            value: function (e) {

              // Storyside
              // console.log('Storyside product-block updateByVariantId function', e);

              var t = this.querySelector(
                '[data-product-block-template="'.concat(e, '"]')
              );
              if (this.activeTemplate && this.activeTemplateContainer) {
                var n = pe(t);

                // Storyside
                // console.log('Storyside product-block next', n, this.ActiveTemplate);

                n &&
                  (this.activeTemplate.remove(),
                  (this.activeTemplate = n),
                  this.activeTemplateContainer.appendChild(n));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ma = window.Shopify,
    ya = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handlePosterClick", function () {
            e._loadContent();
          }),
          a(p(e), "_handleCarouselSelect", function () {
            e._carousel && e._setCarouselDraggable(!0);
          }),
          (e._poster = e.querySelector('[id^="Deferred-Poster-"]')),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.off(
                    "select",
                    this._handleCarouselSelect
                  );
            },
          },
          {
            key: "_loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this._addModel(),
                this.setAttribute("loaded", !0),
                this._carousel && this._setCarouselDraggable(!1)),
                ma.loadFeatures([
                  {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this.setupModelViewerUI.bind(this),
                  },
                ]);
            },
          },
          {
            key: "_addModel",
            value: function () {
              var e = this.querySelector("template");
              if (e && e.content) {
                var t = e.content,
                  n = document.createElement("div");
                n.appendChild(t.firstElementChild.cloneNode(!0));
                var i = n.querySelector("model-viewer");
                this.appendChild(i);
              }
            },
          },
          {
            key: "setupModelViewerUI",
            value: function (e) {
              e ||
                (this.modelViewerUI = new ma.ModelViewerUI(
                  this.querySelector("model-viewer")
                ));
            },
          },
          {
            key: "_setCarouselDraggable",
            value: function (e) {
              var t = this.querySelector(".shopify-model-viewer-ui");
              (this._carousel.dataset.draggable = e ? "true" : "false"),
                this._carousel.reInit(),
                e && t && (t.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        n
      );
    })(ne);
  (window.ProductModel = {
    loadShopifyXR: function () {
      ma.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR: function (e) {
      var t = this;
      e ||
        (window.ShopifyXR
          ? (document
              .querySelectorAll('[id^="ProductJSON-"]')
              .forEach(function (e) {
                window.ShopifyXR.addModels(JSON.parse(e.textContent)),
                  e.remove();
              }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", function () {
              return t.setupShopifyXR();
            }));
    },
  }),
    window.addEventListener("DOMContentLoaded", function () {
      ma.designMode &&
        document
          .querySelectorAll("[data-shopify-xr-hidden]")
          .forEach(function (e) {
            return e.classList.add("hidden");
          }),
        window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  var ga,
    ba,
    _a,
    ka,
    wa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleResize", function () {
            e.setMaxHeight(e.scrollHeight);
          }),
          a(p(e), "removeItem", function () {
            e.collapse().then(function () {
              e.remove();
            });
          }),
          a(p(e), "expand", function () {
            return e.setMaxHeight(e.scrollHeight), V($(e.styles));
          }),
          a(p(e), "collapse", function () {
            return e.setMaxHeight(0), V($(e.styles));
          }),
          a(p(e), "showCheckmark", function () {
            var t = e.querySelector(e.checkmarkSelector);
            t &&
              (t.classList.remove("hidden"),
              V(2500).then(function () {
                t.classList.add("hidden");
              }));
          }),
          a(p(e), "setLoading", function (t) {
            var n = e.querySelector(e.totalsSelector);
            n && n.toggleAttribute("is-loading", t);
          }),
          (e.checkmarkSelector = "[data-cart-item-checkmark]"),
          (e.totalsSelector = "[data-cart-item-totals]"),
          (e.quantitySelector = "[data-cart-item-quantity]"),
          (e.styles = getComputedStyle(p(e))),
          (e.resizeObserver = new ResizeObserver(e.handleResize)),
          e.resizeObserver.observe(p(e)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.setMaxHeight(this.scrollHeight);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.resizeObserver.disconnect();
            },
          },
          {
            key: "setMaxHeight",
            value: function (e) {
              this.style.maxHeight = "".concat(e, "px");
            },
          },
          {
            key: "setDisabled",
            value: function (e) {
              var t = this.querySelector(this.quantitySelector);
              t && t.setDisable(e);
            },
          },
        ]),
        n
      );
    })(ne),
    Sa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleCartItemChange", function (t) {
            var n = +t.target.dataset.index,
              i = e.querySelector("#CartItem-".concat(n));
            i && i.setLoading(!0);
          }),
          a(
            p(e),
            "handleCartChange",
            (0, Oi.debounce)(function (t) {
              var n = +t.target.dataset.index,
                i = t.target.value;
              e.updateItem(n, i);
            }, 500)
          ),
          (e.cartAPI = new la()),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("change", this.handleCartChange),
                this.addEventListener("change", this.handleCartItemChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("change", this.handleCartChange),
                this.removeEventListener("change", this.handleCartItemChange);
            },
          },
          {
            key: "createQueryConfig",
            value: function (e, t) {
              return o(r({}, ua()), {
                body: JSON.stringify({
                  line: e + 1,
                  quantity: t,
                  sections: this.dataset.sectionId,
                  sections_url: window.location.pathname,
                }),
              });
            },
          },
          {
            key: "updateItem",
            value: function (e, t) {
              var n = this,
                i = this.querySelector("#CartItem-".concat(e));
              if (i) {
                var a = this.createQueryConfig(e, t),
                  r = +t,
                  o = 0 === r;
                if (+(i.dataset.quantity || 0) === r) i.setLoading(!1);
                else {
                  if (o) {
                    var s = this.querySelectorAll("cart-item").length;
                    this.updateEmptyStatus(1 === s), i.removeItem();
                  }
                  this.emit("start-update", {}),
                    i.setDisabled(!0),
                    this.cartAPI
                      .change(a)
                      .then(function (e) {
                        var t = JSON.parse(e);
                        i.setDisabled(!1), i.setLoading(!1);
                        var a = ge(t.sections[n.dataset.sectionId]);
                        n.emit("update-nodes", { node: a });
                      })
                      .catch(function () {
                        n.showError();
                      });
                }
              }
            },
          },
          {
            key: "purchaseHandler",
            value: function (e) {
              var t = ge(e.sections[this.dataset.sectionId]);
              this.emit("update-nodes", { node: t });
              var n = this.querySelector(
                'cart-item[data-variant-id="'.concat(e.id, '"]')
              );
              n &&
                (1 === e.quantity
                  ? n
                      .collapse()
                      .then(function () {
                        return n.expand();
                      })
                      .then(function () {
                        return n.showCheckmark();
                      })
                  : n.showCheckmark());
            },
          },
          {
            key: "showError",
            value: function () {
              if (Nt.notification) {
                var e = window.cartStrings;
                Nt.notification.show(e.error, "warning");
              }
            },
          },
          {
            key: "updateEmptyStatus",
            value: function (e) {
              this.toggleAttribute("is-empty", e);
            },
          },
        ]),
        n
      );
    })(ne),
    Ca = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {

        // Storyside attempting to set window.storyside.cartDrawer as this so it executed on component load
        // console.log('Storyside set storyside.cartDrawer');
        window.storyside.cartDrawer = this;

        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleCartItemChange", function (t) {
            var n = +t.target.dataset.index,
              i = e.querySelector("#CartItem-".concat(n));
            i && i.setLoading(!0);
          }),
          a(
            p(e),
            "handleCartChange",
            (0, Oi.debounce)(function (t) {

              // Storyside checking if this is what runs when storyside.cart.cartDrawer.handleCartChange() is executed in console
              // console.log('Storyside handleCartChange', t);

              if (window.Rebuy) {
                // console.log('Rebuy object present');
                setTimeout(function(){ Rebuy.init(); }, 500);
              }

              var n = +t.target.dataset.index,
                i = +t.target.value;
              e.updateItem(n, i);
            }, 500)
          ),
          a(p(e), "handleViewportScroll", function () {
            e.updateViewport();
          }),
          a(p(e), "handleResultsResize", function () {
            e.updateViewport();
          }),
          (e.viewport = e.element.querySelector("[data-cart-drawer-viewport]")),
          (e.results = e.element.querySelector("[data-cart-drawer-results]")),
          (e.header = e.element.querySelector("[data-cart-drawer-header]")),
          (e.footer = e.element.querySelector("[data-cart-drawer-footer]")),
          (e.cartAPI = new la()),
          e.results &&
            ((e.resizeObserver = new ResizeObserver(e.handleResultsResize)),
            e.resizeObserver.observe(e.results)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {

              // Storyside check
              // console.log("Storyside cart-drawer connectedCallback");

              Jt(A(n.prototype), "connectedCallback", this).call(this),
                this.addEventListener("change", this.handleCartChange),
                this.addEventListener("change", this.handleCartItemChange),
                this.viewport &&
                  this.viewport.addEventListener(
                    "scroll",
                    this.handleViewportScroll
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Jt(A(n.prototype), "disconnectedCallback", this).call(this),
                this.removeEventListener("change", this.handleCartChange),
                this.removeEventListener("change", this.handleCartItemChange),
                this.viewport &&
                  this.viewport.removeEventListener(
                    "scroll",
                    this.handleViewportScroll
                  ),
                this.resizeObserver.disconnect();
            },
          },
          {
            key: "_storysideRefreshCart",
            value: function() {
              // _storyside
              // Storyside attempt to add method within cartDrawer component to refresh and rebuild
              // storyside.cart.cartDrawer._storysideRefreshCart()
              // toggles drawer right now
              // console.log('_storysideRefreshCart', this);

              document.querySelector("#CartDrawer").toggle();

              // $.ajax({
              //   type: 'POST',
              //   url: '/cart/add.js',
              //   data: {
              //     quantity: 1, 
              //     id: '39363026518050', 
              //     properties: ''
              //   },
              //   dataType: 'json',
              //   success: function (line_item) {console.log("Success")},
              //   error: function (xhr, status, error) {console.log(error)}
              // })


            },
          },
          {
            key: "updateViewport",
            value: function () {
              if (this.results && this.viewport) {
                var e = this.results.offsetHeight > this.viewport.offsetHeight,
                  t = this.viewport.scrollTop > 0;
                this.classList.toggle("header-shadow-visible", e && t),
                  this.classList.toggle("footer-shadow-visible", e);
              }
            },
          },
          {
            key: "updateItem",
            value: function (e, t) {
              var n = this,
                i = this.createConfig(e, t),
                a = this.querySelector("#CartItem-".concat(e));
              a &&
                (+(a.dataset.quantity || 0) !== t
                  ? (a.setDisabled(!0),
                    0 === t && a.removeItem(),
                    this.emit("start-update", {}),
                    this.cartAPI
                      .change(i)
                      .then(function (e) {
                        var t = JSON.parse(e);
                        a.setLoading(!1), a.setDisabled(!1);
                        var i = n.getTemplateContent(t);
                        n.mount(),
                          n.emit("update-nodes", { node: i }),
                          n.updateEmptyStatus();
                      })
                      .catch(function () {
                        n.showError();
                      }))
                  : a.setLoading(!1));
            },
          },
          {
            key: "showError",
            value: function () {
              var e = this.querySelector("#CartDrawerNotification");
              e && new Rt(e).show(window.cartStrings.error, "warning");
            },
          },
          {
            key: "purchaseHandler",
            value: function (e) {

              // Storyside this is the purchase handler for the cart drawer (the other is for cart page)
              // e is a big object of the item that got added, not everything, so this passes that to getTemplateContent
              // console.log('Storyside drawer purchaseHandler', this, e);


              var t = this,
                n = this.getTemplateContent(e),
                i = j(n);
              this.mount(),
                this.emit("update-nodes", { node: n }),
                this.updateEmptyStatus(),
                Y(i);
              var a = this.element.querySelector(
                'cart-item[data-variant-id="'.concat(e.id, '"]')
              );
              a &&
                (1 === e.quantity
                  ? a
                      .collapse()
                      .then(function () {
                        return t.open();
                      })
                      .then(function () {
                        return a.expand();
                      })
                      .then(function () {
                        return a.showCheckmark();
                      })
                  : this.open().then(function () {
                      return a.showCheckmark();
                    }));

              // Storyside testing Rebuy init
              // console.log("Storyside Rebuy init in purchaseHandler")
              if (window.Rebuy) {
                // console.log('Rebuy object present');
                Rebuy.init();
              }

            },
          },
          {
            key: "getTemplateContent",
            value: function (e) {
              var t = ge(e.sections[this.dataset.sectionId]).querySelector(
                "[data-cart-drawer-template]"
              );
              return pe(t);
            },
          },
          {
            key: "updateEmptyStatus",
            value: function () {
              var e = this.element.querySelectorAll("cart-item");
              if (this.hasAttribute("data-has-warning-placeholder")) {
                var t = 0 === e.length;
                this.toggleAttribute("is-empty", t);
              }
            },
          },
          {
            key: "createConfig",
            value: function (e, t) {
              return o(r({}, ua()), {
                body: JSON.stringify({
                  line: e + 1,
                  quantity: t,
                  sections: this.dataset.sectionId,
                  sections_url: window.location.pathname,
                }),
              });
            },
          },
        ]),
        n
      );
    })(kn),
    Ea = window.Shopify,
    xa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "setProgress", function (t) {
            e.style.setProperty(
              "--gsc-free-shipping-progress",
              "".concat(t, "%")
            );
          }),
          a(p(e), "setMessage", function (t) {
            var n = e.querySelector(e.messageNodeSelector);
            n && (n.innerHTML = t);
          }),
          (e.messageNodeSelector = "[data-free-shipping-bar-message]"),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this.dataset.cartTotal || 0;
              this.updateProgressByCartTotal(+e);
            },
          },
          {
            key: "updateProgressByCartTotal",
            value: function (e) {
              var t = this.dataset.currencyFormat || "",
                n = +(this.dataset.threshold || 0),
                i = +Ea.currency.rate,
                a = this.dataset.progressMessage || "",
                r = this.dataset.achievedMessage || "",
                o = n * i,
                s = +(o - e).toFixed(2),
                c = o / 100;
              if (s > 0) {
                var l = t.replace(/{{.+?}}/g, "".concat(s));
                this.setMessage(a.replace("[value]", l)),
                  this.setProgress(e / c);
              } else this.setMessage(r), this.setProgress(100);
            },
          },
        ]),
        n
      );
    })(ne),
    La = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.setReady();
            },
          },
          {
            key: "updateFirstMediaByVariant",
            value: function (e) {

              // Storyside I think this is the desktop scroll to image action
              // console.log("updateFirstMediaByVariant for desktop but call custom function that does both in custom-head", arguments, e, this.id);
              // console.log(arguments);
              // showVariantImages is a global function defined in custom-head.liquid
              showVariantImages(arguments, this.id);

              var t =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              if (e && e.featured_media) {
                var n = this.querySelector(
                  '[data-media-id="'.concat(e.featured_media.id, '"]')
                );
                // Storyside UNDO SCROll ON DESKTOP
                // n && n.scrollIntoView({ behavior: t ? "auto" : "smooth" }); 
              }
            },
          },
          {
            key: "setReady",
            value: function () {
              this.setAttribute("ready", "");
            },
          },
        ]),
        n
      );
    })(ne),
    Ia = La,
    Ta = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).carouselSelector =
            "[data-product-media-carousel-component]"),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.setReady();
            },
          },
          {
            key: "updateFirstMediaByVariant",
            value: function (e) {

              var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                n = this.querySelector(this.carouselSelector);
              if (e && e.featured_media && n) {
                var i = n.embla.slideNodes().findIndex(function (t) {
                  return (
                    !!t.dataset.mediaId &&
                    +t.dataset.mediaId == +e.featured_media.id
                  );
                });
                // n.embla.scrollTo(i, t); this is JUST mobile
              }

              // Storyside checking action for mobile carousel update on variant select
              // This is nice because it runs on page load (2x actually)
              // console.log('Storyside updateFirstMediaByVariant');
              // console.log(arguments);
              // let variantTitle = arguments[0].title.toLowerCase();
              // console.log(variantTitle);
              if (true) {
                // showVariantImages(variantTitle);
              }
              // console.log(n.embla);
              // console.log('try slides', n.embla.slideNodes());

              n.embla.destroy();

              // n.embla.reInit({
              //   dragFree: true, 
              //   slides: '[data-alt="' + variantTitle + '"]' 
              // });

              // console.log('try slides again', n.embla.slideNodes());

              // let slideNodesNew = [];
              // n.embla.slideNodes().forEach(function(slideNode) {
              //   if (slideNode.dataset.hasOwnProperty('alt')) {
              //     // console.log('node', slideNode, slideNode.dataset.alt);
              //     if (slideNode.dataset.alt.includes('ocean')) {
              //       slideNodesNew.push(slideNode);
              //     }
              //   }
              // });
              // n.embla.reInit({dragFree: true, slides: slideNodesNew });

              

            },
          },
          {
            key: "setReady",
            value: function () {
              this.setAttribute("ready", "");
            },
          },
        ]),
        n
      );
    })(ne),
    Aa = Ta,
    Da = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleVariantChange", function () {

            // Storyside _handleVariantChange on pdp
            // This one is weird bc it actually spits out the CURRENT variant, not the newly selected?
            // console.log("Storyside _handleVariantChange", e, e.variant, e._form, e.variant.available);
            // console.log("Storyside _handleVariantChange", e);


            e._updateForm(),
              e._setInventoryStatusAvailable(e.variant),
              e.variant
                ? (e._form.setDisable(!0),
                  e._form.setLoading(!0),
                  e._pickupAvailability && e._updatePickupAvailability(),
                  e.updateURL(),
                  e._updateVariantInput(),
                  e._updateProduct(),
                  e._updateFirstMediaByVariant(e.variant))
                : e._setButtonsUnavailable();
          }),
          a(p(e), "_handleLabelFocus", function (t) {
            var n = t.target.getAttribute("for");
            e
              .querySelector('input[id="'.concat(n, '"]'))
              .dispatchEvent(new MouseEvent("click", { button: 0, which: 1 })),
              document.addEventListener("keydown", e._handleLabelKeydown);
          }),
          a(p(e), "_handleLabelKeydown", function (t) {
            var n = t.target.closest("[data-variant-picker-option-labels]");
            if (
              "ArrowLeft" === t.key ||
              "ArrowRight" === t.key ||
              "ArrowUp" === t.key ||
              "ArrowDown" === t.key
            )
              if (n) {
                var i = L(n.querySelectorAll("label")),
                  a = i.findIndex(function (e) {
                    return e === t.target;
                  }),
                  r = i[a],
                  o = i[0],
                  s = i[i.length - 1],
                  c = i[a + 1],
                  l = i[a - 1];
                1 !== i.length && t.preventDefault();
                var u = function (e) {
                    r.removeAttribute("tabindex"),
                      e.setAttribute("tabindex", 0),
                      e.focus();
                  },
                  d = function () {
                    u(c || o);
                  },
                  h = function () {
                    u(l || s);
                  };
                (0,
                { ArrowLeft: h, ArrowRight: d, ArrowUp: h, ArrowDown: d }[
                  t.key
                ])();
              } else
                document.removeEventListener("keydown", e._handleLabelKeydown);
          }),
          (e._pickupAvailability = document.getElementById(
            "product-pickup-availability-"
              .concat(e.dataset.productId, "-")
              .concat(e.dataset.section)
          )),
          (e._elements = [
            "sticky-product-buy-btn",
            "product-buy-btn",
            "product-quantity",
          ]),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._updateVariant(),
                setTimeout(function () {
                  e._updateOptionsAvailable(), e.setFocusListeners();
                }, 100),
                this.dataset.selectedVariantId &&
                  this._updateFirstMediaByVariant(this.variant, !0),
                H(this, "change", this._handleVariantChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this, "change", this._handleVariantChange);
            },
          },
          {
            key: "_updateLabels",
            value: function () {
              var e = this,
                t = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                n = this.querySelectorAll(
                  "[data-variant-picker-option-labels]"
                );
              t.forEach(function (t, i) {
                var a,
                  r = L(n[i].querySelectorAll("label")),
                  o = L(t.querySelectorAll("input")),
                  s = e.getCheckedInput(o),
                  c = n[i].querySelector(
                    "[data-dropdown-variant-picker-label]"
                  );
                c &&
                  c.toggleAttribute(
                    "no-available",
                    !(null === (a = e.variant) || void 0 === a
                      ? void 0
                      : a.available)
                  ),
                  r.forEach(function (e) {
                    var t = e.getAttribute("for") === s.id;
                    if (c && t) {
                      var n,
                        i = c.closest("dropdown-opener"),
                        a = e.cloneNode(!0);
                      (n = c).replaceChildren.apply(n, L(a.childNodes)),
                        i.trigger();
                    }
                    e.classList.toggle("selected", t);
                  });
              });
            },
          },
          {
            key: "updateURL",
            value: function () {
              this.variant &&
                "false" !== this.dataset.updateUrl &&
                window.history.replaceState(
                  {},
                  "",
                  ""
                    .concat(this.dataset.url, "?variant=")
                    .concat(this.variant.id)
                );
            },
          },
          {
            key: "_setInventoryStatusAvailable",
            value: function (e) {
              var t = document.getElementById(
                "product-stock-inner-"
                  .concat(this.dataset.productId, "-")
                  .concat(this.dataset.section)
              );
              t && t.classList.toggle("hidden", !e);
            },
          },
          {
            key: "_setButtonsUnavailable",
            value: function () {

              // Storyside this is where disabled button is set, so you can show BIS here?
              // console.log("Storyside _setButtonsUnavailable", this._form, window.variantStrings.unavailable);

              this._form.setDisable(!0),
                this._form.setButtonText(window.variantStrings.unavailable);
            },
          },
          {
            key: "_updateVariant",
            value: function () {
              var e = this,
                t = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                n = this._getVariants(),
                i = L(t).map(function (t) {
                  var n = L(t.querySelectorAll("input"));
                  return e.getCheckedInput(n).value;
                });
              this.variant = n.find(function (e) {
                return !e.options
                  .map(function (e, t) {
                    return i[t] === e;
                  })
                  .includes(!1);
              });
            },
          },
          {
            key: "setFocusListeners",
            value: function () {
              if ("dropdown" === this.dataset.type) {
                var e = L(this.querySelectorAll("float-element"))
                  .map(function (e) {
                    return L(e.element.querySelectorAll("label"));
                  })
                  .reduce(function (e, t) {
                    return L(e).concat(L(t));
                  }, []);
                this.setListenersForLabels(e);
              } else {
                var t = L(this.querySelectorAll("label"));
                this.setListenersForLabels(t);
              }
            },
          },
          {
            key: "setListenersForLabels",
            value: function (e) {
              var t = this;
              e.forEach(function (e) {
                e.addEventListener("focus", t._handleLabelFocus);
              });
            },
          },
          {
            key: "removeListenersForLabels",
            value: function (e) {
              var t = this;
              e.forEach(function (e) {
                e.addEventListener("focus", t._handleLabelFocus);
              });
            },
          },
          {
            key: "_updateOptionsAvailable",
            value: function () {
              var e = this,
                t = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                n = function (e) {
                  return t[e] ? L(t[e].querySelectorAll("input")) : null;
                },
                i = n(0),
                a = n(1),
                r = n(2),
                o = this._getVariants(),
                s = function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return o.reduce(function (e, n) {
                    var i =
                      !t ||
                      t.every(function (e) {
                        return n.options.includes(e.value);
                      });
                    return n.available && i ? L(e).concat([n.options]) : e;
                  }, []);
                },
                c = function (t, n) {
                  var i = !0,
                    a = !1,
                    r = void 0;
                  try {
                    for (
                      var o,
                        s = function () {
                          var t = o.value,
                            i = t.value,
                            a = !1;
                          n.forEach(function (e) {
                            e.includes(i) && (a = !0);
                          });
                          var r,
                            s = 'label[for="'.concat(t.id, '"]');
                          (e.querySelector(s)
                            ? e.querySelector(s)
                            : ((r = s),
                              L(e.querySelectorAll("float-element"))
                                .find(function (e) {
                                  return e.element.querySelector(r);
                                })
                                .element.querySelector(r))
                          ).toggleAttribute("no-available", !a);
                        },
                        c = t[Symbol.iterator]();
                      !(i = (o = c.next()).done);
                      i = !0
                    )
                      s();
                  } catch (e) {
                    (a = !0), (r = e);
                  } finally {
                    try {
                      i || null == c.return || c.return();
                    } finally {
                      if (a) throw r;
                    }
                  }
                };
              (c(i, s()), a) && c(a, s(this.getCheckedInput(i)));
              r && c(r, s(this.getCheckedInput(i), this.getCheckedInput(a)));
            },
          },
          {
            key: "_getVariants",
            value: function () {
              var e = this.querySelector("[data-variant-picker-variants]");
              return JSON.parse(e.textContent);
            },
          },
          {
            key: "_updateFirstMediaByVariant",
            value: function (e, t) {
              document
                .querySelectorAll(
                  "#product-media-"
                    .concat(this.dataset.productId, "-")
                    .concat(this.dataset.section)
                )
                .forEach(function (n) {

                  // Storyside checking why this runs 2x, prob desktop and mobile
                  // console.log('_updateFirstMediaByVariant');
                  // console.log(e);
                  updateKlaviyoSelectedVariant(e);

                  return n.updateFirstMediaByVariant(e, t);
                });
            },
          },
          {
            key: "_updateForm",
            value: function () {
              this._updateVariant(),
                this._updateLabels(),
                this._updateOptionsAvailable();
            },
          },
          {
            key: "_updateVariantInput",
            value: function () {

              // Storyside setting input field data-variant-title which was only added to product form on pdp I think
              // check that this doesn't break quick view or other 
              // console.log("Storyside _updateVariantInput in index unminified", this, this.variant);
              // call global function instead
              // looking to add BIS trigger show/hide in this one
              updateProductPrice(this, this.variant);


              var e = this._form.variantInput;

              (e.value = this.variant.id),
              (e.dataset.variantTitle = this.variant.title),
                e.dispatchEvent(new Event("change", { bubbles: !0 }));
            },
          },
          {
            key: "_updatePickupAvailability",
            value: function () {
              this._pickupAvailability.updateVariantId(this.variant.id),
                this._pickupAvailability.fetchAvailability();
            },
          },
          {
            key: "_updateProduct",
            value: function () {
              var e = this,
                t = ""
                  .concat(this.dataset.url, "?variant=")
                  .concat(this.variant.id, "&section_id=")
                  .concat(this.dataset.sectionIdWithoutPrefix);
              this._updateBlocksByVariantId(this.variant.id),
                fetch(t)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var n = ge(t),
                      i = e.variant.available;
                    e._form.setDisable(!i),
                      e._form.setLoading(!1),
                      e._updateElements(n);
                  })
                  .catch(function () {
                    Nt.notification &&
                      Nt.notification.show(
                        "Error in variant picker component",
                        "warning"
                      );
                  });
            },
          },
          {
            key: "_updateElements",
            value: function (e) {
              var t = this;
              this._elements.forEach(function (n) {
                var i = ""
                    .concat(n, "-")
                    .concat(t.dataset.productId, "-")
                    .concat(t.dataset.section),
                  a = document.getElementById(i);
                if (a) {
                  var r,
                    o = e.getElementById(i).cloneNode(!0);
                  (r = a).replaceChildren.apply(r, L(o.childNodes));
                }
              });
            },
          },
          {
            key: "_updateBlocksByVariantId",
            value: function (e) {
              var t = this;
              ["product-price", "product-sku", "product-stock"].forEach(
                function (n) {
                  var i = document.getElementById(
                    ""
                      .concat(n, "-")
                      .concat(t.dataset.productId, "-")
                      .concat(t.dataset.section)
                  );
                  i && i.updateByVariantId(e);
                }
              );
            },
          },
          {
            key: "getCheckedInput",
            value: function (e) {
              return e.find(function (e) {
                return e.checked;
              });
            },
          },
          {
            key: "_form",
            get: function () {
              return document.getElementById(
                "product-form-component-"
                  .concat(this.dataset.productId, "-")
                  .concat(this.dataset.section)
              );
            },
          },
        ]),
        n
      );
    })(ne),
    Pa = Da,
    Ma = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFormChange", function () {
            e.updateSelected();
          }),
          a(p(e), "_handleMouseEnter", function (t) {
            e.updateActiveValue(t.target.dataset.value);
          }),
          a(p(e), "_handleMouseLeave", function () {
            e.updateSelected();
          }),
          (e.activeValueSelector = "[data-color-swatches-picker-active-value]"),
          (e.activeValue = e.querySelector(e.activeValueSelector)),
          (e.labelSelector = "[data-color-swatches-picker-label]"),
          (e.labels = L(e.querySelectorAll(e.labelSelector))),
          (e.form = e.closest("variant-picker")._form),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.form.addEventListener("change", this.handleFormChange),
                this.labels.forEach(function (t) {
                  t.addEventListener("mouseenter", e._handleMouseEnter),
                    t.addEventListener("mouseleave", e._handleMouseLeave);
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.form.removeEventListener("change", this.handleFormChange),
                this.labels.forEach(function (t) {
                  t.removeEventListener("mouseenter", e._handleMouseEnter),
                    t.removeEventListener("mouseleave", e._handleMouseLeave);
                });
            },
          },
          {
            key: "updateSelected",
            value: function () {
              var e = this.querySelector(
                "".concat(this.labelSelector, ".selected")
              );
              if (e) {
                var t = e.getAttribute("data-value") || "";
                this.updateActiveValue(t);
              }
            },
          },
          {
            key: "updateActiveValue",
            value: function (e) {
              this.activeValue && (this.activeValue.textContent = e);
            },
          },
        ]),
        n
      );
    })(ne),
    Ba = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleKeydown", function (t) {
            var n = t.key || t.keyCode;
            Q(n) && (e.isZoomed ? e.zoomedImage.reset() : e.hide());
          }),
          a(p(e), "_handleCarouselInit", function () {
            e._updateCarouselDraggableState();
          }),
          a(p(e), "_handleCarouselSelect", function () {
            e.updateSelectedSlideNumber();
          }),
          (e.selectors = {
            carousel: "[data-product-modal-carousel]",
            carouselButtons: "[data-product-modal-carousel-button]",
            carouselSlide: "[data-product-modal-slide]",
            carouselSelectedSlideNumber:
              "[data-product-modal-selected-slide-number]",
            carouselSlideNumber: "[data-product-modal-slide-number]",
            zoomCursor: "zoom-cursor",
          }),
          e.element &&
            ((e.carousel = e.element.querySelector(e.selectors.carousel)),
            (e.carouselButtons = e.carousel.querySelectorAll(
              e.selectors.carouselButtons
            )),
            (e._slides = L(
              e.element.querySelectorAll(e.selectors.carouselSlide)
            )),
            (e._selectedSlideNumber = e.element.querySelector(
              e.selectors.carouselSelectedSlideNumber
            )),
            (e._slideNumber = e.element.querySelector(
              e.selectors.carouselSlideNumber
            ))),
          (e._zoomCursor = document.querySelector(e.selectors.zoomCursor)),
          (e.mediaIndexMap = e._createMediaIndexMap()),
          (e.isZoomed = !1),
          e
        );
      }
      return (
        g(n, [
          {
            key: "openAndShowMediaById",
            value: function (e) {
              if ((this.show(), this.carousel)) {
                var t = this.mediaIndexMap[e];
                this.carousel.embla.scrollTo(t, !0),
                  this.carouselButtons[0] && this.carouselButtons[0].focus(),
                  this.updateSelectedSlideNumber();
              }
            },
          },
          {
            key: "_initCarousel",
            value: function () {
              this.carousel &&
                (this.carousel.embla.on("select", this._handleCarouselSelect),
                this.carousel.embla.on("init", this._handleCarouselInit));
            },
          },
          {
            key: "_resetCarousel",
            value: function () {
              this.carousel &&
                (this.carousel.embla.off("select", this._handleCarouselSelect),
                this.carousel.embla.off("init", this._handleCarouselInit));
            },
          },
          {
            key: "hide",
            value: function () {
              this._resetCarousel(),
                Jt(A(n.prototype), "hide", this).call(this),
                (this.isZoomed = !1),
                this.updateModal(),
                this.emit("hide", {});
            },
          },
          {
            key: "show",
            value: function () {
              Jt(A(n.prototype), "show", this).call(this), this._initCarousel();
            },
          },
          {
            key: "updateSelectedSlideNumber",
            value: function () {
              if (this._selectedSlideNumber && this.carousel) {
                var e = this.carousel.embla.selectedScrollSnap() + 1;
                this._selectedSlideNumber.textContent = e;
              }
            },
          },
          {
            key: "updateModal",
            value: function () {
              this._updateCarouselDraggableState(),
                this._updateZoomCursorState(),
                this._updateZoomState();
            },
          },
          {
            key: "_createMediaIndexMap",
            value: function () {
              return this._slides.reduce(function (e, t, n) {
                return t.dataset.mediaId
                  ? o(r({}, e), a({}, t.dataset.mediaId, n))
                  : e;
              }, {});
            },
          },
          {
            key: "_updateCarouselDraggableState",
            value: function () {
              this.carousel &&
                (wn()
                  ? this.carousel.reInit({ draggable: !this.isZoomed })
                  : this.carousel.reInit({ draggable: !1 }));
            },
          },
          {
            key: "_updateZoomCursorState",
            value: function () {
              this._zoomCursor && this._zoomCursor.updateState(this.isZoomed);
            },
          },
          {
            key: "_updateZoomState",
            value: function () {
              this.toggleAttribute("zoom-enabled", this.isZoomed);
            },
          },
        ]),
        n
      );
    })(un),
    qa = Ba,
    Oa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleImageLoad", function () {
            e.setPreloaderVisible(!1);
          }),
          a(p(e), "_handleModalHide", function () {
            e.reset();
          }),
          a(p(e), "_handleCarouselSelect", function () {
            e.reset();
          }),
          a(p(e), "_handleTouchStart", function (t) {
            t.preventDefault(),
              (e.fingers = t.touches.length),
              (e.firstMove = !0),
              e.detectDoubleTap(t);
          }),
          a(p(e), "_handleTouchMove", function (t) {
            if ((t.preventDefault(), !e._isDoubleTapped)) {
              if (e.firstMove)
                e.updateGesture(t), (e.startMoveTouches = t.touches.length);
              else if (e._lastGesture)
                switch (e._lastGesture) {
                  case "zoom":
                    2 === e.startMoveTouches &&
                      2 === t.touches.length &&
                      e.pinch(t);
                    break;
                  case "drag":
                    if (1 === e.startMoveTouches && 1 === t.touches.length) {
                      var n = t.targetTouches[0],
                        i = n.clientX,
                        a = n.clientY;
                      e.drag(i, a);
                    }
                }
              else e.setGesture("none", t);
              e.firstMove = !1;
            }
          }),
          a(p(e), "_handleTouchEnd", function (t) {
            t.preventDefault(),
              (e.fingers = t.touches.length),
              e.updateGesture(t);
          }),
          a(p(e), "_handleMouseDown", function (t) {
            t.preventDefault(),
              e.startDrag(t.clientX, t.clientY),
              e.setDragging(!0);
          }),
          a(p(e), "_handleMouseUp", function (t) {
            e.setDragging(!1);
            var n = e._modal.isZoomed ? 75 : 0;
            e.zoomTimeoutId = setTimeout(function () {
              e.touchZoom(t.clientX, t.clientY);
            }, n);
          }),
          a(p(e), "_handleMouseMove", function (t) {
            if (
              (t.preventDefault(),
              clearTimeout(e.zoomTimeoutId),
              e._isDragging && e._modal.isZoomed)
            ) {
              var n = t.clientX,
                i = t.clientY;
              e.drag(n, i);
            }
          }),
          (e._image = e.querySelector("img")),
          (e._modal = e.closest("product-modal")),
          (e._carousel = e._modal.carousel),
          (e._preloader = e.querySelector(
            "[data-product-modal-image-preloader]"
          )),
          (e._currentScale = 1),
          (e._isDragging = !1),
          (e._offsetX = 0),
          (e._offsetY = 0),
          (e._startDragPoint = { x: 0, y: 0 }),
          (e._maxScale = 3),
          (e._minScale = 1),
          (e._isTapped = !1),
          (e._tapTimeout = 300),
          (e._lastGesture = null),
          e.setZoomCursorVisible(!0),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              K.observe(this._preloader),
                this._image.addEventListener(
                  "mousedown",
                  this._handleMouseDown
                ),
                this._image.addEventListener("mouseup", this._handleMouseUp),
                this._image.addEventListener(
                  "mousemove",
                  this._handleMouseMove
                ),
                this._image.addEventListener(
                  "touchstart",
                  this._handleTouchStart
                ),
                this._image.addEventListener("touchend", this._handleTouchEnd),
                this._image.addEventListener(
                  "touchmove",
                  this._handleTouchMove
                ),
                this._image.addEventListener("load", this._handleImageLoad),
                customElements.upgrade(this._modal),
                this._modal.subscribe("hide", this._handleModalHide),
                this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              K.unobserve(this._preloader),
                this._image.removeEventListener(
                  "mousedown",
                  this._handleMouseDown
                ),
                this._image.removeEventListener("mouseup", this._handleMouseUp),
                this._image.removeEventListener(
                  "mousemove",
                  this._handleMouseMove
                ),
                this._image.removeEventListener(
                  "touchstart",
                  this._handleTouchStart
                ),
                this._image.removeEventListener(
                  "touchend",
                  this._handleTouchEnd
                ),
                this._image.removeEventListener(
                  "touchmove",
                  this._handleTouchMove
                ),
                this._image.removeEventListener("load", this._handleImageLoad),
                this._modal.unsubscribe("hide", this._handleModalHide),
                this._carousel.embla.off("select", this._handleCarouselSelect);
            },
          },
          {
            key: "detectDoubleTap",
            value: function (e) {
              var t = this;
              if (this._isTappedTimeout && 1 === this.fingers)
                switch (
                  (clearTimeout(this._isTappedTimeout),
                  (this._isTappedTimeout = null),
                  (this._isDoubleTapped = !0),
                  this.touchZoom(
                    e.changedTouches[0].clientX,
                    e.changedTouches[0].clientY
                  ),
                  this._lastGesture)
                ) {
                  case "zoom":
                    this.setPinchScaling(!1);
                    break;
                  case "drag":
                    this.setDragging(!1);
                }
              else
                this._isTappedTimeout = setTimeout(function () {
                  (t._isTappedTimeout = null), (t._isDoubleTapped = !1);
                }, this._tapTimeout);
            },
          },
          {
            key: "updateGesture",
            value: function (e) {
              2 === this.fingers
                ? this.setGesture("zoom")
                : 1 === this.fingers
                ? this.setGesture("drag", e)
                : this.setGesture("none", e);
            },
          },
          {
            key: "setGesture",
            value: function (e, t) {
              if (this._lastGesture !== e) {
                if (this._lastGesture && !e)
                  switch (this._lastGesture) {
                    case "zoom":
                      this.setPinchScaling(!1);
                      break;
                    case "drag":
                      this.setDragging(!1);
                  }
                switch (e) {
                  case "zoom":
                    this.setPinchScaling(!0);
                    break;
                  case "drag":
                    this.startDrag(
                      t.changedTouches[0].clientX,
                      t.changedTouches[0].clientY
                    ),
                      this.setDragging(!0);
                    break;
                  case "none":
                    this.setDragging(!1), this.setPinchScaling(!1);
                }
              }
              this._lastGesture = e;
            },
          },
          {
            key: "pinch",
            value: function (e) {
              var t = this.getDistanceBetweenTouches(e),
                n = t > this.lastDistanceBetweenTouches,
                i = n ? 0.125 : -0.125,
                a = this.getNewScale(this.currentScale + i),
                r = this.getTouchCenter(e),
                o = (r.x - this._offsetX) / this.currentScale,
                s = (r.y - this._offsetY) / this.currentScale;
              (this.lastDistanceBetweenTouches = t),
                n || 1 !== a
                  ? this.setTransform({
                      scale: a,
                      offsetX: r.x - o * a,
                      offsetY: r.y - s * a,
                    })
                  : this.reset();
            },
          },
          {
            key: "getDistanceBetweenTouches",
            value: function (e) {
              return Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
              );
            },
          },
          {
            key: "startDrag",
            value: function (e, t) {
              (this._startDragPoint = {
                x: e - this._offsetX,
                y: t - this._offsetY,
              }),
                (this.dragStartPointX = e),
                (this.dragStartPointY = t);
            },
          },
          {
            key: "drag",
            value: function (e, t) {
              var n = this.dragStartPointX > e,
                i = this.dragStartPointY > t,
                a = this.getNewScale(this.currentScale),
                r = e - this._startDragPoint.x,
                o = t - this._startDragPoint.y,
                s = this.getIntersectBounds({
                  isRightDrag: n,
                  isBottomDrag: i,
                });
              (s.right || s.left) && (r = this._offsetX),
                (s.bottom || s.top) && (o = this._offsetY),
                this.setTransform({ scale: a, offsetX: r, offsetY: o });
            },
          },
          {
            key: "getIntersectBounds",
            value: function (e) {
              var t = e.isRightDrag,
                n = e.isBottomDrag,
                i = this._image.getBoundingClientRect(),
                a = t ? -8 : 8,
                r = n ? -8 : 8;
              return {
                right: t && i.right + a < window.innerWidth,
                left: !t && i.left + a > 0,
                bottom: n && i.bottom + r < window.innerHeight,
                top: !n && i.top + r > 0,
              };
            },
          },
          {
            key: "getTouchCenter",
            value: function (e) {
              var t = function (e, t) {
                  return e + t;
                },
                n = L(e.touches),
                i = n.length;
              return {
                x:
                  n
                    .map(function (e) {
                      return e.pageX;
                    })
                    .reduce(t) / i,
                y:
                  n
                    .map(function (e) {
                      return e.pageY;
                    })
                    .reduce(t) / i,
              };
            },
          },
          {
            key: "setTransform",
            value: function (e) {
              var t = e.offsetX,
                n = e.offsetY,
                i = e.scale;
              (this.style.transform = "translate3d("
                .concat(t, "px, ")
                .concat(n, "px, 0) scale3d(")
                .concat(i, ", ")
                .concat(i, ", 1)")),
                (this._offsetX = t),
                (this._offsetY = n),
                (this.currentScale = i);
            },
          },
          {
            key: "touchZoom",
            value: function (e, t) {
              var n,
                i,
                a,
                r = (e - this._offsetX) / this.currentScale,
                o = (t - this._offsetY) / this.currentScale;
              this._modal.isZoomed
                ? ((n = this.getNewScale(1)), (i = 0), (a = 0))
                : ((i = e - r * (n = this.getNewScale(3))), (a = t - o * n)),
                (this.style.cursor = this._modal.isZoomed ? "" : "grab"),
                this.setZoomCursorVisible(this._modal.isZoomed),
                this.setTransform({ scale: n, offsetX: i, offsetY: a });
            },
          },
          {
            key: "reset",
            value: function () {
              this.setTransform({ scale: 1, offsetX: 0, offsetY: 0 });
            },
          },
          {
            key: "getNewScale",
            value: function (e) {
              return Math.max(this._minScale, Math.min(this._maxScale, e));
            },
          },
          {
            key: "setPinchScaling",
            value: function (e) {
              this.toggleAttribute("is-pinch-scaling", e),
                (this._isPinchScaling = e);
            },
          },
          {
            key: "setDragging",
            value: function (e) {
              this.toggleAttribute("is-dragging", e), (this._isDragging = e);
            },
          },
          {
            key: "setZoomCursorVisible",
            value: function (e) {
              this._image.toggleAttribute("data-zoom-cursor-target", e);
            },
          },
          {
            key: "setModalZoom",
            value: function (e) {
              (this._modal.isZoomed = e),
                this._modal.isZoomed && (this._modal.zoomedImage = this),
                this._modal.updateModal();
            },
          },
          {
            key: "setPreloaderVisible",
            value: function (e) {
              this._preloader.classList.toggle("hidden", !e),
                this._image.toggleAttribute("is-loaded", !e);
            },
          },
          {
            key: "currentScale",
            get: function () {
              return this._currentScale;
            },
            set: function (e) {
              this._currentScale !== e &&
                (this.setModalZoom(e > 1), (this._currentScale = e));
            },
          },
        ]),
        n
      );
    })(ne),
    Ra = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "showModal",
            value: function () {
              if (this.dataset.modal) {
                var e = document.querySelector(this.dataset.modal);
                e && e.openAndShowMediaById(this.dataset.mediaId);
              }
            },
          },
        ]),
        n
      );
    })(pn),
    Na = Ra,
    Fa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleIntersectionObserve",
            function (t, n) {
              if (t[0].isIntersecting) {
                n.unobserve(p(e));
                var i = e.dataset.url;
                i &&
                  fetch(i)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(function (t) {
                      var n = ge(t);
                      e._updateByHTML(n);
                    })
                    .catch(function () {
                      Nt.notification &&
                        Nt.notification.show(
                          "Error in product recommendations component",
                          "warning"
                        );
                    });
              }
            }
          ),
          (e._intersectionObserver = new IntersectionObserver(
            e._handleIntersectionObserve,
            { rootMargin: "0px 0px 200px 0px" }
          )),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._intersectionObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._intersectionObserver.disconnect();
            },
          },
          {
            key: "_updateByHTML",
            value: function (e) {
              var t = e.querySelector("product-recommendations");
              if (t) {
                var n = t.cloneNode(!0);
                this.replaceChildren.apply(this, L(n.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Va = window.routes,
    za = (function () {
      "use strict";
      function e() {
        m(this, e);
      }
      return (
        g(e, [
          {
            key: "get",
            value: function (e) {
              var t = this._prepareQuery(e);
              return fetch(t).then(function (e) {
                return e.text();
              });
            },
          },
          {
            key: "_prepareQuery",
            value: function (e) {
              var t = e.searchQuery,
                n = e.sectionParam,
                i = e.limitParam,
                a = e.fieldsParam,
                r = Va.predictive_search_url;
              return ""
                .concat(r, "?q=")
                .concat(t, "&")
                .concat(i, "&")
                .concat(n, "&")
                .concat(a);
            },
          },
        ]),
        e
      );
    })(),
    Ha = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleInputChange",
            (0, Oi.debounce)(function () {
              e._searchQuery ? e._renderResults() : e._resetResults();
            }, 500)
          ),
          (e._cache = {}),
          (e.sidebar = e.closest("#SearchSidebar")),
          (e.inputComponentSelector = "[data-sidebar-search-input-component]"),
          (e.contentResults = "[data-sidebar-search-content-results]"),
          (e.footerSelector = "[data-sidebar-search-footer]"),
          (e.itemSelector = "[data-sidebar-search-item]"),
          e.sidebar &&
            (e._results = e.sidebar.element.querySelector(e.contentResults)),
          (e._predictiveSearchAPI = new za()),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this._inputComponent, "input", this._handleInputChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._inputComponent, "input", this._handleInputChange);
            },
          },
          {
            key: "_renderResults",
            value: function () {
              this._cache[this._searchQuery]
                ? this._renderFromCache(this._searchQuery)
                : this._renderFromUrl(this._searchQuery);
            },
          },
          {
            key: "_resetResults",
            value: function () {
              this.sidebar &&
                this._updateResultsFromHTML(this.sidebar.defaultStateElement);
            },
          },
          {
            key: "_renderFromCache",
            value: function (e) {
              try {
                this._updateResultsFromHTML(this._cache[e]);
              } catch (e) {
                if (!Nt.notification) return;
                Nt.notification.show(
                  "Error in search component when try update from cache",
                  "warning"
                );
              }
            },
          },
          {
            key: "_renderFromUrl",
            value: function (e) {
              var t,
                n,
                i = this,
                a =
                  (null === (t = this.sidebar) || void 0 === t
                    ? void 0
                    : t.dataset.sectionId) || "search-sidebar",
                r = "section_id=".concat(a) || "",
                o = (
                  null === (n = this.sidebar) || void 0 === n
                    ? void 0
                    : n.hasAttribute("enable-extended-search")
                )
                  ? "resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor"
                  : "resources[options][fields]=title,product_type,variants.title,vendor";
              this._predictiveSearchAPI
                .get({
                  searchQuery: this._searchQuery,
                  limitParam: "resources[limit]=999",
                  sectionParam: r,
                  fieldsParam: o,
                })
                .then(function (t) {
                  var n = ge(t);
                  (i._cache[e] = n), i._updateResultsFromHTML(n);
                })
                .catch(function () {
                  Nt.notification &&
                    Nt.notification.show(
                      "Error in search component",
                      "warning"
                    );
                });
            },
          },
          {
            key: "_updateResultsFromHTML",
            value: function (e) {
              var t = e.getElementById("SearchSidebar");
              if (t) {
                var n = t.querySelector("template"),
                  i = pe(n).querySelector(this.contentResults);
                this.updateResultsHTML(i), this.updateFooterVisible();
              }
            },
          },
          {
            key: "updateResultsHTML",
            value: function (e) {
              var t;
              if (this._results) {
                var n = e.cloneNode(!0);
                (t = this._results).replaceChildren.apply(t, L(n.childNodes));
              }
            },
          },
          {
            key: "updateFooterVisible",
            value: function () {
              if (this.sidebar) {
                var e = this.sidebar.element.querySelector(this.footerSelector),
                  t = this.sidebar.element.querySelectorAll(this.itemSelector);
                e && e.classList.toggle("hidden", 0 === t.length);
              }
            },
          },
          {
            key: "_searchQuery",
            get: function () {
              return this._inputComponent
                ? this._inputComponent.value.trim()
                : "";
            },
          },
          {
            key: "_inputComponent",
            get: function () {
              return this.sidebar
                ? this.sidebar.querySelector(this.inputComponentSelector)
                : null;
            },
          },
        ]),
        n
      );
    })(ne),
    Ua = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.update();
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("cart-page, cart-drawer"),
                t = this.dataset.index;
              e && t && e.updateItem(+t, 0);
            },
          },
        ]),
        n
      );
    })(ne),
    Ka = Ua,
    Wa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e._copy();
            }
          ),
          a(p(e), "_copy", function () {
            var t = e.dataset.value;
            t &&
              navigator.clipboard &&
              navigator.clipboard.writeText(t).then(function () {
                e._showTooltip();
              });
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "_showTooltip",
            value: function () {
              var e = this.dataset.tooltipId;
              if (e) {
                var t = document.querySelector("#".concat(e));
                t &&
                  (t.show(),
                  V(1e3).then(function () {
                    t.hide();
                  }));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ja = Wa,
    Ya = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        m(this, n),
          a(p((e = t.call(this))), "_init", function () {
            e._target &&
              Bt(e._target, p(e), function () {
                qt(e._target, e, e._getOptions()).then(function (t) {
                  e._updatePosition(t), e._updateArrow(t);
                });
              });
          }),
          a(p(e), "show", function () {
            e._mount(), e._setVisible(!0), e.emit("show", {});
          }),
          a(p(e), "hide", function () {

            // Storyside check if this is the action called to set nav mega menu visible or now
            // NOPE
            // console.log('Storyside run _setvisible');

            e._setVisible(!1), e._unmount(), e.emit("hide", {});
          });
        var i = e.querySelector("template");
        return (
          (e.element = pe(i)),
          (e._arrow = e.element.querySelector("[data-float-element-arrow]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._init();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._unmount();
            },
          },
          {
            key: "_updatePosition",
            value: function (e) {
              var t = e.x,
                n = e.y;
              Object.assign(this.style, {
                left: "".concat(t, "px"),
                top: "".concat(n, "px"),
              });
            },
          },
          {
            key: "_getOptions",
            value: function () {
              return {
                placement: this._placement,
                middleware: this._getMiddleware(),
                strategy: "absolute",
              };
            },
          },
          {
            key: "_getMiddleware",
            value: function () {
              var e = this.dataset.alignmentAxisOffset || 0,
                t = this.dataset.mainAxisOffset || 0,
                n = [Ze({ alignmentAxis: +e, mainAxis: +t }), Xe(), et()];
              return this._arrow && n.push(He({ element: this._arrow })), n;
            },
          },
          {
            key: "_updateArrow",
            value: function (e) {
              var t = e.placement,
                n = e.middlewareData;
              if (this._arrow) {
                var i = n.arrow,
                  r = i.x,
                  o = i.y,
                  s = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right",
                  }[t.split("-")[0]];
                Object.assign(
                  this._arrow.style,
                  a(
                    {
                      left: null != r ? "".concat(r, "px") : "",
                      top: null != o ? "".concat(o, "px") : "",
                      right: "",
                      bottom: "",
                    },
                    s,
                    "-5px"
                  )
                );
              }
            },
          },
          {
            key: "_mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.setAttribute("aria-hidden", e ? "false" : "true");
            },
          },
          {
            key: "_target",
            get: function () {
              return document.querySelector(
                '[data-clipboard-button-tooltip-target-id="'.concat(
                  this.id,
                  '"]'
                )
              );
            },
          },
          {
            key: "_placement",
            get: function () {
              return this.dataset.placement || "bottom-end";
            },
          },
        ]),
        n
      );
    })(ne),
    Xa = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return n;
    })(ne),
    Qa = Xa,
    Ga = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleMouseEnter", function () {
            var t = e.dataset.url,
              n = e.dataset.id;
            t && n && ha.requestProductFromUrl(t, n);
          }),
          a(p(e), "handleQuickViewBtnClick", function () {
            var t = e.dataset.url;
            t && ha.openAndRenderProductByUrl(t);
          }),
          a(p(e), "handleResize", function () {
            e.buttons && e.setButtonsOverflow(),
              e.colorSwatches && e.colorSwatches.update();
          }),
          a(p(e), "handleImageLoad", function () {
            var t;
            (e.loadedImageCount += 1),
              e.loadedImageCount ===
                (null === (t = e.images) || void 0 === t ? void 0 : t.length) &&
                (e.removePreloader(), e.showImages());
          }),
          (e.resizeObserver = new ResizeObserver(e.handleResize)),
          (e.lastButtonsWidth = 0),
          (e.loadedImageCount = 0),
          (e.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e.preloaderSelector = "[data-product-card-preloader]"),
          (e.imagesContainerSelector = "[data-product-card-media-container]"),
          (e.buttonsSelector = "[data-product-card-buttons]"),
          (e.imagesSelector = "[data-product-card-featured-image]"),
          (e.colorSwatchesSelector = "[data-product-card-color-swatches]"),
          (e.quickViewBtn = e.querySelector(e.quickViewBtnSelector)),
          (e.preloader = e.querySelector(e.preloaderSelector)),
          (e.imagesContainer = e.querySelector(e.imagesContainerSelector)),
          (e.buttons = e.querySelector(e.buttonsSelector)),
          (e.images = L(e.querySelectorAll(e.imagesSelector))),
          (e.colorSwatches = e.querySelector(e.colorSwatchesSelector)),
          e.resizeObserver.observe(p(e)),
          K.observe(p(e)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.images.forEach(function (t) {
                t.addEventListener("load", e.handleImageLoad);
              }),
                this.quickViewBtn &&
                  (this.quickViewBtn.addEventListener(
                    "mouseenter",
                    this.handleMouseEnter
                  ),
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.images.forEach(function (t) {
                t.removeEventListener("load", e.handleImageLoad);
              }),
                this.resizeObserver.disconnect(),
                K.unobserve(this),
                this.quickViewBtn &&
                  (this.quickViewBtn.removeEventListener(
                    "mouseenter",
                    this.handleMouseEnter
                  ),
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  ));
            },
          },
          {
            key: "setButtonsOverflow",
            value: function () {
              if (this.buttons && !(this.offsetWidth < this.lastButtonsWidth)) {
                var e = this.buttons.offsetWidth > this.offsetWidth;
                e &&
                  this.buttons.offsetWidth > this.lastButtonsWidth &&
                  (this.lastButtonsWidth = this.buttons.offsetWidth),
                  this.buttons.classList.toggle(
                    "product-card__btns--overflowed",
                    e
                  );
              }
            },
          },
          {
            key: "removePreloader",
            value: function () {
              this.preloader && (he(this.preloader), K.unobserve(this));
            },
          },
          {
            key: "showImages",
            value: function () {
              this.imagesContainer &&
                this.imagesContainer.setAttribute("visible", "");
            },
          },
        ]),
        n
      );
    })(Qa),
    Za = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleResize",
            (0, Oi.debounce)(function () {
              e._setMaxLines();
            }, 100)
          ),
          (e._resizeObserver = new ResizeObserver(e._handleResize)),
          e._resizeObserver.observe(p(e)),
          (e.targetSelector = "[data-quote-line-clamp-target]"),
          (e.lineClampSelector = "[data-quote-line-clamp]"),
          (e._lineClamp = e.querySelector(e.lineClampSelector)),
          (e._target = e.querySelector(e.targetSelector)),
          (e.styles = getComputedStyle(e._target)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "disconnectedCallback",
            value: function () {
              this._resizeObserver.disconnect();
            },
          },
          {
            key: "_setMaxLines",
            value: function () {
              var e = this._getMaxLines();
              e &&
                this._target &&
                (this._target.style.setProperty(
                  "--gsc-max-lines",
                  "".concat(e)
                ),
                this.setAttribute("data-line-clamp-setter-is-ready", ""));
            },
          },
          {
            key: "_getMaxLines",
            value: function () {
              if (!this._lineClamp || !this._target) return 0;
              var e = this.styles.lineHeight,
                t = this._lineClamp.offsetHeight;
              return Math.floor(t / parseFloat(e));
            },
          },
        ]),
        n
      );
    })(ne),
    Ja = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleItemClick", function (t) {
            e._input &&
              e._dropdownBtnLabel &&
              e._dropdown &&
              (e._input.setAttribute("value", t.target.dataset.value),
              e._setActiveItem(t.target.dataset.value),
              (e._dropdownBtnLabel.innerHTML = t.target.dataset.value),
              e._dropdown.hide());
          }),
          (e._input = e.querySelector("input")),
          (e._dropdown = e.querySelector("float-element")),
          (e._dropdownBtnLabel = e.querySelector(".dropdown__toggle-label")),
          e._createItems(),
          (e._items = L(e.querySelectorAll(".dropdown__item"))),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                H(t, "click", e._handleItemClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this._items.forEach(function (t) {
                U(t, "click", e._handleItemClick);
              });
            },
          },
          {
            key: "_setActiveItem",
            value: function (e) {
              this._items.forEach(function (t) {
                t.classList.toggle("active", t.dataset.value === e);
              });
            },
          },
          {
            key: "_createItems",
            value: function () {
              var e,
                t = this.querySelectorAll("option"),
                n = document.createDocumentFragment();
              this._dropdown &&
                (t.forEach(function (e) {
                  var t,
                    i = document.createElement("div"),
                    a = e.cloneNode(!0);
                  i.classList.add("dropdown__item"),
                    (i.dataset.value = e.value),
                    (i.dataset.provinces = e.dataset.provinces),
                    (t = i).replaceChildren.apply(t, L(a.childNodes)),
                    n.appendChild(i);
                }),
                (e = this._dropdown).replaceChildren.apply(e, L(n.childNodes)));
            },
          },
        ]),
        n
      );
    })(ne),
    $a = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleWindowClick", function (t) {
            var n = t.target,
              i = n.closest("search-input");
            !(e._input === n) && !i && e._updateResetButtonVisible();
          }),
          a(p(e), "_handleInputChange", function () {
            e._updateResetButtonVisible();
          }),
          a(p(e), "_handleResetBtnClick", function (t) {
            t.preventDefault(), e.reset();
          }),
          (e._inputSelector = "[data-search-field-input]"),
          (e._resetBtnSelector = "[data-search-field-reset-button]"),
          (e._input = e.querySelector(e._inputSelector)),
          (e._resetBtn = e.querySelector(e._resetBtnSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this._input, "input", this._handleInputChange),
                H(window, "click", this._handleWindowClick),
                H(this._resetBtn, "click", this._handleResetBtnClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._input, "input", this._handleInputChange),
                U(window, "click", this._handleWindowClick),
                U(this._resetBtn, "click", this._handleResetBtnClick);
            },
          },
          {
            key: "reset",
            value: function () {
              if (this._input) {
                var e = new Event("input", { bubbles: !0 });
                (this._input.value = ""),
                  this._input.dispatchEvent(e),
                  this._input.focus();
              }
            },
          },
          {
            key: "_updateResetButtonVisible",
            value: function () {
              if (this._resetBtn) {
                var e = this._hasInputValue();
                this._resetBtn.classList.toggle("hidden", !e);
              }
            },
          },
          {
            key: "_hasInputValue",
            value: function () {
              return !!this._input && this._input.value.trim().length > 0;
            },
          },
          {
            key: "value",
            get: function () {
              return this._input ? this._input.value : "";
            },
          },
        ]),
        n
      );
    })(ne),
    er = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleButtonClick", function () {
            e._togglePasswordVisible();
          }),
          (e._inputSelector = "[data-password-field-input]"),
          (e._buttonSelector = "[data-password-field-button]"),
          (e._input = e.querySelector(e._inputSelector)),
          (e._button = e.querySelector(e._buttonSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this._button, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._button, "click", this._handleButtonClick);
            },
          },
          {
            key: "_togglePasswordVisible",
            value: function () {
              if (this._input) {
                var e = "password" === this._input.getAttribute("type"),
                  t = e ? "text" : "password";
                this._input.setAttribute("type", t), this._setButton(e);
              }
            },
          },
          {
            key: "_setButton",
            value: function (e) {
              this._button &&
                this._button.toggleAttribute("password-visible", e);
            },
          },
        ]),
        n
      );
    })(ne),
    tr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleMutations", function (t) {
            t.forEach(function (t) {
              if ("attributes" === t.type) {
                var n = t.target.matches(e.zoomTargetSelector);
                e._setVisible(n);
              }
            });
          }),
          a(p(e), "_handleMouseMove", function (t) {
            var n = t.target,
              i = !!n.closest(e.zoomTargetSelector),
              a = wn();
            e._isVisible &&
              ((e.style.top = "".concat(t.clientY, "px")),
              (e.style.left = "".concat(t.clientX, "px"))),
              a ||
                (e._setVisible(i),
                i && e.mutationObserver.observe(n, { attributes: !0 }));
          }),
          (e.zoomTargetSelector = "[data-zoom-cursor-target]"),
          (e.mutationObserver = new MutationObserver(e._handleMutations)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._autoCheckTargets();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(window, "mousemove", this._handleMouseMove),
                this.mutationObserver.disconnect(),
                clearInterval(this.checkTargetsIntervalID);
            },
          },
          {
            key: "_setVisible",
            value: function (e) {
              this.toggleAttribute("visible", e),
                (document.body.style.cursor = e ? "none" : "");
            },
          },
          {
            key: "updateState",
            value: function (e) {
              this.toggleAttribute("zoomed", e);
            },
          },
          {
            key: "_autoCheckTargets",
            value: function () {
              var e = this;
              this.checkTargetsIntervalID = setInterval(function () {
                document.querySelectorAll(e.zoomTargetSelector).length &&
                  !e.isHandlerSetted &&
                  (H(window, "mousemove", e._handleMouseMove),
                  (e.isHandlerSetted = !0));
              }, 1e3);
            },
          },
          {
            key: "_isVisible",
            get: function () {
              return this.hasAttribute("visible");
            },
          },
        ]),
        n
      );
    })(ne),
    nr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleHistoryChange", function (t) {
            var n = t.state.searchParams || e._searchParamsInitial;
            n !== e._searchParamsPrev && e.updateBySearchParams(n);
          }),
          (e._cache = {}),
          (e._searchParamsInitial = window.location.search.slice(1)),
          (e._searchParamsPrev = window.location.search.slice(1)),
          (e.sortQuery = ""),
          (e.filterQuery = ""),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(window, "popstate", this._handleHistoryChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(window, "popstate", this._handleHistoryChange);
            },
          },
          {
            key: "_formatParams",
            value: function (e) {
              this._searchParamsPrev = e;
              var t = this.dataset.baseParams || "";
              return "".concat(t).concat(e);
            },
          },
          {
            key: "updateBySearchParams",
            value: function (e) {
              this.updateShopBySearchParams(e),
                this.updateFiltersBySearchParams(e);
            },
          },
          {
            key: "updateShopBySearchParams",
            value: function (e) {
              var t = this,
                n = this._createUrl(e);
              this._cache[n]
                ? this._updateElements(this._cache[n])
                : this._getFromUrl(n).then(function (e) {
                    return t._updateElements(e);
                  }),
                this._updateURL(e, n);
            },
          },
          {
            key: "updateFiltersBySearchParams",
            value: function (e) {
              var t = this._createUrl(e),
                n = document.querySelector("#SidebarFiltersMobile"),
                i = document.querySelector("#SidebarFiltersDesktop");
              if (n && i) {
                var a = [n, i];
                a.forEach(function (e) {
                  e.loadingOverlay.show();
                });
                var r = function (e) {
                  a.forEach(function (t) {
                    t.updateHTML(e), t.loadingOverlay.hide();
                  });
                };
                this._cache[t]
                  ? r(this._cache[t])
                  : this._getFromUrl(t).then(function (e) {
                      return r(e);
                    });
              }
            },
          },
          {
            key: "_getFromUrl",
            value: function (e) {
              var t = this,
                n = this.querySelector("#ShopProductsOverlay"),
                i = n ? new Zi(n) : null;
              i && i.show();
              var a = ""
                .concat(e, "&section_id=")
                .concat(this.dataset.sectionId);
              return fetch(a)
                .then(function (e) {
                  return e.text();
                })
                .then(function (n) {
                  var a = ge(n);
                  return (t._cache[e] = a), i && i.hide(), a;
                })
                .catch(function () {
                  Nt.notification &&
                    Nt.notification.show("Error in shop component", "warning");
                });
            },
          },
          {
            key: "_updateURL",
            value: function (e, t) {
              history.pushState({ searchParams: e }, "", t);
            },
          },
          {
            key: "_createUrl",
            value: function (e) {
              var t = this._formatParams(e) || "";
              return "".concat(window.location.pathname, "?").concat(t);
            },
          },
          {
            key: "_updateElements",
            value: function (e) {
              [
                "ShopProducts",
                "ShopProductCount",
                "ShopSortList",
                "ShopActiveFilters",
              ].forEach(function (t) {
                var n = document.getElementById(t),
                  i = e.getElementById(t);
                if (n && i) {
                  var a,
                    r = i.cloneNode(!0);
                  (a = n).replaceChildren.apply(a, L(r.childNodes));
                }
              });
            },
          },
          {
            key: "resetQueries",
            value: function () {
              (this.sortQuery = ""), (this.filterQuery = "");
            },
          },
        ]),
        n
      );
    })(ne),
    ir = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).optionsSelector =
            "[data-shop-active-filters-options]"),
          (e.removeBtnSelector = "[data-shop-active-filters-remove-btn]"),
          e
        );
      }
      return (
        g(n, [
          {
            key: "reset",
            value: function () {
              this.replaceChildren();
            },
          },
          {
            key: "setDisable",
            value: function () {
              this.options && this.options.setAttribute("disabled", "");
            },
          },
          {
            key: "options",
            get: function () {
              return this.querySelector(this.optionsSelector);
            },
          },
          {
            key: "buttons",
            get: function () {
              return L(this.querySelectorAll(this.removeBtnSelector));
            },
          },
        ]),
        n
      );
    })(ne),
    ar = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleFormScroll", function () {
            if (e.form) {
              var t = e.form.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t);
            }
          }),
          a(p(e), "_handleClick", function (e) {
            var t = e.target.closest("[data-filters-checkbox]");
            t && t.setAttribute("selected", "");
          }),
          a(p(e), "_handleInputChange", function (t) {
            "INPUT" === t.target.tagName && e._change();
          }),
          (e.form = e.element.querySelector("[data-filters-form]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              Jt(A(n.prototype), "connectedCallback", this).call(this),
                H(this.form, "scroll", this._handleFormScroll),
                H(this, "change", this._handleInputChange),
                H(this, "click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Jt(A(n.prototype), "disconnectedCallback", this).call(this),
                U(this.form, "scroll", this._handleFormScroll),
                U(this, "change", this._handleInputChange),
                U(this, "click", this._handleClick);
            },
          },
          { key: "_change", value: function () {} },
          {
            key: "_createFilterQuery",
            value: function () {
              if (this._form && this._shop) {
                var e = new FormData(this._form),
                  t = new URLSearchParams(e).toString();
                this._shop.filterQuery = t;
              }
            },
          },
          {
            key: "updateHTML",
            value: function (e) {
              if (this.isOpenOnInit) {
                var t = this.getAttribute("id"),
                  n = t ? e.getElementById(t) : null,
                  i = n ? n.querySelector("[data-sidebar-body]") : null;
                i &&
                  (this.updateFormFromElement(i),
                  this.updateHeaderFromElement(i));
              } else {
                var a = this.getAttribute("id"),
                  r = a ? e.getElementById(a) : null,
                  o = r ? r.querySelector("template") : null;
                if (o) {
                  var s = pe(o);
                  this.updateFormFromElement(s),
                    this.updateHeaderFromElement(s);
                }
              }
            },
          },
          {
            key: "updateHeaderFromElement",
            value: function (e) {
              var t = this.element.querySelector("[data-filters-header]"),
                n = e.querySelector("[data-filters-header]");
              if (t && n) {
                var i,
                  a = n.cloneNode(!0);
                (i = t).replaceChildren.apply(i, L(a.childNodes));
              }
            },
          },
          {
            key: "updateFormFromElement",
            value: function (e) {
              var t = this.element.querySelector("[data-filters-form]"),
                n = e.querySelector("[data-filters-form]");
              if (t && n) {
                var i,
                  a = n.cloneNode(!0);
                (i = t).replaceChildren.apply(i, L(a.childNodes));
              }
            },
          },
          {
            key: "_form",
            get: function () {
              return this.element.querySelector("form");
            },
          },
          {
            key: "_shop",
            get: function () {
              return this.element.closest("shop-component");
            },
          },
          {
            key: "_searchParams",
            get: function () {
              return this._shop
                ? [this._shop.filterQuery, this._shop.sortQuery].join("&")
                : "";
            },
          },
          {
            key: "loadingOverlay",
            get: function () {
              var e = this.element.querySelector(
                "[data-filters-loading-overlay]"
              );
              return e ? new Zi(e) : null;
            },
          },
        ]),
        n
      );
    })(kn),
    rr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleSectionLoad",
            function () {}
          ),
          e
        );
      }
      return (
        g(n, [
          {
            key: "_change",
            value: function () {
              this._shop &&
                (this._createFilterQuery(),
                this._shop.updateBySearchParams(this._searchParams));
            },
          },
        ]),
        n
      );
    })(ar),
    or = rr,
    sr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "_change",
            value: function () {
              this._shop &&
                (this._createFilterQuery(),
                this._shop.updateFiltersBySearchParams(this._searchParams),
                this._setButtonForReset());
            },
          },
          {
            key: "_setButtonForReset",
            value: function () {
              var e = this.element.querySelector("filter-remove-btn");
              e && e.classList.contains("hidden") && de(e);
            },
          },
        ]),
        n
      );
    })(ar),
    cr = sr,
    lr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e.update();
            }
          ),
          a(p(e), "_handleKeyDown", function (t) {
            X(t.key || t.keyCode) && (t.preventDefault(), e.update());
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e = this.closest("shop-active-filters"),
                t = this.closest("shop-component"),
                n = this.dataset.url;
              if (e) {
                var i = this.hasAttribute(
                  "data-shop-active-filters-remove-btn"
                );
                if (
                  (this.hasAttribute("data-shop-active-filters-reset") &&
                    e.reset(),
                  i)
                )
                  1 === e.buttons.length
                    ? e.reset()
                    : (e.setDisable(), this.remove());
              }
              if (n && t) {
                var a =
                  -1 === n.indexOf("?") ? "" : n.slice(n.indexOf("?") + 1);
                t.resetQueries(), t.updateBySearchParams(a);
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ur = lr,
    dr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "_handleFormSubmit",
            (0, Oi.debounce)(function (t) {
              t.preventDefault();
              var n = e.closest("shop-component"),
                i = e.closest("sidebar-component"),
                a = t.target;
              if ((i && i.hide(), n && a)) {
                var r = e._getSortQuery(a),
                  o = [n.filterQuery, r].join("&");
                (n.sortQuery = r), n.updateBySearchParams(o);
              }
            }, 250)
          ),
          a(p(e), "_handleLabelKeyDown", function (e) {
            if (X(e.key || e.keyCode)) {
              e.preventDefault();
              var t = e.target.querySelector("input");
              if (t) {
                var n = new MouseEvent("click", { button: 0, which: 1 });
                t.dispatchEvent(n);
              }
            }
          }),
          (e.labelSelector = "[data-sort-list-label]"),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.setListenersForLabels(),
                H(this._form, "input", this._handleFormSubmit);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeListenersForLabels(),
                U(this._form, "input", this._handleFormSubmit);
            },
          },
          {
            key: "_getSortQuery",
            value: function (e) {
              var t = e.closest("form");
              if (t) {
                var n = new FormData(t);
                return new URLSearchParams(n).toString();
              }
              return "";
            },
          },
          {
            key: "setListenersForLabels",
            value: function () {
              var e = this;
              L(this.querySelectorAll(this.labelSelector)).forEach(function (
                t
              ) {
                t.addEventListener("keydown", e._handleLabelKeyDown);
              });
            },
          },
          {
            key: "removeListenersForLabels",
            value: function () {
              var e = this;
              L(this.querySelectorAll(this.labelSelector)).forEach(function (
                t
              ) {
                t.removeEventListener("keydown", e._handleLabelKeyDown);
              });
            },
          },
          {
            key: "_form",
            get: function () {
              return this.querySelector("form");
            },
          },
        ]),
        n
      );
    })(ne),
    hr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleRangeInput", function (t) {
            var n = e.querySelector("[data-price-range-max-input]"),
              i = e.querySelector("[data-price-range-min-input]");
            if (e._progress && i && n) {
              var a = e._progress.offsetLeft + e._progress.offsetWidth / 2,
                r = t.offsetX < a;
              i.toggleAttribute("targeted", r),
                n.toggleAttribute("targeted", !r);
            }
          }),
          a(p(e), "_handleNumberChange", function () {
            if (e._minNumberInput && e._maxNumberInput) {
              var t = parseInt(e._minNumberInput.value),
                n = parseInt(e._maxNumberInput.value);
              e._updateMinRangeInput(t), e._updateMaxRangeInput(n);
            }
          }),
          a(p(e), "_handleRangeChange", function () {
            if (e._minRangeInput && e._maxRangeInput) {
              var t = parseInt(e._minRangeInput.value),
                n = parseInt(e._maxRangeInput.value);
              e._updateMaxPriceInput(n),
                e._updateMaxRangeInput(n),
                e._updateMinPriceInput(t),
                e._updateMinRangeInput(t);
            }
          }),
          (e._minNumberInput = e.querySelector(
            "[data-price-min-range-number]"
          )),
          (e._maxNumberInput = e.querySelector(
            "[data-price-max-range-number]"
          )),
          (e._rangeWrapper = e.querySelector(
            "[data-price-range-inputs-wrapper]"
          )),
          (e._minRangeInput = e.querySelector("[data-price-min-range-input]")),
          (e._maxRangeInput = e.querySelector("[data-price-max-range-input]")),
          (e._progress = e.querySelector("[data-price-range-progress]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this._minRangeInput &&
                this._updateMinRangeInput(+this._minRangeInput.value),
                this._maxRangeInput &&
                  this._updateMaxRangeInput(+this._maxRangeInput.value),
                H(this._minNumberInput, "input", this._handleNumberChange),
                H(this._maxNumberInput, "input", this._handleNumberChange),
                H(this._minRangeInput, "input", this._handleRangeChange),
                H(this._maxRangeInput, "input", this._handleRangeChange),
                H(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                H(this._rangeWrapper, "mousemove", this._handleRangeInput);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._minNumberInput, "input", this._handleNumberChange),
                U(this._maxNumberInput, "input", this._handleNumberChange),
                U(this._minRangeInput, "input", this._handleRangeChange),
                U(this._maxRangeInput, "input", this._handleRangeChange),
                U(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                U(this._rangeWrapper, "mousemove", this._handleRangeInput);
            },
          },
          {
            key: "_updateMaxRangeInput",
            value: function (e) {
              if (this._maxRangeInput && this._progress) {
                var t = 100 - (e / +this._maxRangeInput.max) * 100;
                (this._maxRangeInput.value = "".concat(e)),
                  (this._progress.style.right = "".concat(t, "%"));
              }
            },
          },
          {
            key: "_updateMinRangeInput",
            value: function (e) {
              if (this._minRangeInput && this._progress) {
                var t = (e / +this._minRangeInput.max) * 100;
                (this._minRangeInput.value = "".concat(e)),
                  (this._progress.style.left = "".concat(t, "%"));
              }
            },
          },
          {
            key: "_updateMaxPriceInput",
            value: function (e) {
              this._maxNumberInput &&
                (this._maxNumberInput.value = e.toFixed(2));
            },
          },
          {
            key: "_updateMinPriceInput",
            value: function (e) {
              this._minNumberInput &&
                (this._minNumberInput.value = e.toFixed(2));
            },
          },
        ]),
        n
      );
    })(ne),
    fr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleSectionLoad", function (t) {
            e.dataset.sectionId === t.detail.sectionId && e.reset();
          }),
          a(p(e), "_handleItemClick", function (t) {
            var n = t.target.closest(e.itemSelector);
            if (n) {
              var i = +(n.dataset.value || 1);
              e._switch(i);
            }
          }),
          a(p(e), "_handleKeyDown", function (t) {
            if (X(t.key || t.keyCode)) {
              t.preventDefault();
              var n = t.target.closest(e.itemSelector);
              if (n) {
                var i = +(n.dataset.value || 1);
                e._switch(i);
              }
            }
          }),
          (e.itemSelector = "[data-column-switcher-item]"),
          (e.targetSelector = "[data-column-switcher-target]"),
          (e.items = L(e.querySelectorAll(e.itemSelector))),
          (e._cssVariable = e.dataset.columnSwitcherCssVariable || ""),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this._isEditorMode || this._init(),
                this.items.forEach(function (t) {
                  H(t, "keydown", e._handleKeyDown),
                    H(t, "click", e._handleItemClick);
                }),
                this._isEditorMode &&
                  this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.items.forEach(function (t) {
                U(t, "keydown", e._handleKeyDown),
                  U(t, "click", e._handleItemClick);
              }),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "updateByColumnCount",
            value: function (e) {
              this._selectSwitch(e), this._updateColumnCount(e);
            },
          },
          {
            key: "_selectSwitch",
            value: function (e) {
              this.items.forEach(function (t) {
                var n = +(t.getAttribute("data-value") || 1);
                t.classList.toggle("selected", n === e);
              });
            },
          },
          {
            key: "_updateColumnCount",
            value: function (e) {
              var t = this.closest(this.targetSelector);
              t &&
                (t.style.setProperty(
                  "--gsc-".concat(this._cssVariable),
                  e.toString()
                ),
                localStorage.setItem(
                  "products-".concat(this._cssVariable),
                  e.toString()
                ));
            },
          },
          {
            key: "_init",
            value: function () {
              var e = localStorage.getItem(
                "products-".concat(this._cssVariable)
              );
              if (e && "null" !== e) {
                var t = Number(e);
                t > 0 && this.updateByColumnCount(t);
              }
            },
          },
          {
            key: "_switch",
            value: function (e) {
              this.updateByColumnCount(e);
            },
          },
          {
            key: "reset",
            value: function () {
              this.dataset.default &&
                this._switch(Number(this.dataset.default));
            },
          },
        ]),
        n
      );
    })(ne),
    vr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              var t = e.closest("shop-component"),
                n = e.closest("#SidebarFiltersMobile");
              if (t) {
                var i = [t.filterQuery, t.sortQuery].join("&");
                t.updateShopBySearchParams(i);
              }
              n && n.hide();
            }
          ),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              H(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this, "click", this._handleButtonClick);
            },
          },
        ]),
        n
      );
    })(ne),
    pr = vr,
    mr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleButtonMouseDown", function (t) {
            t.preventDefault(), e.startMove();
          }),
          a(p(e), "_handleButtonMouseUp", function () {
            e.endMove();
          }),
          a(p(e), "_handleMouseMove", function (t) {
            e._isMoved && e.moveSeparator(t.pageX);
          }),
          a(p(e), "_handleButtonKeyUp", function (t) {
            if (e._btn) {
              var n = t.key || t.keyCode,
                i = Z(n),
                a = G(n);
              if (i || a) {
                var r = e._btn.getBoundingClientRect(),
                  o = r.right - r.width / 2,
                  s = i ? o - e._movingStep : o + e._movingStep;
                e.moveSeparator(s);
              }
            }
          }),
          a(p(e), "_handleTouchStart", function () {
            e.startMove();
          }),
          a(p(e), "_handleTouchEnd", function () {
            e.endMove();
          }),
          a(p(e), "_handleTouchMove", function (t) {
            e._isMoved &&
              (t.preventDefault(), e.moveSeparator(t.targetTouches[0].clientX));
          }),
          (e._btnSelector = "[data-before-after-images-button]"),
          (e._btn = e.querySelector(e._btnSelector)),
          (e._isMoved = !1),
          (e._movingStep = 20),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.setSeparatorPosition(
                Number(this.dataset.initialDragPosition)
              ),
                H(this._btn, "keyup", this._handleButtonKeyUp),
                H(this._btn, "mousedown", this._handleButtonMouseDown),
                H(document, "mouseup", this._handleButtonMouseUp),
                H(document, "mousemove", this._handleMouseMove),
                H(this._btn, "touchstart", this._handleTouchStart),
                H(this, "touchmove", this._handleTouchMove),
                H(document, "touchend", this._handleTouchEnd);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              U(this._btn, "keyup", this._handleButtonKeyUp),
                U(this._btn, "mousedown", this._handleButtonMouseDown),
                U(document, "mouseup", this._handleButtonMouseUp),
                U(document, "mousemove", this._handleMouseMove),
                U(this._btn, "touchstart", this._handleTouchStart),
                U(this, "touchmove", this._handleTouchMove),
                U(document, "touchend", this._handleTouchEnd);
            },
          },
          {
            key: "startMove",
            value: function () {
              this._isMoved = !0;
            },
          },
          {
            key: "endMove",
            value: function () {
              this._isMoved = !1;
            },
          },
          {
            key: "setSeparatorPosition",
            value: function (e) {
              this.style.setProperty("--gsc-drag-position", "".concat(e, "%"));
            },
          },
          {
            key: "moveSeparator",
            value: function (e) {
              var t = this.getBoundingClientRect();
              if (e <= t.left) this.setSeparatorPosition(0);
              else if (e >= t.right) this.setSeparatorPosition(100);
              else {
                var n =
                  Math.floor(((e - t.left) / this.offsetWidth) * 1e3) / 10;
                this.setSeparatorPosition(n);
              }
            },
          },
        ]),
        n
      );
    })(ne),
    yr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFloatElementOpen", function () {
            e.setAttribute("animation-state", "pause");
          }),
          a(p(e), "handleFloatElementHide", function () {
            e.removeAttribute("animation-state");
          }),
          a(p(e), "handleModalOpen", function () {
            e.setAttribute("animation-state", "pause"),
              e.header && e.header._setHidden(!0);
          }),
          a(p(e), "handleModalHide", function () {
            e.removeAttribute("animation-state"),
              e.header && e.header._setHidden(!1);
          }),
          a(p(e), "handleEditorClick", function () {
            e.floatElements.forEach(function (e) {
              e.hide();
            });
          }),
          (e.modals = L(e.querySelectorAll("modal-component"))),
          (e.floatElements = L(e.querySelectorAll("hotspots-float-element"))),
          (e.header = document.querySelector("header-component")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.modals.forEach(function (t) {
                customElements.whenDefined("modal-component").then(function () {
                  t.subscribe("show", e.handleModalOpen),
                    t.subscribe("hide", e.handleModalHide);
                });
              }),
                this.floatElements.forEach(function (t) {
                  customElements
                    .whenDefined("hotspots-float-element")
                    .then(function () {
                      t.subscribe("show", e.handleFloatElementOpen),
                        t.subscribe("hide", e.handleFloatElementHide);
                    });
                }),
                this._isEditorMode &&
                  window.addEventListener("click", this.handleEditorClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.modals.forEach(function (t) {
                customElements.whenDefined("modal-component").then(function () {
                  t.unsubscribe("show", e.handleModalOpen),
                    t.unsubscribe("hide", e.handleModalHide);
                });
              }),
                this.floatElements.forEach(function (t) {
                  customElements
                    .whenDefined("hotspots-float-element")
                    .then(function () {
                      t.unsubscribe("show", e.handleFloatElementOpen),
                        t.unsubscribe("hide", e.handleFloatElementHide);
                    });
                }),
                this._isEditorMode &&
                  window.removeEventListener("click", this.handleEditorClick);
            },
          },
        ]),
        n
      );
    })(ne),
    gr = "AuroraTheme-Timer",
    br = (function () {
      "use strict";
      function e(t) {
        m(this, e), (this._blockId = t);
      }
      return (
        g(e, [
          {
            key: "parseData",
            value: function (e) {
              try {
                var t = JSON.parse(null != e ? e : "{}");
                return "endDate" in t && "hash" in t
                  ? { endDate: new Date(+t.endDate), hash: t.hash }
                  : null;
              } catch (e) {
                return null;
              }
            },
          },
          {
            key: "saveData",
            value: function (e) {
              try {
                localStorage.setItem(
                  "".concat(gr, "-").concat(this._blockId),
                  JSON.stringify({ endDate: e.endDate.getTime(), hash: e.hash })
                );
              } catch (e) {}
            },
          },
          {
            key: "loadData",
            value: function () {
              try {
                return this.parseData(
                  localStorage.getItem("".concat(gr, "-").concat(this._blockId))
                );
              } catch (e) {
                return null;
              }
            },
          },
        ]),
        e
      );
    })();
  ((ba = ga || (ga = {})).Fixed = "fixed"),
    (ba.Evergreen = "evergreen"),
    ((ka = _a || (_a = {})).None = "none"),
    (ka.Hide = "hide"),
    (ka.Restart = "restart"),
    (ka.WaitOneDay = "wait_one_day");
  var _r = {
      january: 0,
      february: 1,
      march: 2,
      april: 3,
      may: 4,
      june: 5,
      july: 6,
      august: 7,
      september: 8,
      october: 9,
      november: 10,
      december: 11,
    },
    kr = function (e, t) {
      var n = new Date();
      switch (e) {
        case "day":
          n.setDate(n.getDate() + t);
          break;
        case "hour":
          n.setHours(n.getHours() + t);
          break;
        case "minute":
          n.setMinutes(n.getMinutes() + t);
          break;
        case "second":
          n.setSeconds(n.getSeconds() + t);
      }
      return n;
    },
    wr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e, i, r, o;
        (m(this, n),
        a(p((e = t.call(this))), "mode", ga.Fixed),
        a(p(e), "endDate", new Date()),
        a(p(e), "finishStrategy", _a.None),
        (e._daysUnit = e.querySelector("[data-timer-days]")),
        (e._hoursUnit = e.querySelector("[data-timer-hours]")),
        (e._minutesUnit = e.querySelector("[data-timer-minutes]")),
        (e._secondsUnit = e.querySelector("[data-timer-seconds]")),
        (e._daysUnitLabel = e.querySelector("[data-timer-days-label]")),
        (e._hoursUnitLabel = e.querySelector("[data-timer-hours-label]")),
        (e._minutesUnitLabel = e.querySelector("[data-timer-minutes-label]")),
        (e._secondsUnitLabel = e.querySelector("[data-timer-seconds-label]")),
        (e.evergreenUnit =
          null !== (i = e.dataset.evergreenUnit) && void 0 !== i
            ? i
            : "minute"),
        (e.evergreenValue = parseInt(
          null !== (r = e.dataset.evergreenValue) && void 0 !== r ? r : "0"
        )),
        (e.mode = e.dataset.mode),
        e.mode === ga.Fixed &&
          (e.finishStrategy =
            "true" === e.dataset.hideOnComplete ? _a.Hide : _a.None),
        e.mode === ga.Evergreen) &&
          ((e.finishStrategy = e.dataset.evergreenOnComplete),
          (e.timerStorage = new br(
            null !== (o = e.dataset.blockId) && void 0 !== o ? o : e.id
          )));
        return e;
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.start();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              clearInterval(this.timerRef);
            },
          },
          {
            key: "getHash",
            value: function () {
              return ""
                .concat(this.finishStrategy, "-")
                .concat(this.evergreenUnit, "-")
                .concat(this.evergreenValue);
            },
          },
          {
            key: "start",
            value: function () {
              if (this.mode === ga.Fixed) {
                var e,
                  t = Number(this.dataset.year),
                  n =
                    _r[
                      null !== (e = this.dataset.month) && void 0 !== e
                        ? e
                        : "january"
                    ],
                  i = Number(this.dataset.day),
                  a = Number(this.dataset.hour),
                  r = Number(this.dataset.minute);
                this.endDate = new Date(t, n, i, a, r);
              }
              if (this.mode === ga.Evergreen) {
                var o = this.timerStorage.loadData();
                o && o.hash === this.getHash()
                  ? (this.endDate = o.endDate)
                  : this.updateEvergreenData();
              }
              (this.timerRef = setInterval(this.tick.bind(this), 1e3)),
                this.tick();
            },
          },
          {
            key: "updateEvergreenData",
            value: function () {
              var e = kr(this.evergreenUnit, this.evergreenValue);
              this.timerStorage.saveData({ endDate: e, hash: this.getHash() }),
                (this.endDate = e);
            },
          },
          {
            key: "finish",
            value: function () {
              switch ((clearInterval(this.timerRef), this.finishStrategy)) {
                case _a.Restart:
                  this.timerStorage.saveData({
                    endDate: kr(this.evergreenUnit, this.evergreenValue),
                    hash: this.getHash(),
                  }),
                    this.start();
                  break;
                case _a.WaitOneDay:
                  if (new Date().getTime() - this.endDate.getTime() > 864e5) {
                    var e = kr(this.evergreenUnit, this.evergreenValue);
                    this.timerStorage.saveData({
                      endDate: e,
                      hash: this.getHash(),
                    }),
                      this.start();
                  } else this.hide();
                  break;
                default:
                  this.hide();
              }
            },
          },
          {
            key: "renderTime",
            value: function (e, t, n, i) {
              this._daysUnit &&
                this._hoursUnit &&
                this._minutesUnit &&
                this._secondsUnit &&
                ((this._daysUnit.innerText = e.toString()),
                (this._hoursUnit.innerText = t.toString()),
                (this._minutesUnit.innerText = n.toString()),
                (this._secondsUnit.innerText = i.toString()),
                this.renderLabels(e, t, n, i));
            },
          },
          {
            key: "renderLabels",
            value: function (e, t, n, i) {
              this._daysUnitLabel &&
                this._hoursUnitLabel &&
                this._minutesUnitLabel &&
                this._secondsUnitLabel &&
                ((this._daysUnitLabel.innerText =
                  1 === e
                    ? window.countdownTimerString.day
                    : window.countdownTimerString.days),
                (this._hoursUnitLabel.innerText =
                  1 === t
                    ? window.countdownTimerString.hour
                    : window.countdownTimerString.hours),
                (this._minutesUnitLabel.innerText =
                  1 === n
                    ? window.countdownTimerString.minute
                    : window.countdownTimerString.minutes),
                (this._secondsUnitLabel.innerText =
                  1 === i
                    ? window.countdownTimerString.second
                    : window.countdownTimerString.seconds));
            },
          },
          {
            key: "tick",
            value: function () {
              var e = this.endDate.getTime() - new Date().getTime();
              if (e > 0)
                return (
                  this.show(),
                  void this.renderTime(
                    Math.floor(e / 864e5),
                    Math.floor((e % 864e5) / 36e5),
                    Math.floor((e % 36e5) / 6e4),
                    Math.floor((e % 6e4) / 1e3)
                  )
                );
              this.renderTime(0, 0, 0, 0),
                this.finish(),
                window.Shopify.designMode && this.show();
            },
          },
          {
            key: "show",
            value: function () {
              de(this),
                this.dataset.blockId &&
                  de(
                    document.querySelector(
                      ".block-".concat(this.dataset.blockId)
                    )
                  );
            },
          },
          {
            key: "hide",
            value: function () {
              window.Shopify.designMode ||
                (this.dataset.sectionId &&
                  he(
                    document.querySelector(
                      ".section-".concat(this.dataset.sectionId)
                    )
                  ),
                this.dataset.blockId &&
                  he(
                    document.querySelector(
                      ".block-".concat(this.dataset.blockId)
                    )
                  ),
                he(this));
            },
          },
        ]),
        n
      );
    })(ne),
    Sr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleFormScroll", function () {
            if (e.viewport) {
              var t = e.viewport.scrollTop > 0;
              e.toggleAttribute("header-shadow-visible", t);
            }
          }),
          (e.viewport = e.element.querySelector(
            "[data-product-information-drawer-viewport]"
          )),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              Jt(A(n.prototype), "connectedCallback", this).call(this),
                H(this.viewport, "scroll", this._handleFormScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Jt(A(n.prototype), "disconnectedCallback", this).call(this),
                U(this.viewport, "scroll", this._handleFormScroll);
            },
          },
        ]),
        n
      );
    })(kn),
    Cr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n), ((e = t.call(this)).styles = getComputedStyle(p(e))), e
        );
      }
      return (
        g(n, [
          {
            key: "show",
            value: function () {
              return this.setVisible(!0), V(this.transitionDuration);
            },
          },
          {
            key: "hide",
            value: function () {
              return this.setVisible(!1), V(this.transitionDuration);
            },
          },
          {
            key: "setVisible",
            value: function (e) {
              this.setAttribute("aria-hidden", e ? "false" : "true");
            },
          },
          {
            key: "isVisible",
            get: function () {
              return "false" === this.getAttribute("aria-hidden");
            },
          },
          {
            key: "transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        n
      );
    })(ne),
    Er = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleWindowScroll", function () {
            e._lastScrollPosition || (e._lastScrollPosition = window.scrollY),
              e.updateVisibleStatus(),
              e.updateExtendStatus();
          }),
          a(
            p(e),
            "updateExtendStatus",
            (0, Oi.debounce)(function () {
              if (Math.abs(window.scrollY - e._lastScrollPosition) > 24) {
                var t = e._lastScrollPosition > window.scrollY;
                e.toggleAttribute("is-extended", t);
              }
              e._lastScrollPosition = 0;
            }, 50)
          ),
          (e.products = document.getElementById("ShopProducts")),
          (e.footer = document.querySelector(".shopify-section-footer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              Jt(A(n.prototype), "connectedCallback", this).call(this),
                window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Jt(A(n.prototype), "disconnectedCallback", this).call(this),
                window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "updateVisibleStatus",
            value: function () {
              var e = this.footer ? this.footer.offsetTop : 0,
                t = this.products.getBoundingClientRect(),
                n = window.innerHeight + window.scrollY < e,
                i = t.top < 0,
                a = n && i;
              this.toggleAttribute("is-visible", a),
                document.body.toggleAttribute("is-filters-button-fixed", a);
            },
          },
        ]),
        n
      );
    })(_n),
    xr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).checkbox = e.querySelector(
            "[data-recipient-form-checkbox]"
          )),
          (e.timezoneInput = e.querySelector(
            "[data-recipient-form-timezone-input]"
          )),
          (e.inputs = e.querySelectorAll(
            "[data-recipient-form-input], [data-recipient-form-timezone-input]"
          )),
          (e.fields = e.querySelector("[data-recipient-form-fields]")),
          (e.timezoneInput.value = new Date().getTimezoneOffset()),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("change", this.handleChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("change", this.handleChange);
            },
          },
          {
            key: "handleChange",
            value: function () {
              var e = this.checkbox.checked;
              this.updateMaxHeight(e),
                this.updateInputDisable(!e),
                e || this.clearInputs();
            },
          },
          {
            key: "clearInputs",
            value: function () {
              this.inputs.forEach(function (e) {
                e.value = "";
              });
            },
          },
          {
            key: "updateInputDisable",
            value: function (e) {
              this.inputs.forEach(function (t) {
                t.disabled = e;
              });
            },
          },
          {
            key: "reset",
            value: function () {
              (this.checkbox.checked = !1), this.clearInputs();
            },
          },
          {
            key: "updateMaxHeight",
            value: function (e) {
              if (this.fields) {
                var t = e ? this.fields.scrollHeight : 0;
                this.fields.style.maxHeight = "".concat(t, "px");
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Lr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return g(n, [{ key: "connectedCallback", value: function () {} }]), n;
    })(Qa),
    Ir = Lr,
    Tr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return g(n, [{ key: "connectedCallback", value: function () {} }]), n;
    })(Qa),
    Ar = Tr,
    Dr = {
      aliceblue: "#f0f8ff",
      antiquewhite: "#faebd7",
      aqua: "#00ffff",
      aquamarine: "#7fffd4",
      azure: "#f0ffff",
      beige: "#f5f5dc",
      bisque: "#ffe4c4",
      black: "#000000",
      blanchedalmond: "#ffebcd",
      blue: "#0000ff",
      blueviolet: "#8a2be2",
      brown: "#a52a2a",
      burlywood: "#deb887",
      cadetblue: "#5f9ea0",
      chartreuse: "#7fff00",
      chocolate: "#d2691e",
      coral: "#ff7f50",
      cornflowerblue: "#6495ed",
      cornsilk: "#fff8dc",
      crimson: "#dc143c",
      cyan: "#00ffff",
      darkblue: "#00008b",
      darkcyan: "#008b8b",
      darkgoldenrod: "#b8860b",
      darkgray: "#a9a9a9",
      darkgreen: "#006400",
      darkkhaki: "#bdb76b",
      darkmagenta: "#8b008b",
      darkolivegreen: "#556b2f",
      darkorange: "#ff8c00",
      darkorchid: "#9932cc",
      darkred: "#8b0000",
      darksalmon: "#e9967a",
      darkseagreen: "#8fbc8f",
      darkslateblue: "#483d8b",
      darkslategray: "#2f4f4f",
      darkturquoise: "#00ced1",
      darkviolet: "#9400d3",
      deeppink: "#ff1493",
      deepskyblue: "#00bfff",
      dimgray: "#696969",
      dodgerblue: "#1e90ff",
      firebrick: "#b22222",
      floralwhite: "#fffaf0",
      forestgreen: "#228b22",
      fuchsia: "#ff00ff",
      gainsboro: "#dcdcdc",
      ghostwhite: "#f8f8ff",
      gold: "#ffd700",
      goldenrod: "#daa520",
      gray: "#808080",
      green: "#008000",
      greenyellow: "#adff2f",
      honeydew: "#f0fff0",
      hotpink: "#ff69b4",
      indianred: "#cd5c5c",
      indigo: "#4b0082",
      ivory: "#fffff0",
      khaki: "#f0e68c",
      lavender: "#e6e6fa",
      lavenderblush: "#fff0f5",
      lawngreen: "#7cfc00",
      lemonchiffon: "#fffacd",
      lightblue: "#add8e6",
      lightcoral: "#f08080",
      lightcyan: "#e0ffff",
      lightgoldenrodyellow: "#fafad2",
      lightgrey: "#d3d3d3",
      lightgreen: "#90ee90",
      lightpink: "#ffb6c1",
      lightsalmon: "#ffa07a",
      lightseagreen: "#20b2aa",
      lightskyblue: "#87cefa",
      lightslategray: "#778899",
      lightsteelblue: "#b0c4de",
      lightyellow: "#ffffe0",
      lime: "#00ff00",
      limegreen: "#32cd32",
      linen: "#faf0e6",
      magenta: "#ff00ff",
      maroon: "#800000",
      mediumaquamarine: "#66cdaa",
      mediumblue: "#0000cd",
      mediumorchid: "#ba55d3",
      mediumpurple: "#9370d8",
      mediumseagreen: "#3cb371",
      mediumslateblue: "#7b68ee",
      mediumspringgreen: "#00fa9a",
      mediumturquoise: "#48d1cc",
      mediumvioletred: "#c71585",
      midnightblue: "#191970",
      mintcream: "#f5fffa",
      mistyrose: "#ffe4e1",
      moccasin: "#ffe4b5",
      navajowhite: "#ffdead",
      navy: "#000080",
      oldlace: "#fdf5e6",
      olive: "#808000",
      olivedrab: "#6b8e23",
      orange: "#ffa500",
      orangered: "#ff4500",
      orchid: "#da70d6",
      palegoldenrod: "#eee8aa",
      palegreen: "#98fb98",
      paleturquoise: "#afeeee",
      palevioletred: "#d87093",
      papayawhip: "#ffefd5",
      peachpuff: "#ffdab9",
      peru: "#cd853f",
      pink: "#ffc0cb",
      plum: "#dda0dd",
      powderblue: "#b0e0e6",
      purple: "#800080",
      rebeccapurple: "#663399",
      red: "#ff0000",
      rosybrown: "#bc8f8f",
      royalblue: "#4169e1",
      saddlebrown: "#8b4513",
      salmon: "#fa8072",
      sandybrown: "#f4a460",
      seagreen: "#2e8b57",
      seashell: "#fff5ee",
      sienna: "#a0522d",
      silver: "#c0c0c0",
      skyblue: "#87ceeb",
      slateblue: "#6a5acd",
      slategray: "#708090",
      snow: "#fffafa",
      springgreen: "#00ff7f",
      steelblue: "#4682b4",
      tan: "#d2b48c",
      teal: "#008080",
      thistle: "#d8bfd8",
      tomato: "#ff6347",
      turquoise: "#40e0d0",
      violet: "#ee82ee",
      wheat: "#f5deb3",
      white: "#ffffff",
      whitesmoke: "#f5f5f5",
      yellow: "#ffff00",
      yellowgreen: "#9acd32",
    },
    Pr = Object.keys(Dr).reduce(function (e, t) {
      return o(r({}, e), a({}, Dr[t], t));
    }, {}),
    Mr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          ((e = t.call(this)).element =
            e.querySelector(".color-swatch") || p(e)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.setValue();
            },
          },
          { key: "disconnectedCallback", value: function () {} },
          {
            key: "setValue",
            value: function () {
              var e = this;
              if (!this.hasAttribute("is-image")) {
                var t = this.dataset.color.toLowerCase().trim(),
                  n = this.dataset.colorsPatterns.split("\n");
                this.isColor(t) || this.element.setAttribute("not-valid", ""),
                  this.setPropertyValue(t),
                  n.forEach(function (n) {
                    var i = n.split("::"),
                      a = i[0],
                      r = i[1];
                    a.toLowerCase().trim() !== t || e.setPropertyValue(r);
                  });
              }
            },
          },
          {
            key: "getGradientValue",
            value: function (e) {
              var t = "90deg, ";
              return (
                e.forEach(function (n, i) {
                  var a = 100 / e.length,
                    r = "".concat(a * i, "%"),
                    o = "".concat(a * (i + 1), "%"),
                    s = ""
                      .concat(n, " ")
                      .concat(r, ", ")
                      .concat(n, " ")
                      .concat(o);
                  (t = "".concat(t, " ").concat(s)),
                    i !== e.length - 1 && (t = "".concat(t, ", "));
                }),
                "linear-gradient(".concat(t, ")")
              );
            },
          },
          {
            key: "setPropertyValue",
            value: function (e) {
              var t = this.isImage(e),
                n = this.isUrl(e),
                i = this.isGradient(e),
                a = this.isColor(e),
                r = this.dataset.sectionBackground,
                o = Pr[r];
              if (n)
                this.element.removeAttribute("not-valid"),
                  this.element.style.setProperty(
                    "--gsc-color-swatch-value",
                    "url(".concat(e, ")")
                  ),
                  this.setSimilarlyBgColorStatus(!1);
              else if (t) this.setSimilarlyBgColorStatus(!1);
              else if (i) {
                var s = e.split("/"),
                  c = this.getGradientValue(s),
                  l = e.includes(r) || e.includes(o);
                this.element.removeAttribute("not-valid"),
                  this.element.style.setProperty("--gsc-color-swatch-value", c),
                  this.setSimilarlyBgColorStatus(l);
              } else {
                var u = e === r || e === o;
                a && this.element.removeAttribute("not-valid"),
                  this.setSimilarlyBgColorStatus(u),
                  this.element.style.setProperty("--gsc-color-swatch-value", e);
              }
            },
          },
          {
            key: "setSimilarlyBgColorStatus",
            value: function (e) {
              this.element.toggleAttribute(
                "section-background-color-equally",
                e
              );
            },
          },
          {
            key: "isColor",
            value: function (e) {
              var t = new Option().style;
              return (t.color = e), "" !== t.color;
            },
          },
          {
            key: "isImage",
            value: function (e) {
              return e.includes(".png") || e.includes(".jp");
            },
          },
          {
            key: "isUrl",
            value: function (e) {
              try {
                return new URL(e), !0;
              } catch (e) {
                return !1;
              }
            },
          },
          {
            key: "isGradient",
            value: function (e) {
              return e.includes("/");
            },
          },
        ]),
        n
      );
    })(ne),
    Br = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleMouseEnter", function () {
            var t = e.dataset.url,
              n = e.dataset.id;
            t && n && ha.requestProductFromUrl(t, n);
          }),
          a(p(e), "handleQuickViewBtnClick", function () {
            var t = e.dataset.url;
            t && ha.openAndRenderProductByUrl(t);
          }),
          (e.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e.quickViewBtn = e.querySelector(e.quickViewBtnSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
        ]),
        n
      );
    })(Qa),
    qr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleMouseEnter", function () {
            var t = e.dataset.url,
              n = e.dataset.id;
            t && n && ha.requestProductFromUrl(t, n);
          }),
          a(p(e), "handleQuickViewBtnClick", function () {
            var t = e.dataset.url;
            t && ha.openAndRenderProductByUrl(t);
          }),
          (e.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e.quickViewBtn = e.querySelector(e.quickViewBtnSelector)),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
        ]),
        n
      );
    })(Qa),
    Or = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        return m(this, n), t.apply(this, arguments);
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.loadProducts();
            },
          },
          {
            key: "loadProducts",
            value: function () {
              var e = this;
              return (
                this.setAttribute("is-loading", ""),
                fetch(this.dataset.url)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(function (t) {
                    var n = ge(t);
                    e._updateByHTML(n), e.removeAttribute("is-loading");
                  })
                  .catch(function () {
                    Nt.notification &&
                      Nt.notification.show(
                        "Error in product recommendations component",
                        "warning"
                      );
                  })
              );
            },
          },
          {
            key: "_updateByHTML",
            value: function (e) {
              var t = e.querySelector("#".concat(this.id));
              if (t) {
                var n = t.cloneNode(!0);
                this.replaceChildren.apply(this, L(n.childNodes)),
                  this.toggleAttribute("is-ready", this.hasChildNodes());
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Rr = Or,
    Nr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleDeleteButtonClick", function (e) {
            var t = e.currentTarget,
              n = t.getAttribute("data-confirm-message");
            confirm(n) &&
              (function (e, t) {
                var n = (t = t || {}).method || "post",
                  i = t.parameters || {},
                  a = document.createElement("form");
                for (var r in (a.setAttribute("method", n),
                a.setAttribute("action", e),
                i)) {
                  var o = document.createElement("input");
                  o.setAttribute("type", "hidden"),
                    o.setAttribute("name", r),
                    o.setAttribute("value", i[r]),
                    a.appendChild(o);
                }
                document.body.appendChild(a),
                  a.submit(),
                  document.body.removeChild(a);
              })(t.dataset.target, { parameters: { _method: "delete" } });
          }),
          (e.deleteButtons = e.querySelectorAll(
            "[data-addresses-delete-button]"
          )),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              this.deleteButtons.forEach(function (t) {
                t.addEventListener("click", e._handleDeleteButtonClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e = this;
              this.deleteButtons.forEach(function (t) {
                t.removeEventListener("click", e._handleDeleteButtonClick);
              });
            },
          },
        ]),
        n
      );
    })(ne),
    Fr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "_handleContentResize", function () {
            e.updateMaxHeight(e.isVisible);
          }),
          (e.content = e.querySelector("[data-tabs-element-content]")),
          (e._resizeObserver = new ResizeObserver(e._handleContentResize)),
          e.content && e._resizeObserver.observe(e.content),
          e
        );
      }
      return (
        g(
          n,
          [
            {
              key: "connectedCallback",
              value: function () {
                this.updateMaxHeight(this.isVisible);
              },
            },
            {
              key: "disconnectedCallback",
              value: function () {
                this._resizeObserver.disconnect();
              },
            },
            {
              key: "attributeChangedCallback",
              value: function (e, t, n) {
                this.updateMaxHeight(this.isVisible);
              },
            },
            {
              key: "show",
              value: function () {
                return this.setVisible(!0), V(0);
              },
            },
            {
              key: "hide",
              value: function () {
                return this.setVisible(!1), V(0);
              },
            },
            {
              key: "setVisible",
              value: function (e) {
                this.setAttribute("aria-hidden", e ? "false" : "true");
              },
            },
            {
              key: "updateMaxHeight",
              value: function (e) {
                if (this.content) {
                  var t = e ? this.content.offsetHeight : 0;
                  this.style.maxHeight = "".concat(t, "px");
                }
              },
            },
            {
              key: "isVisible",
              get: function () {
                return "false" === this.getAttribute("aria-hidden");
              },
            },
          ],
          [
            {
              key: "observedAttributes",
              get: function () {
                return ["aria-hidden"];
              },
            },
          ]
        ),
        n
      );
    })(ne),
    Vr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleClick", function (t) {
            if ("VIDEO" === t.target.tagName) {
              var n = t.target;
              e.hasAttribute("data-enable-controls") || e.videoToggle(n);
            }
          }),
          a(p(e), "handlePosterClick", function () {
            e.loadContent();
          }),
          (e.poster = e.querySelector("[data-video-banner-poster]")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.hasAttribute("data-enable-autoplay") && this.loadContent(),
                this.poster &&
                  this.poster.addEventListener("click", this.handlePosterClick),
                this.addEventListener("click", this.handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.poster &&
                this.poster.removeEventListener(
                  "click",
                  this.handlePosterClick
                ),
                this.removeEventListener("click", this.handleClick);
            },
          },
          {
            key: "videoToggle",
            value: function (e) {
              e.paused ? e.play() : e.pause();
            },
          },
          {
            key: "loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this.addVideo(), this.setAttribute("loaded", "true"));
            },
          },
          {
            key: "removeVideo",
            value: function () {
              var e = this.querySelector("video,  iframe");
              e && (e.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "addVideo",
            value: function () {
              var e = document.createElement("div"),
                t = this.querySelector("[data-video-banner-media-template]"),
                n = null == t ? void 0 : t.content,
                i = this.querySelector("[data-video-banner-container]");
              if (n && n.firstElementChild) {
                var a = n.firstElementChild.cloneNode(!0);
                e.appendChild(a);
                var r = e.querySelector("video, iframe");
                r &&
                  (this.poster && this.poster.remove(),
                  i.appendChild(r),
                  "VIDEO" === r.tagName && r.play());
              }
            },
          },
        ]),
        n
      );
    })(ne),
    zr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.apply(this, arguments))), "updateByHTML", function (t) {
            var n = t.querySelector("#".concat(e.id));
            if (n) {
              var i = null == n ? void 0 : n.cloneNode(!0);
              e.replaceChildren.apply(e, L(null == i ? void 0 : i.childNodes));
              var a = e.closest("cart-drawer-related-products-block"),
                r = e.querySelectorAll("vertical-product-card");
              e.setReady(r.length > 0), a.checkHasAsideProducts();
            }
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.loadProducts();
            },
          },
          {
            key: "erase",
            value: function () {
              this.replaceChildren(), this.setReady(!1);
            },
          },
          {
            key: "loadProducts",
            value: function () {
              var e = this;
              if (
                this.lastRequestedUrl !== this.dataset.url &&
                ((this.lastRequestedUrl = this.dataset.url), this.dataset.url)
              )
                return (
                  this.showPreloader(),
                  fetch(this.dataset.url)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(function (t) {
                      e.hidePreloader();
                      var n = ge(t).querySelector(
                          "[data-cart-drawer-template]"
                        ),
                        i = pe(n);
                      e.updateByHTML(i);
                    })
                    .catch(function () {
                      Nt.notification &&
                        Nt.notification.show(
                          "Error in cart drawer related products",
                          "warning"
                        );
                    })
                );
            },
          },
          {
            key: "setReady",
            value: function (e) {
              this.toggleAttribute("is-ready", e);
            },
          },
          {
            key: "showPreloader",
            value: function () {
              var e = this.querySelector(".loading-overlay");
              de(e);
            },
          },
          {
            key: "hidePreloader",
            value: function () {
              var e = this.querySelector(".loading-overlay");
              he(e);
            },
          },
        ]),
        n
      );
    })(ne),
    Hr = zr,
    Ur = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "handleCartDrawerFinishUpdate",
            function (t) {
              var n = t.node;
              e.updateByNode(n);
            }
          ),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleCartDrawerFinishUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-drawer-items-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Kr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "handleCartDrawerFinishUpdate",
            function (t) {
              var n = t.node;
              e.updateByNode(n);
            }
          ),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleCartDrawerFinishUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-drawer-in-cart-banner-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Wr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "handleCartDrawerFinishUpdate",
            function (t) {
              var n = t.node;
              e.updateByNode(n);
            }
          ),
          (e.relatedProducts = e.querySelector(
            "[data-cart-drawer-related-products]"
          )),
          (e.cartDrawer = e.closest("cart-drawer")),
          (e.isAutoRecommendations = e.hasAttribute("is-auto-recommendations")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.checkHasAsideProducts(),
                this.cartDrawer &&
                  this.cartDrawer.subscribe(
                    "update-nodes",
                    this.handleCartDrawerFinishUpdate
                  );
            },
          },
          {
            key: "checkHasAsideProducts",
            value: function () {
              if (this.hasAttribute("is-aside-related-products")) {
                var e = document.querySelectorAll(
                    "[is-aside-related-products] vertical-product-card"
                  ),
                  t = (null == e ? void 0 : e.length) > 0,
                  n = document.querySelector("cart-drawer");
                n && n.toggleAttribute("has-aside-products", t);
              }
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              if (this.relatedProducts) {
                var t = this.getAttribute("block-id"),
                  n = e.querySelector(
                    'cart-drawer-related-products-block[block-id="'.concat(
                      t,
                      '"] [data-cart-drawer-related-products]'
                    )
                  );
                if (n)
                  if (this.isAutoRecommendations) {
                    var i = n.getAttribute("data-url");
                    this.relatedProducts.setAttribute("data-url", i),
                      i
                        ? (this.relatedProducts.loadProducts(), de(this))
                        : (this.relatedProducts.erase(),
                          he(this),
                          this.checkHasAsideProducts());
                  } else {
                    var a,
                      r = n.cloneNode(!0);
                    (a = this.relatedProducts).replaceChildren.apply(
                      a,
                      L(r.childNodes)
                    ),
                      this.checkHasAsideProducts();
                  }
              }
            },
          },
        ]),
        n
      );
    })(ne),
    jr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "handleCartDrawerFinishUpdate",
            function (t) {
              var n = t.node;
              e.updateByNode(n);
            }
          ),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleCartDrawerFinishUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-drawer-timer-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Yr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "handleCartDrawerFinishUpdate",
            function (t) {
              var n = t.node;
              e.updateByNode(n);
            }
          ),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleCartDrawerFinishUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = e.querySelector("cart-drawer-header");
              if (t) {
                var n = t.cloneNode(!0);
                this.replaceChildren.apply(this, L(n.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Xr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(
            p((e = t.call(this))),
            "handleCartDrawerFinishUpdate",
            function (t) {
              var n = t.node;
              e.updateByNode(n);
            }
          ),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleCartDrawerFinishUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = e.querySelector("cart-drawer-footer");
              if (t) {
                var n = t.cloneNode(!0);
                this.replaceChildren.apply(this, L(n.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Qr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-items-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes)),
                  this.scrollIntoView({ behavior: "smooth" });
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Gr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleStartCartUpdate", function () {
            e.setLoading(!0);
          }),
          a(p(e), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n), e.setLoading(!1);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                (this.cart.subscribe(
                  "start-update",
                  this.handleStartCartUpdate
                ),
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                ));
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-buttons-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
          {
            key: "setLoading",
            value: function (e) {
              var t = this.querySelector("[data-cart-page-checkout-button]");
              t &&
                (t.toggleAttribute("disabled", e),
                t.classList.toggle("loading", e));
            },
          },
        ]),
        n
      );
    })(ne),
    Zr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-countdown-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    Jr = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleCartFinishUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.relatedProducts = e.querySelector("[data-cart-related-products]")),
          (e.cart = e.closest("cart-page")),
          (e.isAutoRecommendations = e.hasAttribute("is-auto-recommendations")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleCartFinishUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              if (this.relatedProducts) {
                var t = this.getAttribute("block-id"),
                  n = e.querySelector(
                    'cart-related-products-block[block-id="'.concat(
                      t,
                      '"] [data-cart-related-products]'
                    )
                  );
                if (n)
                  if (this.isAutoRecommendations) {
                    var i = n.getAttribute("data-url");
                    this.relatedProducts.setAttribute("data-url", i),
                      i
                        ? (this.relatedProducts.loadProducts(), de(this))
                        : (this.relatedProducts.erase(), he(this));
                  } else {
                    var a,
                      r = n.cloneNode(!0);
                    (a = this.relatedProducts).replaceChildren.apply(
                      a,
                      L(r.childNodes)
                    );
                  }
              }
            },
          },
        ]),
        n
      );
    })(ne),
    $r = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-order-notes-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    eo = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-app-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    to = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-in-cart-banner-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    no = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.getAttribute("block-id"),
                n = e.querySelector(
                  'cart-subtotal-block[block-id="'.concat(t, '"]')
                );
              if (n) {
                var i = n.cloneNode(!0);
                this.replaceChildren.apply(this, L(i.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    io = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = e.closest("cart-page")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.querySelector("free-shipping-bar"),
                n = e.querySelector("free-shipping-bar");
              if (t && n) {
                var i = n.dataset.cartTotal || 0;
                t.updateProgressByCartTotal(+i);
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ao = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleFinishCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cart = document.querySelector("cart-page")),
          (e.cartDrawer = document.querySelector("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cart &&
                this.cart.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                ),
                this.cartDrawer &&
                  this.cartDrawer.subscribe(
                    "update-nodes",
                    this.handleFinishCartUpdate
                  );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = e.querySelector("#NewCartCount");
              if (t) {
                var n = t.cloneNode(!0);
                this.replaceChildren.apply(this, L(n.childNodes));
              }
            },
          },
        ]),
        n
      );
    })(ne),
    ro = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleCartUpdate", function (t) {
            var n = t.node;
            e.updateByNode(n);
          }),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleCartUpdate
                );
            },
          },
          {
            key: "updateByNode",
            value: function (e) {
              var t = this.querySelector("free-shipping-bar"),
                n = e.querySelector("free-shipping-bar");
              if (t && n) {
                var i = n.dataset.cartTotal || 0;
                t.updateProgressByCartTotal(+i);
              }
            },
          },
        ]),
        n
      );
    })(ne),
    oo = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.call(this))), "handleStartCartUpdate", function () {
            e.setLoading(!0);
          }),
          a(p(e), "handleFinishCartUpdate", function () {
            e.setLoading(!1);
          }),
          (e.cartDrawer = e.closest("cart-drawer")),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.cartDrawer &&
                (this.cartDrawer.subscribe(
                  "start-update",
                  this.handleStartCartUpdate
                ),
                this.cartDrawer.subscribe(
                  "update-nodes",
                  this.handleFinishCartUpdate
                ));
            },
          },
          {
            key: "setLoading",
            value: function (e) {
              var t = this.querySelector("[data-cart-checkout-button]");
              t &&
                (t.toggleAttribute("disabled", e),
                t.classList.toggle("loading", e));
            },
          },
        ]),
        n
      );
    })(ne),
    so = (function (e) {
      "use strict";
      k(n, e);
      var t = M(n);
      function n() {
        var e;
        return (
          m(this, n),
          a(p((e = t.apply(this, arguments))), "updateByHTML", function (t) {
            var n = t.querySelector("#".concat(e.id));
            if (n) {
              var i = n.cloneNode(!0);
              e.replaceChildren.apply(e, L(i.childNodes));
            }
            var a = e.querySelectorAll("vertical-product-card");
            e.setReady(a.length > 0);
          }),
          e
        );
      }
      return (
        g(n, [
          {
            key: "connectedCallback",
            value: function () {
              this.loadProducts();
            },
          },
          {
            key: "erase",
            value: function () {
              this.replaceChildren(), this.setReady(!1);
            },
          },
          {
            key: "loadProducts",
            value: function () {
              var e = this;
              if (
                this.lastRequestedUrl !== this.dataset.url &&
                ((this.lastRequestedUrl = this.dataset.url), this.dataset.url)
              )
                return (
                  this.showPreloader(),
                  fetch(this.dataset.url)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(function (t) {
                      e.hidePreloader();
                      var n = ge(t);
                      e.updateByHTML(n);
                    })
                    .catch(function () {
                      Nt.notification &&
                        Nt.notification.show(
                          "Error in cart related products",
                          "warning"
                        );
                    })
                );
            },
          },
          {
            key: "setReady",
            value: function (e) {
              this.toggleAttribute("is-ready", e);
            },
          },
          {
            key: "showPreloader",
            value: function () {
              var e = this.querySelector(".loading-overlay");
              de(e);
            },
          },
          {
            key: "hidePreloader",
            value: function () {
              var e = this.querySelector(".loading-overlay");
              he(e);
            },
          },
        ]),
        n
      );
    })(ne),
    co = [
      { tag: "login-component", component: ie },
      { tag: "back-to-top-button", component: ae },
      { tag: "sticky-cart-button", component: re },
      { tag: "quantity-component", component: oe },
      { tag: "quantity-btn", component: se },
      { tag: "localization-selector", component: ce },
      { tag: "notification-component", component: le },
      { tag: "tabs-component", component: be },
      { tag: "tab-component", component: Cr },
      { tag: "list-component", component: _e },
      { tag: "list-btn", component: we },
      { tag: "float-element", component: Vt },
      { tag: "hotspots-float-element", component: $t },
      { tag: "float-element-btn", component: Qt },
      { tag: "dropdown-opener", component: en },
      { tag: "tooltip-trigger", component: nn },
      { tag: "accordeon-component", component: an },
      { tag: "accordeon-btn", component: on },
      { tag: "product-media-tabs", component: cn },
      { tag: "color-swatches", component: ln },
      { tag: "modal-component", component: un },
      { tag: "password-modal", component: dn },
      { tag: "cart-notification-popup", component: fn },
      { tag: "modal-opener", component: pn },
      { tag: "password-modal-opener", component: yn },
      { tag: "modal-close-btn", component: bn },
      { tag: "sidebar-button", component: _n },
      { tag: "sidebar-component", component: kn },
      { tag: "search-sidebar", component: Cn },
      { tag: "quick-view", component: Ln },
      { tag: "carousel-component", component: Fi },
      { tag: "carousel-play-button", component: Vi },
      { tag: "carousel-dots", component: zi },
      { tag: "carousel-dot", component: Hi },
      { tag: "carousel-btn", component: Ki },
      { tag: "carousel-progress", component: Wi },
      { tag: "header-component", component: ji },
      { tag: "drawer-menu", component: Yi },
      { tag: "drawer-menu-page", component: Xi },
      { tag: "drawer-menu-page-link", component: Gi },
      { tag: "pagination-component", component: Ji },
      { tag: "pagination-load-button", component: ea },
      { tag: "pagination-link", component: na },
      { tag: "pagination-infinite-scroll", component: ia },
      { tag: "deferred-media", component: aa },
      { tag: "pickup-availability", component: oa },
      { tag: "product-form", component: fa },
      { tag: "product-form-button", component: va },
      { tag: "product-block", component: pa },
      { tag: "product-model", component: ya },
      { tag: "cart-item", component: wa },
      { tag: "cart-page", component: Sa },
      { tag: "cart-drawer", component: Ca },
      { tag: "free-shipping-bar", component: xa },
      { tag: "product-media", component: Ia },
      { tag: "product-media-carousel", component: Aa },
      { tag: "variant-picker", component: Pa },
      { tag: "color-swatches-picker", component: Ma },
      { tag: "product-modal", component: qa },
      { tag: "product-modal-image-wrap", component: Oa },
      { tag: "product-modal-opener", component: Na },
      { tag: "product-recommendations", component: Fa },
      { tag: "product-related-block", component: Rr },
      { tag: "cart-drawer-related-products", component: Hr },
      { tag: "recently-viewed", component: En },
      { tag: "search-sidebar-form-wrapper", component: Ha },
      { tag: "cart-remove-button", component: Ka },
      { tag: "clipboard-button", component: ja },
      { tag: "clipboard-button-tooltip", component: Ya },
      { tag: "product-card", component: Ga },
      { tag: "horizontal-product-card", component: Br },
      { tag: "vertical-product-card", component: qr },
      { tag: "max-lines-component", component: Za },
      { tag: "country-selector", component: Ja },
      { tag: "search-field", component: $a },
      { tag: "password-field", component: er },
      { tag: "zoom-cursor", component: tr },
      { tag: "shop-component", component: nr },
      { tag: "shop-active-filters", component: ir },
      { tag: "sidebar-filters-desktop", component: or },
      { tag: "sidebar-filters-mobile", component: cr },
      { tag: "filter-remove-btn", component: ur },
      { tag: "sort-list", component: dr },
      { tag: "price-range", component: hr },
      { tag: "column-switcher", component: fr },
      { tag: "filters-submit-btn", component: pr },
      { tag: "before-after-images", component: mr },
      { tag: "countdown-timer", component: wr },
      { tag: "product-information-drawer", component: Sr },
      { tag: "sidebar-filters-sticky-mobile-button", component: Er },
      { tag: "recipient-form", component: xr },
      { tag: "collection-card", component: Ir },
      { tag: "article-card", component: Ar },
      { tag: "shape-swatch", component: Mr },
      { tag: "addresses-component", component: Nr },
      { tag: "tab-with-dynamic-height", component: Fr },
      { tag: "video-banner", component: Vr },
      { tag: "cart-drawer-items-block", component: Ur },
      { tag: "cart-drawer-in-cart-banner-block", component: Kr },
      { tag: "cart-drawer-related-products-block", component: Wr },
      { tag: "cart-drawer-timer-block", component: jr },
      { tag: "cart-drawer-header", component: Yr },
      { tag: "cart-drawer-footer", component: Xr },
      { tag: "cart-items-block", component: Qr },
      { tag: "cart-buttons-block", component: Gr },
      { tag: "cart-countdown-block", component: Zr },
      { tag: "cart-related-products-block", component: Jr },
      { tag: "cart-order-notes-block", component: $r },
      { tag: "cart-app-block", component: eo },
      { tag: "cart-subtotal-block", component: no },
      { tag: "cart-in-cart-banner-block", component: to },
      { tag: "cart-free-shipping-bar-block", component: io },
      { tag: "cart-count", component: ao },
      { tag: "cart-drawer-free-shipping-bar-block", component: ro },
      { tag: "cart-drawer-buttons-block", component: oo },
      { tag: "cart-related-products", component: so },
      {
        tag: "share-wrapper",
        component: (function (e) {
          "use strict";
          k(n, e);
          var t = M(n);
          function n() {
            var e;
            return (
              m(this, n),
              ((e = t.call(this)).customTemplate = e.querySelector(
                "[data-share-custom-template]"
              )),
              (e.systemDefaultTemplate = e.querySelector(
                "[data-share-system-default-template]"
              )),
              e
            );
          }
          return (
            g(n, [
              {
                key: "connectedCallback",
                value: function () {
                  this.init();
                },
              },
              {
                key: "init",
                value: function () {
                  var e = navigator.share
                      ? this.systemDefaultTemplate
                      : this.customTemplate,
                    t = ve(e);
                  this.appendChild(t);
                },
              },
            ]),
            n
          );
        })(ne),
      },
      {
        tag: "share-component",
        component: (function (e) {
          "use strict";
          k(n, e);
          var t = M(n);
          function n() {
            var e;
            return (
              m(this, n),
              a(p((e = t.call(this))), "handleButtonClick", function (t) {
                t.preventDefault(),
                  navigator.share &&
                    navigator.share({ text: e.dataset.valueToCopy });
              }),
              (e.button = e.querySelector("[data-share-button]")),
              e
            );
          }
          return (
            g(n, [
              {
                key: "connectedCallback",
                value: function () {
                  this.button &&
                    this.button.addEventListener(
                      "click",
                      this.handleButtonClick
                    );
                },
              },
              {
                key: "disconnectedCallback",
                value: function () {
                  this.button &&
                    this.button.removeEventListener(
                      "click",
                      this.handleButtonClick
                    );
                },
              },
            ]),
            n
          );
        })(ne),
      },
      {
        tag: "scrolling-text",
        component: (function (e) {
          "use strict";
          k(n, e);
          var t = M(n);
          function n() {
            var e;

            // Storyside this is where scrolling-text is set
            // console.log("Storyside scrolling-text", e, this);
            
            return (
              m(this, n),
              a(p((e = t.call(this))), "calcHeight", function () {
                e.paddings =
                  parseInt(e.styles.paddingTop) +
                  parseInt(e.styles.paddingBottom);
                var t,
                  n = e.querySelectorAll(e.lineSelector),
                  i = n[0].getBoundingClientRect();
                if (n.length > 1) {
                  var a = [],
                    r = [],
                    o = n[n.length - 1].getBoundingClientRect();
                  a.push(i.top),
                    a.push(o.top),
                    r.push(i.bottom),
                    r.push(o.bottom),
                    (t =
                      r.sort(function (e, t) {
                        return t - e;
                      })[0] -
                      a.sort(function (e, t) {
                        return e - t;
                      })[0]);
                } else t = i.height;
                return t;
              }),
              a(p(e), "setHeight", function () {
                var t = e.calcHeight();
                e.style.setProperty("--gsc-section-height", "".concat(t, "px"));
              }),
              a(
                p(e),
                "handleResize",
                (0, Oi.debounce)(function () {
                  e.setHeight();
                }, 100)
              ),
              (e.containerSelector = "[data-scrolling-text-container]"),
              (e.lineSelector = "scrolling-text-line"),
              (e.container = e.querySelector(e.containerSelector)),
              (e.resizeObserver = new ResizeObserver(e.handleResize)),
              e.resizeObserver.observe(e.container),
              (e.styles = getComputedStyle(e.container)),
              e
            );
          }
          return (
            g(n, [
              {
                key: "disconnectedCallback",
                value: function () {
                  this.resizeObserver.disconnect();
                },
              },
            ]),
            n
          );
        })(ne),
      },
      {
        tag: "scrolling-text-line",
        component: (function (e) {
          "use strict";
          k(n, e);
          var t = M(n);
          function n() {
            var e;
            return (
              m(this, n),
              a(p((e = t.call(this))), "getDimentions", function () {
                var t = e.querySelector(e.announcementSelector);
                if (t) {
                  var n = document.body.clientWidth,
                    i = t.clientWidth;

                  // Storyside checking return length
                  // console.log('Storyside scrolling-text-line getDimentions', (e.initialScreenWidth = n), { screenWidth: n, announcementWidth: i });  

                  return (
                    (e.initialScreenWidth = n),
                    { screenWidth: n, announcementWidth: i }
                  );
                }
              }),
              a(p(e), "calcQuantityToRender", function (t, n) {
                return Math.round((t * e.screenSizeMultiply) / n);
              }),
              a(p(e), "renderNodes", function (t) {
                var n = e.querySelector(e.announcementSelector);
                if (n) {
                  for (
                    var i = document.createDocumentFragment(), a = 0;
                    a < t;
                    a++
                  ) {
                    var r = n.cloneNode(!0);
                    r.classList.add(e.animationClass), i.appendChild(r);
                  }
                  n.classList.add(e.animationClass), e.appendChild(i);
                }
              }),
              a(
                p(e),
                "handleResize",
                (0, Oi.debounce)(function () {

                  // Storyside check when handleResize is called
                  // console.log("Storyside scrolling-text-line handleResize - this is where you could run it when screen shrinks as well as grows");

                  document.body.clientWidth > e.initialScreenWidth &&
                    e.render(),
                    e.setAttribute("data-is-rendered", "true");
                }, 100)
              ),
              a(p(e), "render", function () {



                var t = e.getDimentions(),
                  n = t.screenWidth,
                  i = t.announcementWidth,
                  a = e.calcQuantityToRender(n, i);

                // Storyside see if it is calculating infinity if an announcement width is 0
                // add if isFinite around e.renderNodes(a); if remove, keep e.renderNodes(a);
                // console.log("Storyside scrolling-text-line render BIG FIX", n, i, a);
              
                if (isFinite(a) && a < 1000) {
                  // console.log('Storyside scrolling-text-line a was finite and < 1000');
                  e.renderNodes(a);
                } else {
                  // console.log('Storyside scrolling-text-line a was Infinity or > 1000');
                }
              }),
              (e.initialScreenWidth = 0),
              (e.screenSizeMultiply = 2),
              (e.announcementSelector = "[data-scrolling-text-line]"),
              (e.animationClass = "scrolling-text--animated"),
              (e.resizeObserver = new ResizeObserver(e.handleResize)),
              e.resizeObserver.observe(document.body),
              e
            );
          }
          return (
            g(n, [
              {
                key: "disconnectedCallback",
                value: function () {
                  this.resizeObserver.disconnect();
                },
              },
            ]),
            n
          );
        })(ne),
      },
      { tag: "hotspots-component", component: yr },
    ];
  window.recentlyViewed = En;
  co.forEach(function (e) {
    var t = e.tag,
      n = e.component;
    customElements.define(t, n);
  }),
    (window.bodyElement = Nt),
    (window.auroraTheme = o(r({}, window.auroraTheme), {
      theme_version: "2.0.1",
      id: window.Shopify.theme.id,
      storeId: window.Shopify.theme.theme_store_id,
      isLicenseTheme: !!window.Shopify.theme.theme_store_id,
    })),
    window.addEventListener("shopify:section:load", function () {
      v({ lazyClass: "yall-video-lazy", threshold: 0 });
    }),
    window.addEventListener("load", function () {
      v({ lazyClass: "yall-video-lazy", threshold: 0 });
    });
})();
